<!--创建/编辑活动-->
<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import appConfig from "@/app.config";
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";
import {
  getCreateList,
  getVideoPathToken,
  getVideoPathUrl,
  isFollowWechat,
  updateActivitySignList,
  getActivityCode,
  getUserUrl
} from "@/utils/api/activity";
import {
  activityDetail,
  clockPresetsAdd,
  clockPresetsDel,
  clockPresetsDetail,
  clockPresetsList,
  clockPresetsUpdate,
  getCoverimgTemplate,
  getProjectManageAdmin,
  getSignList,
  isUpdateSignList,
  updateActivity,
  updateSignList,
} from "@/utils/api/build";
import { imageUrl } from "@/utils/config/commonUrl.js";
import serverConfig from "@/utils/config/index.js";
import router from "../../../router";
import Layout from "../../layouts/main";
const gzhQrcodeImg = require("@/assets/images/gzh_qrcode.jpg");
const GZH_DIALOG_LIMIT_KEY = "jl_create_activity_gzh_dialog_show_times";
const GZH_DIALOG_MAX_SHOW = 2;

var dayjs = require("dayjs");

import systemPictures from "@/components/systemPictures/systemPictures.vue";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import PosPermissionSelector from "./component/PosPermissionSelector.vue";
import WaterMarkSwitch from "./component/WaterMarkSwitch.vue";

export default {
  page() {
    return {
      title: "创建接龙",
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: {
    Layout,
    PosPermissionSelector,
    WaterMarkSwitch,
    systemPictures,
    CustomDialogHeader,
  },
  data() {
    return {
      appid: copyrightConfig.AppID,
      title: "Basic Tables",
      items: [
        {
          text: "Tables",
          href: "/",
        },
        {
          text: "Basic",
          active: true,
        },
      ],
      drawer: true,
      direction: "rtl",
      generalCheckTimesArr: [
        {
          value: 0,
          label: "不限制",
        },
        {
          value: 1,
          label: "1次",
        },
        {
          value: 2,
          label: "2次",
        },
        {
          value: 3,
          label: "3次",
        },
        {
          value: 4,
          label: "4次",
        },
        {
          value: 5,
          label: "5次",
        },
        {
          value: 6,
          label: "6次",
        },
        {
          value: 7,
          label: "7次",
        },
        {
          value: 8,
          label: "8次",
        },
        {
          value: 9,
          label: "9次",
        },
        {
          value: 10,
          label: "10次",
        },
        {
          value: 11,
          label: "11次",
        },
        {
          value: 12,
          label: "12次",
        },
        {
          value: 13,
          label: "13次",
        },
        {
          value: 14,
          label: "14次",
        },
        {
          value: 15,
          label: "15次",
        },
        {
          value: 16,
          label: "16次",
        },
        {
          value: 17,
          label: "17次",
        },
        {
          value: 18,
          label: "18次",
        },
        {
          value: 19,
          label: "19次",
        },
        {
          value: 20,
          label: "20次",
        },
      ],
      enablePushArr:
				[
					{
						label: "接受消息通知",
						value: 1,
					},
					{
						label: "不接收任何消息通知",
						value: 2,
					},
				],

      value: "",
      checked: true,
      value1: "",
      input: "",
      radio: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      gzhDialogVisible: false,
      wechatFollowStatus: null,
      gzhDialogPromiseResolver: null,
      gzhQrcodeSrc: gzhQrcodeImg,
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/qualifty/100",
        },
        {
          name: "food2.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      value2: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      candidateList: [], // 选中的周几
      value3: "",

      map: null,
      point: null,
      markerPoint: {
        address: "",
      },
      location: { lng: 116.403963, lat: 39.915119 }, // 地图中心点
      zoom: 19, // 地图缩放级别
      markLocation: {
        // 标记点的经纬度
        lng: 116.403963,
        lat: 39.915119,
      },
      form: {
        address: "", // 详细地址
        addrPoint: {
          // 详细地址经纬度
          lng: 0,
          lat: 0,
        },
      },
      mk: "", // Marker实例
      value4: "",

      addressDialog: false,
      addressIdx: null,

      poiname: "", //地址名称
      longitude: "", //纬度
      latitude: "", //经度

      // -----------------------------------------------------------------------------
      // 基础设置
      isType: "106", //创建活动的类型
      groupId: "", //群组id
      // 详细信息
      activityDetail: {
        name: "",
        content: "",
        generalCheckTimes: 1, // 高级设置每人可接龙次数
      },
      modularList: [], // 模块列表
      modular1: [], // 模块列表
      indexIdx: 0,
      commonDisabled: false, // 是否可以编辑
      formDrawerShow: false,
      actStartAndEndTime: "",
      // 表单项 类别
      formList: [
        {
          label: "姓名",
          type: 0,
        },
        {
          label: "手机号",
          type: 1,
        },
        {
          label: "数量",
          type: 2,
        },
        {
          label: "文件",
          type: 25,
        },
        {
          label: "签名",
          type: 24,
        },
        // {
        //     label: '水印拍照',
        //     type: 23,
        // },
        {
          label: "日期/时间",
          type: 3,
        },
        {
          label: "图片",
          type: 4,
        },
        {
          label: "身份证",
          type: 5,
        },
        // {
        //     label: '时间',
        //     type: 6,
        // },
        {
          label: "定位",
          type: 7,
        },
        {
          label: "省/市/区",
          type: 8,
        },
        {
          label: "性别",
          type: 9,
        },
        {
          label: "音频",
          type: 12,
        },
        {
          label: "视频",
          type: 13,
        },
        {
          label: "邮箱",
          type: 14,
        },
        {
          label: "学校",
          type: 15,
        },
        {
          label: "院系",
          type: 16,
        },
        {
          label: "工号",
          type: 17,
        },
        {
          label: "学号",
          type: 18,
        },
        {
          label: "公司",
          type: 19,
        },
        {
          label: "职位",
          type: 20,
        },
        {
          label: "部门",
          type: 21,
        },
        // {
        //     label: '单位',
        //     type: 22,
        // },
        {
          label: "时间区间",
          type: 31,
        },
      ],
      // 报名字段
      listList: [
        {
          signListName: "",
          ifDel: 2,
          addTime: "",
          signField: [],
        },
      ],

      storgeName: [],
      // ---------------------------------------------------------------------------------
      // 打卡内容
      formClock: {
        clockFrequencyName: "每天", //打卡要求
        clockRemindStatus: 1, //打卡提醒开关 1 开 2关
        remindTime: "10:00", //打卡提醒时间
        beginTime: "00:00", //打卡开始时间
        endTime: "23:59", //打卡结束时间
        clockSupplyStatus: 1, //补卡开关  1 开 2关
        supplyTimes: "-1", //补卡次数
        clockLocationStatus: 2, //是否指定打卡地点 1 开 2关
        clockRange: 1000, //打卡范围
        clockFrequency: "0,1,2,3,4,5,6", //打卡要求 周、每天
        // 新加的 有用的
        clockLocationInfo: "", //打卡地点信息
        clockFrequencyType: "3", // 打卡频率类型！！！！！
        clockMaxNum: 1, // 每周、每月打卡 最大次数
        clockMaxSwitch: 2, // 每周、每月最大值开关
        dayOfDate: "", // 每周、每月打卡截止—周几或几号，根据clockFrequencyType变化（周几 存的是 0、1、2、3、4、5、6   月：几号就是几，不变）
        timeOfDay: "", // 每周、每月打卡截止—时分秒
        multiPeriodSwitch: 2, // 多时段打卡开关
        clockInTimeSlot: [
          {
            startTime: "00:00",
            endTime: "23:59",
            ifDel: 2, // 删除是1，未删除是2
            randomDecimal: Date.now(),
          },
        ],
        customDate: "", // 自定义日期 逗号拼接的
        clockSupplyType: -1, //补卡频率类型 0 总共  1=每月｜2=每周｜3=每天 | -1 不限制次数
        checkSwitch: 1, // 允许一天内多次打卡 1关 2开
        checkTimes: 1, // 每天打卡次数
      },
      clockFrequencyName: "",
      markers: {},
      range: "1",
      address: "",
      clockRange: 1000,
      selectData: "每天",
      starttime: "00:00",
      endtime: "23:59",
      show: false,
      show2: false,
      color: "#1877FF",
      candidates: [
        { name: "星期一", value: "0", checked: false },
        { name: "星期二", value: "1", checked: false },
        { name: "星期三", value: "2", checked: false },
        { name: "星期四", value: "3", checked: false },
        { name: "星期五", value: "4", checked: false },
        { name: "星期六", value: "5", checked: false },
        { name: "星期日", value: "6", checked: false },
      ],

      columns3: [
        ["1000米以内", "500米以内", "200米以内", "100米以内", "50米以内"],
      ],
      dakaColumnsArr: [
        {
          label: "1000米以内",
          value: 1000,
        },
        {
          label: "500米以内",
          value: 500,
        },
        {
          label: "200米以内",
          value: 200,
        },
        {
          label: "100米以内",
          value: 100,
        },
      ],
      clockRangeList: [
        {
          name: "不限制次数",
          value: -1,
        },
        {
          name: "「总共」可补卡次数",
          value: 0,
        },
        {
          name: "「每天」可补卡次数",
          value: 3,
        },
        {
          name: "「每周」可补卡次数",
          value: 2,
        },
        {
          name: "「每月」可补卡次数",
          value: 1,
        },
      ],
      disbandBox: false,
      city: "",
      current: 0,
      selectFrequency: 3, // 频率类型 1=每月｜2=每周｜3=每天｜4=法定工作日｜5=法定节假日｜6=自定义周几打卡｜7=自定义日期打卡 | 8=一次性打卡
      lastDayOfMonth: "",
      weekChineseNumbers: ["一", "二", "三", "四", "五", "六", "日"],
      endMonthShow: false,
      endMonthArr: [[], [], []],
      endMonthArr1: [],
      endMonthArr2: [],
      endMonthArr3: [],
      endMonthValue: "",
      endWeekShow: false,
      endWeekArr: [["一", "二", "三", "四", "五", "六", "日"], [], []],
      endWeekArr1: [
        {
          label: "周一",
          value: 0,
        },
        {
          label: "周二",
          value: 1,
        },
        {
          label: "周三",
          value: 2,
        },
        {
          label: "周四",
          value: 3,
        },
        {
          label: "周五",
          value: 4,
        },
        {
          label: "周六",
          value: 5,
        },
        {
          label: "周日",
          value: 6,
        },
      ],
      endWeekArr2: [],
      endWeekArr3: [],

      endWeekValue: "",
      modeRili: "multiple",
      cusRilishow: false,
      customDateArr: [],
      // 打卡频率
      CheckInFrequency: [
        {
          label: "每月",
          value: 1,
        },
        {
          label: "每周",
          value: 2,
        },
        {
          label: "每天",
          value: 3,
        },
        {
          label: "法定工作日",
          value: 4,
        },
        {
          label: "法定节假日",
          value: 5,
        },
        {
          label: "自定义周几打卡",
          value: 6,
        },
        {
          label: "自定义日期打卡",
          value: 7,
        },
        {
          label: "一次性打卡",
          value: 8,
        },
      ],
      monthDay: 0,
      monthHour: 0,
      monthMinute: 0,
      weekDay: 1,
      weekHour: 1,
      weekMinute: 0,
      // 时间段
      timeSlotArr: ["00:00", "23:59"],
      selectedFile: null,
      modulCommonIndex: 0,
      imageUrl: imageUrl,
      modularDelIds: [],
      // 查看活动类型
      selectType: "add", //add
      delListInfo: [],
      activityId: "2",
      previewImgSrc: "", // 图片路径
      previewImgShow: false,
      isModular: false,
      addMapType: 1, // 2-模块 3-设置 1-打卡 4-签到
      imageUploadLimit: 9,
      imgUpMoveSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png",
      imgDownMoveSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png",
      imgCancelSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png",

      // 高级设置
      shareStatus: "",
      commentStatus: 2,
      confirmWord: "参加接龙",
      select_type: "",
      activityType: 0,
      isanonymous: 1,
      publisher: localStorage.getItem("jlnickname"),
      remindtime: "00:00",
      edit_publisher: "",
      columns1: [["不允许修改", "自定义修改时间", "接龙终止前"]],
      // 允许修改报名信息
      updateSignInfo: 3, // 是否允许修改 1、活动结束前可以  2、不可以取消 3、时间段内可以
      updateSignArr: [
        {
          label: "不允许修改",
          value: 1,
        },
        {
          label: "自定义修改时间",
          value: 2,
        },
        {
          label: "接龙终止前",
          value: 3,
        },
      ],
      columns1Show: false,
      columns2: [["不允许删除", "自定义删除时间", "接龙终止前"]],
      removeSignStatus: 4,
      cancellation: [["活动终止前", "不可取消", "自定义", "允许取消"]],
      cancellationArr: [
        {
          label: "活动终止前",
          value: 1,
        },
        {
          label: "不可取消",
          value: 2,
        },
        {
          label: "自定义",
          value: 3,
        },
        {
          label: "允许取消",
          value: 4,
        },
      ],
      columns2Show: false,
      anonymousparticipation: 0,

      submitcopy: "参加接龙",
      edit_submit_btn: "",
      edit_partin_btn: "",
      is_notice: 0, // 接龙通知
      is_forward: 0, //转发
      is_remind: 0, //接龙提醒
      cancelTitle: "接龙终止前",
      endregistrationtime: null,
      registrationtime: null,
      zdyTimes: false,
      zdyTimesEnd: false,
      zdyDelTimes: false,
      zdyDelTimesEnd: false,
      enddeletingtime: null,
      startdeletingtime: null,
      delSignTitle: "不允许删除",
      deleteregistration: 1, //是否允许删除报名信息1不允许 ，2自定义，3活动结束前
      is_signUpSet: false, //报名信息设置
      is_destination: 0,
      deliveryaddress: "",
      newSeniorSetInfo: {},
      informationswitch: false, //报名信息设置开关
      custombutton: false, //自定义按钮设置开关
      addresscolumns: [
        [
          "2000米以内",
          "1500米以内",
          "1000米以内",
          "500米以内",
          "200米以内",
          "100米以内",
        ],
      ], //打卡范围 数组
      addresscolumnsArr: [
        {
          label: "2000米以内",
          value: 2000,
        },
        {
          label: "1500米以内",
          value: 1500,
        },
        {
          label: "1000米以内",
          value: 1000,
        },
        {
          label: "500米以内",
          value: 500,
        },
        {
          label: "200米以内",
          value: 200,
        },
        {
          label: "100米以内",
          value: 100,
        },
      ],
      addressShow: false,
      clockRange1: "", //打卡范围
      checkinrange: "", //打卡范围
      specifyaddress: "", //
      ifcopy: false, //是否为复制活动
      chatSwitch: 1, //聊天开关
      thumbs_up: 1, //点赞
      is_comment: 1, //点评
      is_score: 1, //评分
      isMessage: 1, // 评论
      signInfoStatus: 1, //报名信息展示
      isContentFocus: true,
      isInputContentFocus: false,
      isFocus: false,
      modelContentFocus: false,
      modelContentbind: true,
      ishandleFocus: false,
      is_template: "0", // 1-模板 0-不是模板是活动
      valueId: null, //点击输入框索引
      valueId2: null,
      valueId3: null,
      valueId4: null,
      valueId5: null,
      valueId6: null,
      valueId7: null,
      valueId8: null,
      selected1: false,
      selected2: false,
      valueindex: null,
      valueindex1: null,
      selectedItem: null,
      copyStatus: 2, // 是否运行他们复制
      ctStartAndEndTime: "",
      deadline: "",
      deadCancelline: "",
      interdict_people_num: 0, // 人数限制

      seniorShow: false,
      openNameListDrawer: false,
      nameShowContent: "",
      people_num: 0,
      importVisible: false,
      nameListDrawer: false,
      addNameListDrawer: false,
      customizeDrawer: false,
      clockInList: [], // 预存名单
      presetsList: [], // 名单管理列表
      clockShowPresetTitle: "",
      clockShowPresetContent: "",
      nameId: "",
      people_num2: "",
      copywriting: "",
      copyimage: "",
      copyShowWriting: "",
      copyShowImage: "",
      is_draft: 0, // 是否是草稿，0不是 1是草稿
      isrepeatClick: false, //防止连续点击创建
      showName: "列表接龙",
      baseurl: "",
      multipleActivitiesStatus: 1, //是否允许参加多项活动 1、允许参加多项活动  2、不允许参加多项活动
      routeParameter: "", // 链接参数
      pageType: "",
      imgInfo: [],
      isOtherPeople: "", // 1=创建者、2=管理员、3=普通用户
      loadingShow: {},
      activeBuildTitle: "通用接龙",
      musicLink: "",
      musicDialog: false,
      fileIframeShow: false,
      fileUrl: "",
      relatedList: [],
      selectedItems: [],
      totalRow: 0,
      pages: 0,
      pageNum: 1,
      relatedDrawerShow: false,
      propertySetShow: false,
      // 格式验证
      validateArr: [
        "不限格式",
        "仅中文",
        "仅英文",
        "仅数字",
        "英文+数字",
        "中文+数字",
        "中文+英文",
        "身份证号",
        "手机号",
        "座机号",
        "邮箱",
        "网址",
      ],
      validateIndex: 0,
      commValue: "",
      commType: "",
      commIndex: "",
      checkboxList1: [
        {
          name: "必填",
          checked: false,
        },
        {
          name: "公开",
          checked: false,
        },
      ],
      checkboxValue1: [],
      commonImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/",
      dateSetList: [
        {
          type: 0,
          value: "09:00 ~ 10:00",
          checked: false,
        },
        {
          type: 1,
          value: "2024-12 ~ 2025-01",
          checked: false,
        },
        {
          type: 2,
          value: "2024-12-12 ~ 2025-01-01",
          checked: false,
        },
        {
          type: 3,
          value: "2024-02-02 09:00 ~ 2024-08-02 19:00",
          checked: false,
        },
      ],
      timeSetList: [
        {
          type: 0,
          value: "23:59:59",
          checked: false,
        },
        {
          type: 1,
          value: "2024-05",
          checked: false,
        },
        {
          type: 2,
          value: "2024-05-01",
          checked: false,
        },
        {
          type: 3,
          value: "2024-05-01 23:59:59",
          checked: false,
        },
      ],
      areaSetList: [
        {
          type: 0,
          value: "省",
          checked: false,
        },
        {
          type: 1,
          value: "省/市",
          checked: false,
        },
        {
          type: 2,
          value: "省/市/区",
          checked: false,
        },
        {
          type: 3,
          value: "省/市/区/详细地址",
          checked: false,
        },
      ],
      displayStyleArr: [
        {
          value: 1,
          label: "列表式",
        },
        {
          value: 2,
          label: "下拉式",
        },
      ],
      wenHaoImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-build-wenhao.svg",
      propertyData: {},
      selectOptionList: [
        {
          name: "拍摄照片",
        },
        {
          name: "从相册选取",
        },
        {
          name: "从微信聊天中选取",
        },
      ],
      selectOptionShow: false,
      showOptionList: [
        {
          name: "列表式",
        },
        {
          name: "下拉式",
        },
      ],
      showOptionShow: false,
      optionName: "列表式",
      imgNumShow: false,
      imgNumArr: [[1, 2, 3, 4, 5, 6, 7, 8, 9]],
      lineCopywriting: "",
      maxShow: false,
      maxValueArr: [
        {
          value: 0,
          label: "不限",
        },
        {
          value: 1,
          label: "1",
        },
      ],
      minShow: false,
      minValueArr: [
        {
          value: 0,
          label: "不限",
        },
        {
          value: 1,
          label: "1",
        },
      ],
      studyContent: "",
      modelContentDel: false,
      placeholderContent: "",
      tipsPH: "请输入提示内容或说明（选填）",
      tipsContent: "",
      taShow: false,
      scrollHandler: "",
      isLoading: false,
      imageUploadNumArr: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      batchOptionShow: false,
      isInFolder: 1, // 是否在文件夹内 默认 1 否 2 是
      folderId: "", // 文件夹ID
      nameAddOptions: [
        {
          name: "设定姓名",
        },
        {
          name: "设定分组",
        },
      ],
      nameAddOptionsShow: false,
      nameAddType: 1, // 1姓名还是2分组
      subsetShow: false,
      // 分组弹框中间值
      subsetCenterValueArr: [],
      subsetValueArr: [], // 给后台的值
      filteredArr: [], // 过滤用
      commFzInfo: {},
      commFzIndex: 0,
      fzPopItemInfo: {}, // 弹框中间值
      fzTitle: "", // 弹框中间值
      fzValue: "", // 弹框中间值
      fzNameArr: [],
      packetData: [], // 展示再页面的分组数据
      pickerName: "全部",
      pickerNameSelectShow: false,
      pickerNameSelectArr: [], // 中间值
      pickerNameSelect: 0,
      nameListLength: 0, // 名单人数
      tableData: [
        { name: "张三", studentId: "" },
        { name: "李四", studentId: "" },
        { name: "王五", studentId: "" },
      ],
      showModal: false,
      placeholderText1: "",
      isAi: "0",
      clockNameNumberSwitch: "1", //是否开启学号/编号 1开启 2关闭
      editImgSrc: "https://ossfastmake.mustke.com/12jielong/lsyJL/edit.svg",
      subtractFzImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/subtractFz.png",
      addFzImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/addFz.png",
      handleSubShow: false,
      downloadBoxShow: false,
      beginTime: "",
      foreverValidChecked: true,
      clockSupplyText: "不限制次数",
      clockSupplyShow: false,
      clockSupplyCenterText: "",
      supplyTxt: "",
      isDelSignInfoPop: false,
      isDelOrder: "",
      signFieldClone: [],
      resultList: [],
      rateType: "", // 打卡频率
      showRanking: 2, // 排行榜 1关2开
      // 字段类型配置映射
      fieldTypeMap: {
        0: { type: 1, fieldName: "姓名", num: 3 },
        1: { type: 11, fieldName: "手机号" },
        2: { type: 13, fieldName: "数量" },
        3: { type: 3, fieldName: "日期" },
        4: {
          type: 5,
          fieldName: "请上传图片",
          watermarkSwitch: "0",
          watermarkTimeOrPosition: "",
          annotationPermission:null,
        },
        5: { type: 10, fieldName: "身份证" },
        6: { type: 15, fieldName: "时间" },
        7: { type: 12, fieldName: "你所在的位置", posPermissions: 1 },
        8: { type: 8, fieldName: "请选择省市区" },
        9: {
          type: 2,
          fieldName: "性别",
          num: 2,
          content: [{ value: "男", maxNum: -1 }, { value: "女", maxNum: -1 }],
        },
        10: { type: 14, fieldName: "请上传健康码", num: 7 },
        11: { type: 14, fieldName: "请上传行程码", num: 8 },
        12: { type: 7, fieldName: "请填写音频标题" },
        13: { type: 6, fieldName: "请填写视频标题" },
        14: { type: 19, fieldName: "邮箱", placeholder: "邮箱" },
        15: { type: 21, fieldName: "学校", placeholder: "学校" },
        16: { type: 22, fieldName: "院系", placeholder: "院系" },
        17: { type: 23, fieldName: "工号", placeholder: "工号" },
        18: { type: 24, fieldName: "学号", placeholder: "学号" },
        19: { type: 25, fieldName: "公司", placeholder: "公司" },
        20: { type: 26, fieldName: "职位", placeholder: "职位" },
        21: { type: 27, fieldName: "部门", placeholder: "部门" },
        22: { type: 28, fieldName: "单位", placeholder: "单位" },
        23: {
          type: 20,
          fieldName: "水印拍照",
          placeholder: "水印拍照",
          watermarkImageUrl: "",
        },
        24: {
          type: 29,
          fieldName: "签名",
          placeholder: "签名",
          value: "",
          watermarkImageUrl: "",
        },
        25: {
          type: 32,
          fieldName: "文件",
          placeholder: "文件",
          value: "",
          watermarkImageUrl: "",
        },
        31: {
          type: 31,
          fieldName: "时间区间",
          placeholder: "时间区间",
          value: "",
          watermarkImageUrl: "",
        },
        // 特殊类型
        "-99": { type: 1, fieldName: "", num: 4 }, // AI使用
        "-1": { type: 1, fieldName: "", num: 4 }, // 单行文本
        "-2": {
          type: 2,
          fieldName: "单选",
          num: 1,
          content: [{ value: "", maxNum: -1 }],
        },
        "-3": {
          type: 4,
          fieldName: "多选",
          isChoose: 2,
          isChooseNum: 0,
          content: [{ value: "", maxNum: -1 }],
        },
        "-4": { type: 9, fieldName: "" }, // 多行文本
      },
      nameOrGroup: 0, // 0不启用 1姓名还是2分组
      onlyNameArr: [],
      onlyGroupArr: [],
      kfShow: true,
      // 图片裁剪
      dialogVisibleCro: false,
      // 裁剪配置
      option: {
        img: "https://ossfastmake.mustke.com/12xtPictures/xt-1.png", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 400, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [5, 4], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        
      },
      // 防止重复提交
      loading: false,
      // 裁剪过后的图片
      imgUrl: "",

      activityMode: 1, // 1 报名模式 2接龙模式 默认 1
      uploadPicsType: 1, // 1-模块 2-封面 3-分享图设置
      activityModeUrl: "https://ossfastmake.mustke.com/12xtPictures/xt-1.png", // 封面图
      maxImgCount: 9, // 上传图片最大数量
      batchPlayerImage: [],
      shareImgPopShow: false,
      shareImageStyle: 1,
      shareImgWord: "系统分享图",
      uploadImgBtnSrc:
        "https://ossfastmake.mustke.com/12jielong/bdJL/uploadImgBtn.svg",
      shareImgColumns: [
        {
          label: "系统分享图",
          value: 1,
        },
        {
          label: "上传自定义",
          value: 2,
        },
      ],
      shareImgColumnsValue: 1,
      shareImageUrl:
        "https://ossfastmake.mustke.com/12jielong/bdJL/sys-defaultShareImg.jpg", // 系统分享图地址
      shareZdyImageUrl:
        "https://ossfastmake.mustke.com/12jielong/bdJL/uploadImgBtn.svg", // 自定义分享图地址
      uploadImgOrVideo: [
        {
          name: "上传图片",
          id: 1,
        },
        {
          name: "上传视频",
          id: 2,
        },
      ],
      uploadImgOrVideoShow: false,
      UsePop: false, // 说明弹框
      imgOrVideo: 1,
      uploader: null,
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-shanghai",
      userId: "1303984639806000",
      file: null,
      stsProgress: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      statusText: "",
      clockListNumber: 5, // 一行展示多少个参与名单 2一排两个 1一排三个，以此类推

      clockListNumArr: [
        {
          value: 2,
          label: "一排2个",
        },
        {
          value: 3,
          label: "一排3个",
        },
        {
          value: 4,
          label: "一排4个",
        },
        {
          value: 5,
          label: "一排5个",
        },
      ],
      // 核销
      verificationSwitch: 1, // 核销开关(1-关闭,2-开启)';默认1
      foreverTimeHxChecked: false,
      verificationStartTime: "", // 核销开始时间
      verificationEndTime: "", // 核销结束时间
      hxStartAndEndTime: "",

      // 签到
      foreverTimeQdChecked: false,
      signInStartTime: "", // 核销开始时间
      signInEndTime: "", // 核销结束时间
      signStartAndEndTime: "",

      // 签到参与地点
      signLocationSwitch: 1, // 是否指定签到地点(1-否,2-是) 默认1
      signLocation: "", // 有经纬度
      signLocationDistance: 2000,
      signInAddress: "",
      signLocationDisShow: false,
      clockInfoObj: {},
      demonstrateTitle: "演示",
      demonVisible: false,
      contentList: {},
      checkInStatusArr: [
        {
          label: "仅创建者和管理员可见",
          id: 1,
        },
        {
          label: "所有人可见",
          id: 2,
        },
      ],
      checkInStatusShow: false,
      checkInStatusWord: "仅创建者和管理员可见",
      checkInStatusSwitch: 1, // 1创建者管理员可见2所有人可见
      clockSwitch: 1, // 默认1关闭2开启.
      programType: 99, // 小程序类型 1-加加 2-报名
      AppID: "",

      // 封面设置相关
      coverSettingDrawer: false,
      // isCoverEnabled: 1, // 是否启用封面（开关）1-开 2-关
      // coverImages: [], // 自定义封面图片数组
      // maxCoverImages: 5, // 最大封面图片数量
      // coverVideoId: '', // 视频ID
      // coverPlayUrl: '', // 视频地址
      // coverPlayCoverImage: '', // 视频封面
      // coverSubCoverImages: [], // 封面子图片地址
      // coverIsVideo: 2, // 是否是视频 1-视频 2-图片
      // coverActivityModeUrl: 'https://ossfastmake.mustke.com/12xtPictures/xt-1.png', // 系统封面图
      customCoverDialog: {
        vid: "", //  视频ID
        playUrl: "", //  视频地址
        playCoverImage: "", //  视频封面
        subCoverImages: [], //  封面子图片地址
        maxCoverImages: 5, // 最大封面图片数量
        isVideo: 2, //  是否是视频 1-视频 2-图片
        isCoverEnabled: 1, //  是否启用封面（开关）1-开 2-关
        activityModeUrl: "https://ossfastmake.mustke.com/12xtPictures/xt-1.png", // 系统封面图
      },

      vid: "",
      playUrl: "",
      playCoverImage: "",
      subCoverImages: [],
      isVideo: 2,
      isCoverEnabled: 1,
      testHeight: "568rpx", //轮播图初始高度  452
      swiperH: [], //轮播图片高度数据
      swiperIndex: 0, //轮播当前所选序列
      turnPictures: [], // 轮播图
      indicatorDots: true,
      autoplay: true,
      duration: 500,
      activityKey: "",
      phoneSwitch: 1, // 是否显示联系信息 默认1 关闭 2开启
      userPhone: "",
      edit_userPhone: "",
      contactType: 1, // 1-手机号 2-微信号 3-手机号和微信同号
      contactTypeShow: false,
      contactTypeArr: [
        {
          label: "手机号",
          id: 1,
        },
        {
          label: "微信号",
          id: 2,
        },
        {
          label: "手机号和微信同号",
          id: 3,
        },
      ],
      contactTypeText: "手机号",
      batch_set_num: "",
      currentFieldItem: null,
      currentFieldIndex: null,
      catchBatchSetNumShowBox: false,
      signDataScreenDrawer:false,//签到数据大屏
      DataScreenUrl: '', // 数据大屏地址
      key: '', // 访问密码
      browserList: [], // 当前使用浏览器列表
    };
  },
  mounted() {
    var str11 = dayjs().format("DD/MM/YYYY");
    // 页面参数
    this.routeParameter = this.$route.query;
    if (this.routeParameter.activityId) {
      this.activityId = this.routeParameter.activityId;
    }
    if (this.routeParameter.alias) {
      this.activityKey = this.routeParameter.alias;
    }
    if (this.routeParameter.selectType) {
      this.selectType = this.routeParameter.selectType;
    }
    if (this.routeParameter.is_template) {
      this.is_template = Number(this.routeParameter.is_template); // 1-模板 0-不是模板是活动
    }
    if (this.routeParameter.isType) {
      this.isType = this.routeParameter.isType;
    }
    if (this.routeParameter.selectType) {
      this.selectType = this.routeParameter.selectType;
    }
    if (this.routeParameter.folderId) {
      this.folderId = this.routeParameter.folderId;
      // 在文件夹内创建，isInFolder 设置为 2
      this.isInFolder = 2;
    }
    if (this.routeParameter.isInFolder) {
      this.isInFolder = this.routeParameter.isInFolder;
    }
    if (this.routeParameter.isAi) {
      this.isAi = this.routeParameter.isAi;
    }
    if (this.routeParameter.rateType) {
      this.rateType = this.routeParameter.rateType;
    }

    this.pageType = this.routeParameter.pageType;
    this.ifcopy = this.routeParameter.copy;
    this.groupId = this.routeParameter.groupId;

    if (this.isType == 109) {
      this.activeBuildTitle = "打卡接龙";
    }
    if (this.isType == 110) {
      this.activeBuildTitle = "周期打卡";
    }
    if (this.isType == 106) {
      this.activeBuildTitle = copyrightConfig.AppID == "wx7d8daf6d777947a2" ? "通用报名" : "通用接龙";
    }

    // generalCheckTimesArr已在data中初始化

    this.subAddress();
    this.lastDayOfMonth = this.getLastDayOfMonth();
    // 截止赋值
    var arr1 = [];
    for (var i = 1; i <= 31; i++) {
      var str = i + "号";
      var _json = {
        value: i,
        label: str,
      };
      arr1.push(_json);
    }
    this.endMonthArr1 = arr1;

    var arr2 = [];
    for (var j = 0; j <= 23; j++) {
      if (j < 10) {
        var timeJson1 = {
          value: j,
          label: "0" + j + "时",
        };
        arr2.push(timeJson1);
      } else {
        var timeJson2 = {
          value: j,
          label: j + "时",
        };
        arr2.push(timeJson2);
      }
    }
    this.endMonthArr2 = arr2;
    this.endWeekArr2 = arr2;

    var arr3 = [];
    for (var g = 0; g <= 59; g++) {
      if (g < 10) {
        var timeJson3 = {
          value: g,
          label: "0" + g + "分",
        };
        arr3.push(timeJson3);
      } else {
        var timeJson4 = {
          value: g,
          label: g + "分",
        };
        arr3.push(timeJson4);
      }
    }
    this.endMonthArr3 = arr3;
    this.endWeekArr3 = arr3;

    this.clockPresetsList();
    this.activityDetailFun();
    this.getRelatedList();
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  watch: {
    gzhDialogVisible(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleGzhDialogClosed();
      }
    },
    relatedDrawerShow(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const scrollableDiv = document.getElementById("scrollable-div");
          if (scrollableDiv) {
            this.scrollHandler = (event) => {
              this.isLoading = false;

              // 添加一个小的容错值(比如5px)来处理可能的小数点误差
              if (
                scrollableDiv.scrollTop + scrollableDiv.clientHeight + 5 >=
                scrollableDiv.scrollHeight
              ) {
                this.pageNum++;
                this.getRelatedList();
              }
            };
            scrollableDiv.addEventListener("scroll", this.scrollHandler);
          }
        });
      } else {
        const scrollableDiv = document.getElementById("scrollable-div");
        if (scrollableDiv && this.scrollHandler) {
          scrollableDiv.removeEventListener("scroll", this.scrollHandler);
        }
      }
    },
    "propertyData.content"(newVal, oldVal) {
      var length = this.propertyData.content.length;
      this.maxValueArr = [];
      this.minValueArr = [];
      for (var i = 0; i <= length; i++) {
        if (i == 0) {
          const bx = {
            value: 0,
            label: "不限",
          };
          this.maxValueArr.push(bx);
          this.minValueArr.push(bx);
        } else {
          const other = {
            value: i,
            label: i,
          };
          this.maxValueArr.push(other);
          this.minValueArr.push(other);
        }
      }
    },
  },
  beforeDestroy() {
    const scrollableDiv = document.getElementById("scrollable-div");
    if (scrollableDiv && this.scrollHandler) {
      scrollableDiv.removeEventListener("scroll", this.scrollHandler);
    }
  },
  methods: {
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      document.title = `创建接龙 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    signDataScreenDrawerClose(){
       this.signDataScreenDrawer = false;
    },
    getDataScreenUrl(){
      this.signDataScreenDrawer = true;
      this._currentUsage();
      this._getActivityCode();
    },
    // 获取用户地址信息
    async _currentUsage() {
      axios.get(serverConfig.baseURL + '/screen/getUserUrl', {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Token': localStorage.getItem("token"),
                    'alias':this.activityDetail.activityKey
                }
            })
                .then(response => {
                    console.log(response, 'response')
                })
                .catch(error => {
                  
                });
        // const result = await getUserUrl({}, { "alias": this.alias });
    },
    // 下线
    offline(i) {
      this.commIndex = i;
      this.$confirm('确定下线？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this._offlineUsers();
      }).catch(() => {});
    },
    // 下线用户
    async _offlineUsers() {
      try {
        const res = await axios.get(`${serverConfig.BASE_URL}/screen/offlineUsers`, {
          headers: {
            "Content-Type": "application/json",
            "appId": this.appid,
            "alias": this.activityDetail.activityKey ,
            "Access-Token": localStorage.getItem("token") || ""
          }
        });
        if (res.data.status == 1) {
          this.$message.success('下线成功');
          this._currentUsage();
        }
      } catch (error) {
        console.error('下线失败：', error);
      }
    },
    // 获取AccessKey
    async _getAccessKey(codeurl) {
      try {
        const res = await axios.post(serverConfig.baseURL + '/screen/getAccessKey', {
          url: codeurl,
          name: this.activityDetail.name,
          appId: this.appid
        }, {
          headers: {
            "Content-Type": "application/json",
            "appId": this.appid,
            "alias":this.activityDetail.activityKey,
            "Access-Token": localStorage.getItem("token") || ""
          }
        })
        if (res.data.status == 1) {
          this.key = res.data.msg;
        }
      } catch (error) {
        console.error('获取AccessKey失败：', error);
      }
    },
    // 获取活动码
    async _getActivityCode() {
      try {
        const { data, msg, status } = await getActivityCode({
          activityId: this.activityId,
          scene: `id=${this.activityId}&st=see&ity=${this.activityType}`,
          page: "pages/solataireGroupDetails/solataireGroupDetails",
        });
        if (status == 1) {
          const codeurl = this.imageUrl + data.smallCode;
          this._getAccessKey(codeurl);
        }
      } catch (error) {
        console.error('获取活动码失败：', error);
      }
    },
    // 复制地址
    copyUrl() {
      const input = document.createElement('input');
      input.value = this.DataScreenUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    getGzhDialogShowCount() {
      if (typeof window === "undefined" || !window.localStorage) {
        return 0;
      }
      try {
        const storedValue = window.localStorage.getItem(GZH_DIALOG_LIMIT_KEY);
        const parsedValue = Number(storedValue);
        return Number.isNaN(parsedValue) ? 0 : parsedValue;
      } catch (error) {
        console.warn("getGzhDialogShowCount error", error);
        return 0;
      }
    },
    setGzhDialogShowCount(count) {
      if (typeof window === "undefined" || !window.localStorage) {
        return;
      }
      try {
        const normalizedValue = Math.max(0, Number(count) || 0);
        window.localStorage.setItem(
          GZH_DIALOG_LIMIT_KEY,
          String(normalizedValue)
        );
      } catch (error) {
        console.warn("setGzhDialogShowCount error", error);
      }
    },
    shouldLimitGzhDialog() {
      return this.selectType === "add";
    },
    canShowGzhDialog() {
      if (!this.shouldLimitGzhDialog()) {
        return true;
      }
      return this.getGzhDialogShowCount() < GZH_DIALOG_MAX_SHOW;
    },
    recordGzhDialogShow() {
      if (!this.shouldLimitGzhDialog()) {
        return;
      }
      const currentCount = this.getGzhDialogShowCount();
      this.setGzhDialogShowCount(currentCount + 1);
    },
    waitForGzhDialogClose() {
      this.resolveGzhDialogPromise();
      return new Promise((resolve) => {
        this.gzhDialogPromiseResolver = resolve;
      });
    },
    resolveGzhDialogPromise() {
      if (typeof this.gzhDialogPromiseResolver === "function") {
        this.gzhDialogPromiseResolver();
        this.gzhDialogPromiseResolver = null;
      }
    },
    handleGzhDialogClosed() {
      this.resolveGzhDialogPromise();
    },
    closeGzhDialog() {
      this.gzhDialogVisible = false;
    },
    showGzhDialog(options = {}) {
      const respectLimit = Object.prototype.hasOwnProperty.call(
        options,
        "respectLimit"
      )
        ? options.respectLimit
        : this.shouldLimitGzhDialog();
      const waitForClose = Object.prototype.hasOwnProperty.call(
        options,
        "waitForClose"
      )
        ? options.waitForClose
        : false;
      if (respectLimit && !this.canShowGzhDialog()) {
        return waitForClose ? Promise.resolve(false) : false;
      }
      this.gzhDialogVisible = true;
      if (respectLimit) {
        this.recordGzhDialogShow();
      }
      if (waitForClose) {
        return this.waitForGzhDialogClose();
      }
      return true;
    },
    async handleEnablePushChange(value) {
      if (
        this.selectType !== "add" ||
        (this.activityDetail && this.activityDetail.id)
      ) {
        return;
      }
      if (Number(value) === 1) {
        await this.checkWechatFollowStatus();
      }
    },
    async checkWechatFollowStatus(options = {}) {
      const showDialog =
        options && Object.prototype.hasOwnProperty.call(options, "showDialog")
          ? options.showDialog
          : true;
      const respectLimit =
        options && Object.prototype.hasOwnProperty.call(options, "respectLimit")
          ? options.respectLimit
          : this.shouldLimitGzhDialog();
      if (this.wechatFollowStatus === 2) {
        return true;
      }
      if (this.wechatFollowStatus === 1) {
        if (showDialog) {
          await this.showGzhDialog({ respectLimit, waitForClose: true });
        }
        return false;
      }
      try {
        const { status, data } = await isFollowWechat({});
        if (status === 1) {
          const followStatusRaw =
            typeof data === "object" && data !== null
              ? data.followStatus ?? data.status ?? data.value
              : data;
          const followStatus = Number(followStatusRaw);
          if (!Number.isNaN(followStatus)) {
            this.wechatFollowStatus = followStatus;
            if (followStatus === 2) {
              return true;
            }
          }
        }
        if (showDialog) {
          await this.showGzhDialog({ respectLimit, waitForClose: true });
        }
        return false;
      } catch (error) {
        console.error("checkWechatFollowStatus error", error);
        this.$message.error("获取关注状态失败，请稍后再试");
        return false;
      }
    },
    // 批量设置数量
    batchSetNum(fieldItem, fieldIndex) {
      this.currentFieldItem = fieldItem;
      this.currentFieldIndex = fieldIndex;
      this.catchBatchSetNumShowBox = true;
    },
    confirmBatchSetNum() {
      // 批量设置数量
      if (this.currentFieldItem && this.currentFieldItem.content) {
        // 为当前字段的所有选项设置相同的数量
        this.currentFieldItem.content.forEach((item, index) => {
          // 如果输入为空，设置为-1表示数量不限
          item.maxNum =
            this.batch_set_num === "" ||
            this.batch_set_num === null ||
            this.batch_set_num === undefined
              ? -1
              : parseInt(this.batch_set_num) || 0;
        });

        // 关闭弹窗并清空输入
        this.catchBatchSetNumShowBox = false;
        this.batch_set_num = "";
        this.$message("批量设置数量成功");
      } else {
        this.$message("数据错误，请重试");
      }
    },
    // 处理数量值变化
    handleNumValueChange(event, item) {
      console.log("handleNumValueChange处理数量值变化", event, item);
      // 检查item是否存在
      if (!item) {
        console.warn("handleNumValueChange: item is undefined");
        return;
      }
      const value = event;
      // if (value === "" || value === null || value === undefined) {
      //   item.maxNum = -1; // 空值设为-1表示无限
      // } else {
      
      // }
        item.maxNum = parseInt(value) || 0;
        console.log(item.maxNum,'item.maxNumitem.maxNum')
    },
    // 处理数量值获得焦点
    handleNumValueFocus(item) {
      // 检查item是否存在
      if (!item) {
        console.warn("handleNumValueFocus: item is undefined");
        return;
      }
      // 如果当前值是-1（无限），清空输入框让用户输入
      if (item.maxNum === -1) {
        item.maxNum = "";
      }
    },
    // 保存活动时同步maxNum到fmFieldNumList
    syncMaxNumToFieldNumListForSave(fieldData) {
      // 检查是否是单选或多选类型
      if (
        (fieldData.type === 2 || fieldData.type === 4||fieldData.type ===9) &&
        fieldData.content &&
        Array.isArray(fieldData.content)
      ) {
        // 确保fmFieldNumList存在
        if (!fieldData.fmFieldNumList) {
          fieldData.fmFieldNumList = [];
        }

        // 遍历content中的每个选项，同步maxNum到fmFieldNumList
        fieldData.content.forEach((option, optionIndex) => {
          // 如果fmFieldNumList中没有对应索引的项，创建一个
          if (!fieldData.fmFieldNumList[optionIndex]) {
            fieldData.fmFieldNumList[optionIndex] = {
              id: null,
              itemId: null,
              ifDel: 2,
              addTime: new Date()
                .toISOString()
                .replace("T", " ")
                .substring(0, 19),
              filedNumId: null,
              maxNum: option.maxNum !== undefined ? option.maxNum : -1,
              optionName: null,
              value: option.value || null,
            };
          } else {
            // 更新已存在项的maxNum
            fieldData.fmFieldNumList[optionIndex].maxNum =
              option.maxNum !== undefined ? option.maxNum : -1;
            fieldData.fmFieldNumList[optionIndex].value = option.value || null;
          }
        });
      }
    },
    // 处理选项值变化
    handleOptionValueChange(event, fieldIndex, optionIndex) {
      const value = event.detail.value;
      // 使用 $set 确保响应式更新
      this.$set(
        this.listList[this.indexIdx].signField[fieldIndex].content[optionIndex],
        "value",
        value
      );

      // 强制更新视图
      this.$forceUpdate();

      const updatedValue =
        this.listList[this.indexIdx].signField[fieldIndex].content[optionIndex]
          .value;
    },
    // 打开封面设置
    openCoverSetting() {
      // 初始化封面设置数据
      this.customCoverDialog.isCoverEnabled = this.isCoverEnabled;
      this.customCoverDialog.activityModeUrl = this.activityModeUrl;
      this.customCoverDialog.subCoverImages = this.subCoverImages;
      this.customCoverDialog.isVideo = this.isVideo;
      this.customCoverDialog.vid = this.vid;
      this.customCoverDialog.playUrl = this.playUrl;
      if (this.customCoverDialog.subCoverImages.length >= 1) {
        this.customCoverDialog.isCoverEnabled = 2;
      }
      this.coverSettingDrawer = true;
    },

    // 关闭封面设置
    closeCoverSetting() {
      this.coverSettingDrawer = false;
    },

    // 保存封面设置
    saveCoverSetting() {
      this.vid = this.customCoverDialog.vid;
      this.playUrl = this.customCoverDialog.playUrl;
      this.playCoverImage = this.customCoverDialog.playCoverImage;
      this.subCoverImages = this.customCoverDialog.subCoverImages;
      this.isVideo = this.customCoverDialog.isVideo;
      this.isCoverEnabled = this.customCoverDialog.isCoverEnabled;
      this.activityModeUrl = this.customCoverDialog.activityModeUrl;

      // 整合activityModeUrl和subCoverImages到turnPictures数组
      this.turnPictures = [];
      // 如果activityModeUrl不为空字符串，则添加到数组开头
      if (this.activityModeUrl && this.activityModeUrl.trim() !== "") {
        this.turnPictures.push(this.activityModeUrl);
      }
      // 如果subCoverImages不为空数组，则添加到turnPictures中
      if (this.subCoverImages && this.subCoverImages.length > 0) {
        this.turnPictures = this.turnPictures.concat(this.subCoverImages);
      }

      if (this.isCoverEnabled == 2 && this.activityModeUrl) {
        // 删除 turnPictures 数组里的第一个
        this.turnPictures.splice(0, 1);
      }

      this.coverSettingDrawer = false;
      this.$message.success("封面设置保存成功");
    },

    // 选择系统封面
    selectSystemCover() {
      this.$refs.systemPictures.openSysPop(1);
    },

    // 确认选择系统封面
    confirmSystemCover(item) {
      this.customCoverDialog.activityModeUrl = item.url;
      this.customCoverDialog.isVideo = 2; // 系统封面是图片
    },

    // 上传自定义封面图片
    handleCoverImageUpload(event) {
      this.selectedFile = event.target.files;

      // 检查当前图片数量限制
      const currentImageCount = this.customCoverDialog.subCoverImages.length;
      const maxImages = this.customCoverDialog.maxCoverImages;

      if (currentImageCount >= maxImages) {
        this.$message.warning(`最多只能上传${maxImages}张自定义封面图片`);
        event.target.value = "";
        return;
      }

      // 检查选择的文件数量是否会超过限制
      const remainingSlots = maxImages - currentImageCount;
      const filesToProcess = Math.min(this.selectedFile.length, remainingSlots);

      if (this.selectedFile.length > remainingSlots) {
        this.$message.warning(`最多只能再上传${remainingSlots}张图片`);
      }

      var pettern = /^image/;
      for (let i = 0; i < filesToProcess; i++) {
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          event.target.value = "";
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("请上传大小不超过5MB文件");
          event.target.value = "";
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.isVideo = 2;
                this.customCoverDialog.isCoverEnabled = 2;
                this.subCoverImages.push(this.imageUrl + response.data.msg);
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });
        }
      }

      // 清空文件输入框
      event.target.value = "";
    },

    // 上传封面视频
    handleCoverVideoUpload(event) {
      this.file = event.target.files[0];
      console.log("this.file", this.file);
      if (this.customCoverDialog.subCoverImages.length > 5) {
        this.$message("最多可上传5张自定义封面图片!");
        return;
      }
      if (!this.file) {
        this.$message("请先选择需要上传的文件!");
        return;
      }

      // 检查文件格式
      const lastArr = this.file.name.split(".");
      if (lastArr[1] !== "mp4") {
        this.$message("文件格式不正确，请上传MP4格式视频");
        event.target.value = "";
        return;
      }

      // 检查文件大小
      if (this.file.size / 1048576 > 10) {
        this.$message("请上传大小不超过10MB文件");
        event.target.value = "";
        return;
      }

      const fileURL = URL.createObjectURL(this.file);
      this.customCoverDialog.playUrl = fileURL;

      var Title = this.file.name;
      var userData = '{"Vod":{}}';

      if (this.uploader) {
        this.uploader.stopUpload();
        this.stsProgress = 0;
        this.statusText = "";
      }

      this.uploader = this.createUploader();
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = false;
      this.customCoverDialog.isVideo = 1;
    },

    // 删除自定义封面图片
    deleteCoverImage(index) {
      this.customCoverDialog.subCoverImages.splice(index, 1);
    },
    // 删除视频
    deleteVideo() {
      this.customCoverDialog.isVideo = 2;
      this.customCoverDialog.playUrl = "";
    },
    // 添加自定义封面图片到数组
    addCoverImage(imageUrl) {
      if (
        this.customCoverDialog.subCoverImages.length <
        this.customCoverDialog.maxCoverImages
      ) {
        this.customCoverDialog.subCoverImages.push(imageUrl);
      } else {
        this.$message.warning(
          `最多只能上传${this.customCoverDialog.maxCoverImages}张自定义封面图片`
        );
      }
    },

    // 选择自定义封面
    selectCustomCover(imageUrl) {
      this.customCoverDialog.activityModeUrl = imageUrl;
      this.customCoverDialog.isVideo = 2; // 图片
      this.$message.success("已选择该图片作为封面");
    },

    // 切换封面启用状态
    toggleCoverEnabled(value) {
      console.log("切换封面启用状态:", value);
      this.customCoverDialog.isCoverEnabled = value;
    },

    demonstrate(n) {
      this.contentList = {};
      if (n == 1) {
        this.contentList = {
          title: "版式选择演示",
          imgurl: "https://ossfastmake.mustke.com/12jielong/bdJL/bm-yanshi.png",
        };
      }
      if (n == 2) {
        this.contentList = {
          title: "提示",
          imgurl: "https://ossfastmake.mustke.com/12jielong/bdJL/tbx-tishi.jpg",
        };
      }
      if (n == 3) {
        this.contentList = {
          title: "匿名参与使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/niming-tishi.png",
        };
      }
      if (n == 4) {
        this.contentList = {
          title: "显示发布人信息使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/faburen-tishi.jpg",
        };
      }
      if (n == 5) {
        this.contentList = {
          title: "群聊演示弹框",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/qunliao-tishi.jpg",
        };
      }
      if (n == 6) {
        this.contentList = {
          title: "核销演示弹框",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/hexiao-tishi.jpg",
        };
      }
      if (n == 7) {
        this.contentList = {
          title: "签到码演示弹框",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/qiandao-tishi.jpg",
        };
      }
      if (n == 8) {
        this.contentList = {
          title: "撤销签到功能使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/chexiaoqd-tishi.jpg",
        };
      }
      if (n == 9) {
        this.contentList = {
          title: "报名信息使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/baomingxx-tishi.jpg",
        };
      }
      if (n == 10) {
        this.contentList = {
          title: "指定参与地点使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/canyudidian-tishi.jpg",
        };
      }
      if (n == 11) {
        this.contentList = {
          title: "添加名单使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/add-mingdan-tishi.png",
        };
      }
      if (n == 12) {
        this.contentList = {
          title: "加密浏览分享数据演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/jimiliulanshuju-tishi-jiami.jpg",
        };
      }
      if (n == 13) {
        this.contentList = {
          title: "内容展开收起使用演示",
          imgurl:
            "https://ossfastmake.mustke.com/12jielong/bdJL/collExpand-tips.png",
        };
      }
       if (n == 14) {
        this.contentList = {
					title: "签到数据大屏使用演示",
					imgurl:
						"https://ossfastmake.mustke.com/12jielong/lsyJL/dataBigScreen-yanshi.png",
				};
      }
      this.demonVisible = true;
    },
    clockListNumFn(n) {
      this.clockListNumber = n;
      this.activityDetail.clockListNumber = n;
    },
    ...mapActions("commonData", ["saveIsOpenShare"]),

    openIV() {
      this.uploadImgOrVideoShow = true;
    },
    IVClick(e) {},
    handleCoverImgUpload(event) {
      this.selectedFile = event.target.files;
      console.log(event.target.value);
      const iptElm = document.getElementById("uploadImageBtn");
      const url = URL.createObjectURL(iptElm.files[0]);
      this.option["img"] = url;
      this.dialogVisibleCro = true;
    },
    handleVideoFmUpload(e) {
      this.file = e.target.files[0];
      if (!this.file) {
        alert("请先选择需要上传的文件!");
        return;
      }
      console.log(e.target.files[0], "e.target======");
      const fileURL = URL.createObjectURL(this.file);
      console.log(fileURL, "fileURL=====");
      this.customCoverDialog.playUrl = fileURL;
      var Title = this.file.name;
      var userData = '{"Vod":{}}';
      if (this.uploader) {
        this.uploader.stopUpload();
        this.authProgress = 0;
        this.statusText = "";
      }
      this.uploader = this.createUploader();
      // 首先调用 uploader.addFile(event.target.files[i], null, null, null, userData)
      console.log(userData);
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = false;
    },
    // 开始上传
    stsUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.uploadDisabled = true;
        this.pauseDisabled = false;
      }
    },
    // 暂停上传
    pauseUpload() {
      if (this.uploader !== null) {
        this.uploader.stopUpload();
        this.resumeDisabled = false;
        this.pauseDisabled = true;
      }
    },
    // 恢复上传
    resumeUpload() {
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.resumeDisabled = true;
        this.pauseDisabled = false;
      }
    },
    /* global AliyunUpload */
    createUploader() {
      const self = this;
      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: Math.round(self.partSize || 1048576),
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        localCheckpoint: true, //此参数是禁用服务端缓存
        // 添加文件成功
        addFileSuccess: (uploadInfo) => {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          console.log("addFileSuccess: " + uploadInfo.file.name);
          self.stsUpload();
        },
        // 开始上传
        onUploadstarted: (uploadInfo) => {
          console.log("onUploadstarted", uploadInfo);

          axios
            .post(serverConfig.baseURL + "/videoTx/getVideoPathToken", "", {
              headers: {
                "Content-Type": "application/json",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              console.log("response", response);
              var result = response.data;
              console.log("result", response);
              if (result.status == 1) {
                console.log("result", result.data.AccessKeyId);
                uploader.setSTSToken(
                  uploadInfo,
                  result.data.AccessKeyId,
                  result.data.AccessKeySecret,
                  result.data.SecurityToken
                );
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });

          self.statusText = "文件开始上传...";
          console.log(
            "onUploadStarted:" +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );
        },

        // 文件上传成功
        onUploadSucceed: (uploadInfo) => {
          console.log(
            "onUploadSucceed: " +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );
          console.log(uploadInfo, "上传成功！！！！");
          self.activityDetail.vid = uploadInfo.videoId;
          // self.activityDetail.playUrl = uploadInfo.endpoint + '/' +uploadInfo.object;
          self.activityDetail.isVideo = 1;
          self.statusText = "文件上传成功!";

          // 如果是封面设置模式，更新封面设置数据
          if (self.coverSettingDrawer) {
            self.customCoverDialog.vid = uploadInfo.videoId;
            self.customCoverDialog.isVideo = 1;
          }
        },
        // 文件上传失败
        onUploadFailed: (uploadInfo, code, message) => {
          console.log(
            "onUploadFailed: file:" +
              uploadInfo.file.name +
              ",code:" +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: (uploadInfo, code, message) => {
          console.log(
            "Canceled file: " +
              uploadInfo.file.name +
              ", code: " +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: (uploadInfo, totalSize, progress) => {
          console.log(
            "onUploadProgress:file:" +
              uploadInfo.file.name +
              ", fileSize:" +
              totalSize +
              ", percent:" +
              Math.ceil(progress * 100) +
              "%"
          );
          const progressPercent = Math.ceil(progress * 100);
          self.stsProgress = progressPercent;
          self.statusText = "文件上传中...";
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 如果是上传方式二即根据 STSToken 实现时，从新获取STS临时账号用于恢复上传
          // 上传文件过大时可能在上传过程中 sts token 就会失效, 所以需要在 token 过期的回调中调用 resumeUploadWithSTSToken 方法
          // 这里是测试接口, 所以我直接获取了 STSToken
          // let stsUrl = 'http://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateSecurityToken?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=67999yyuuuy&AppVersion=1.0.0'
          // axios.get(stsUrl).then(({data}) => {
          //     let info = data.SecurityTokenInfo
          //     let accessKeyId = info.AccessKeyId
          //     let accessKeySecret = info.AccessKeySecret
          //     let secretToken = info.SecurityToken
          //     let expiration = info.Expiration
          //     uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expiration)
          // })

          this.$message("文件上传超时");
          self.statusText = "文件超时...";
        },
        // 全部文件上传结束
        onUploadEnd: (uploadInfo) => {
          loading.close();
          console.log("onUploadEnd: uploaded all the files");
          self.statusText = "文件上传完毕";
        },
      });
      return uploader;
    },

    // 获取视频封面和视频地址
    async _getVideoPathUrl() {
      console.log("获取视频封面和视频地址=====");
      const result = await getVideoPathUrl({
        videoId: this.customCoverDialog.vid,
      });
      if (result.status == 1) {
        this.customCoverDialog.isVideo = 1;
      }
      console.log(result, "视频信息哦");
    },
    handleFail(res) {
      console.log("上传失败", res);
    },
    IVClose() {
      this.uploadImgOrVideoShow = false;
    },
    openShareImgPop() {
      this.shareImgPopShow = true;
    },
    shareImgCancel() {
      this.shareImgPopShow = false;
    },
    shareImgConfirm(e) {
      console.log(e);
      this.activityDetail.shareImageStyle = e;
      this.shareImageStyle = e;
    },
    checkInConfirm(e) {
      this.activityDetail.checkInStatusSwitch = e;
      this.checkInStatusSwitch = e;
    },
    selectSysPic() {
      this.showModal = true;
      this.$refs.systemPictures.openSysPop(1);
    },
    changeXTShareImg() {
      this.$refs.systemPictures.openSysPop(2);
    },
    sureSelect(item) {
      console.log("this.showModal", this.showModal);
      // 如果是封面设置模式，更新封面设置数据
      if (this.coverSettingDrawer) {
        this.customCoverDialog.activityModeUrl = item;
        this.customCoverDialog.isVideo = 2;
      } else {
        this.activityModeUrl = item;
        this.activityDetail.activityModeUrl = item;
        this.activityDetail.isVideo = 2;
      }
      this.showModal = false;
    },
    shareSelect(item) {
      this.showModal = false;
      if (this.activityDetail.shareImageStyle == 1) {
        this.shareImageUrl = item;
        this.activityDetail.shareImageUrl = item;
      } else {
        this.shareZdyImageUrl = item;
        this.activityDetail.shareZdyImageUrl = item;
      }
    },
    changeMode(num) {
      this.activityMode = num;
      this.activityDetail.activityMode = num;
    },
    // 选择图片（加在图片上的事件，点击图片，获取图片的链接地址）
    selectImage(src) {
      // 设置图片Base64
      this.setImageBase64(src, (base64) => {
        this.option.img = base64;
        this.dialogVisibleCro = true;
      });
    },

    // 设置图片Base64
    setImageBase64(src, callback) {
      const image = new Image();
      // 支持跨域
      image.crossOrigin = "anonymous";
      // 处理缓存
      image.src = src + "?v=" + Math.random();
      // 动态生成
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        const result = canvas.toDataURL("image/png");
        callback && callback(result);
      };
    },

    // 确认裁剪
    finish() {
      this.$refs.cropper.getCropData((data) => {
        const file = this.base64ToFile(data, "cropped-image.png");

        var parm = {
          file,
          type: "modularImg",
        };
        axios
          .post(serverConfig.baseURL + "/file/uploadFile", parm, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Token": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            this.activityModeUrl = this.imageUrl + res.data.msg;
            this.activityDetail.activityModeUrl = this.imageUrl + res.data.msg;
            this.activityDetail.isVideo = 2;
            this.dialogVisibleCro = false;
          });
      });
    },
    base64ToFile(base64, filename) {
      const arr = base64.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]); // 解码 base64
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    // 关闭裁剪
    closeCropper() {
      this.dialogVisibleCro = false;
    },

    handleShareImgUpload(event) {
      this.selectedFile = event.target.files;
      var pettern = /^image/;
      if (!pettern.test(this.selectedFile[0].type)) {
        this.$message("文件格式不正确");
        event.target.value = "";
        return;
      }
      if (this.selectedFile[0].size / 1048576 > 5) {
        this.$message("请上传大小不超过5MB文件");
        event.target.value = "";
      } else {
        var parm = {
          file: this.selectedFile[0],
          type: "modularImg",
        };

        axios
          .post(serverConfig.baseURL + "/file/uploadFile", parm, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Token": localStorage.getItem("token"),
            },
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.uploadPicsType = 3;
              this.shareZdyImageUrl = this.imageUrl + response.data.msg;
            }
          })
          .catch((error) => {
            event.target.value = "";
            console.log("err:", error);
          });
      }
    },

    editFzNameList() {
      if (this.nameAddType == 1) {
        this.openNameListDrawerFun();
        this.nameAddOptionsShow = false;
      }
      if (this.nameAddType == 2) {
        // 更新中间值
        this.subsetCenterValueArr = JSON.parse(
          JSON.stringify(this.subsetValueArr)
        );
        this.subsetCenterValueArr.forEach((item) => {
          var reg = /([\n\r])+/g;
          var str = item.clockInList.replace(reg, "\n");
          let arr = str.split(/[\n+,，；;]/g);
          arr = arr.filter((item) => item != "");
          console.log(arr, "啥情况啊，这里怎么就不对呢");
          item.clockInListNum = arr.length;
        });

        if (this.pickerName == "全部") {
          this.subsetShow = true;
        } else {
          // 根据pickerName的值，找到数组subsetCenterValueArr对应的值，深度赋值fzPopItemInfo
          this.fzPopItemInfo = JSON.parse(
            JSON.stringify(
              this.subsetCenterValueArr.find(
                (item) => item.listGroupName == this.pickerName
              )
            )
          );
          this.fzTitle = this.fzPopItemInfo.listGroupName;
          this.fzValue = this.fzPopItemInfo.clockInList;
          this.handlerBlur();
          this.showModal = true;
          this.copyTextAreaShow = true;
          this.modelContentDel = true;
          setTimeout(() => {
            this.placeholderText1 =
              "请输入姓名名单，每个名单可用中英文逗号,换行隔开，最大输入为100个名单。可复制粘贴";
          }, 350);

          this.handleSubShow = true;
        }
      }
    },
    // 获取时分秒 23:12:12
    getCurrentTime() {
      const now = new Date();
      // 使用 padStart 确保两位数格式（兼容所有现代浏览器）
      const hour = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");
      const second = String(now.getSeconds()).padStart(2, "0");
      return `${hour}:${minute}:${second}`;
    },
    //调用ai生成接龙信息
    getCreateMessage(isAi) {
      console.log("isAi", isAi);
      const sfm = this.getCurrentTime();
      if (isAi == "1") {
        var activityInfo = localStorage.getItem("activityInfo");
        console.log("activityInfo11111111111", activityInfo);
        activityInfo = JSON.parse(activityInfo);
        if (activityInfo && typeof activityInfo === "object") {
          if (activityInfo.activityName) {
            this.activityDetail.name = activityInfo.activityName;
          }
          if (activityInfo.description) {
            this.activityDetail.content = activityInfo.description;
          }
          if (activityInfo.startTime) {
            if (activityInfo.startTime.length > 10) {
              this.activityDetail.beginTime = activityInfo.startTime;
            } else {
              this.activityDetail.beginTime =
                activityInfo.startTime + " " + sfm;
            }
          }
          if (activityInfo.endTime) {
            if (activityInfo.startTime.length > 10) {
              this.activityDetail.beginTime = activityInfo.startTime;
            } else {
              this.activityDetail.beginTime =
                activityInfo.startTime + " " + sfm;
            }
          }
          if (activityInfo.formItems) {
            const itemArray = activityInfo.formItems.split(",");
            this.resultList = itemArray.map((item) => {
              const matchedItem = this.formList.find((form) =>
                item.includes(form.label)
              );
              if (matchedItem) {
                return { label: matchedItem.label, type: matchedItem.type };
              }
              return { label: item, type: -99 }; //手动添加了专属
            });
            console.log("处理后的表单项:", this.resultList);

            this.resultList.forEach((item) => {
              // console.log(item,item.label,item.type);
              this.addForm(item.type, item.label);
            });
          }
          console.log("赋值后的name:", this.activityDetail.name);
          console.log("赋值后的content:", this.activityDetail.content);
        }
      }
    },
    foreverValidChange(e) {
      this.foreverValidChecked = e;
      if (e == true) {
        this.activityDetail.endTime = "2099-12-31 23:59:59";
      }
    },
    foreverHxValidChange(e) {
      this.foreverTimeHxChecked = e;
      if (e == true) {
        this.activityDetail.verificationStartTime = "2099-12-31 23:59:59";
      }
    },
    foreverQdValidChange(e) {
      this.foreverTimeQdChecked = e;
      if (e == true) {
        this.activityDetail.signInEndTime = "2099-12-31 23:59:59";
      }
    },
    selectOptionClick(e) {
      console.log(e);
      this.formClock.clockSupplyType = e;
      if (e == 0) {
        this.supplyTxt = "总共";
      }
      if (e == 3) {
        this.supplyTxt = "每天";
      }
      if (e == 2) {
        this.supplyTxt = "每周";
      }
      if (e == 1) {
        this.supplyTxt = "每月";
      }
      this.disbandBox = true;
    },
    confirmModal() {
      if (this.clockSupplyCenterText === "") {
        this.$message("补卡次数不能为空");
        return false;
      }
      this.formClock.supplyTimes = this.clockSupplyCenterText;
      this.clockSupplyText = this.formClock.supplyTimes;
      this.clockSupplyShow = true;
      this.disbandBox = false;
    },
    saveToDraft() {
      this.$confirm("是否保存为草稿?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.is_draft = 1;
          // 存为草稿
          this.submit();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    confirmChangeForm() {
      // 走删除接口
      this.isDelOrder = 1;
      this.isDelSignInfoPop = false;
      // 编辑填表项接口
      this._updateSignList(this.signFieldClone, this.activityDetail.id);
    },
    // 分组取消/保存
    popupSaveFzFn(index) {
      if (index == 0) {
        this.subsetShow = false;
      }
      if (index == 1) {
        if (this.subsetCenterValueArr.length === 0) {
          this.$message("分组不能为空");
          return false;
        }
        let enter = true;
        for (let i = 0; i < this.subsetCenterValueArr.length; i++) {
          if (this.subsetCenterValueArr[i].clockInList === "") {
            this.$message(
              this.subsetCenterValueArr[i].listGroupName + "分组名单不能为空"
            );
            enter = false;
            break;
          }
        }
        if (enter == false) {
          return false;
        }
        this.nameAddType = 2;
        this.filteredArr = JSON.parse(
          JSON.stringify(this.subsetCenterValueArr)
        );
        this.updateSignPeoplePicker();
        this.subsetShow = false;
      }
    },
    // 编辑/添加
    addOrEditFz(index) {
      if (index == 0) {
        this.placeholderText1 = "";
        this.handleSubShow = false;
        this.showModal = false;
        this.copyTextAreaShow = false;
        this.modelContentDel = false;
        this.fzValue = "";
      }
      if (index == 1) {
        if (this.fzTitle === "") {
          this.$message("分组名称不能为空");
          return false;
        }
        if (this.fzValue === "") {
          this.$message("分组名单不能为空");
          return false;
        }
        this.subsetCenterValueArr[this.commFzIndex].listGroupName =
          this.fzTitle;
        this.subsetCenterValueArr[this.commFzIndex].clockInList = this.fzValue;

        this.subsetCenterValueArr.forEach((item) => {
          var reg = /([\n\r])+/g;
          var str = item.clockInList.replace(reg, "\n");
          let arr = str.split(/[\n+,，；;]/g);
          arr = arr.filter((item) => item != "");
          console.log(arr, "啥情况啊，这里怎么就不对呢");
          item.clockInListNum = arr.length;
        });

        this.handleSubShow = false;
        this.showModal = false;
        this.copyTextAreaShow = false;
        this.modelContentDel = false;
        this.fzValue = "";
        this.placeholderText1 = "";
        this.activityDetail.clockNameNumberSwitch = this.clockNameNumberSwitch;
      }
    },
    // 更新下拉选项 更新为全部
    updateSignPeoplePicker() {
      this.subsetValueArr = JSON.parse(
        JSON.stringify(this.subsetCenterValueArr)
      );
      this.pickerName = "全部";
      // 更新分组的下拉
      this.pickerNameSelectArr = [
        {
          label: "全部",
          value: 0,
        },
      ];
      var subArr = [];
      this.subsetValueArr.forEach((item, subIndex) => {
        subArr.push({
          label: item.listGroupName,
          value: subIndex + 1,
        });
      });
      const uniqueArr = [...new Set(subArr)];
      this.pickerNameSelectArr.push(...uniqueArr);

      // 更新全部名单
      let valueAll = "";
      this.subsetValueArr.forEach((son, i) => {
        valueAll += "," + son.clockInList;
      });
      // 处理一下 变成数组 可能需要做监听？
      var reg = /([\n\r])+/g;
      valueAll = valueAll.trim().replace(reg, "\n");
      let arr = valueAll.split(/[\n+,，；;]/g);
      arr = arr.filter((item) => item != "");
      this.nameListLength = arr.length; // 更新名单人数
      this.packetData = arr;
    },
    clockNameNumberSwitchChange(e) {
      this.clockNameNumberSwitch = e;
      this.activityDetail.clockNameNumberSwitch = e;
    },
    clockSwitchFn(e) {
      this.clockSwitch = e;
      this.activityDetail.clockSwitch = e;
    },
    downloadNameBox() {
      this.downListShow = true;
      this.downloadBoxShow = true;
      this.$refs.downloadBox.open();
    },
    downloadGzhQrcode() {
      this.downloadImage(this.gzhQrcodeSrc, "接龙情况通知");
    },
    downloadImage(imgsrc, name = "qrcode") {
      if (!imgsrc) return;
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.fillStyle = "#FFFFFF";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.download = name || "qrcode";
        a.href = url;
        a.click();
      };
      image.src = imgsrc;
    },
    // 清空
    emptyFn() {
      this.fzValue = "";
      this.fzNameArr = [];
      this.onlyGroupArr = [];
    },
    // 预存名单
    prestore() {
      // uni.navigateTo({
      //     url: '/pages-mine/nameList/nameList'
      // })
    },

    // 选择分组
    selectGrouping(e) {
      const selectedItem = this.pickerNameSelectArr.find(
        (item) => item.value === e
      );
      this.pickerName = selectedItem ? selectedItem.label : "全部";
      this.pickerNameSelectShow = false;
      // 切换下面的数据
      // 筛选逻辑（示例：保留所有 listGroupName 存在的项）
      if (e != 0) {
        this.filteredArr = this.subsetValueArr.filter((item) => {
          return item.listGroupName === this.pickerName; // 精确匹配
        });
      } else {
        this.filteredArr = JSON.parse(JSON.stringify(this.subsetValueArr));
      }

      // 筛选packetData
      let valueAll = "";
      this.filteredArr.forEach((son, i) => {
        valueAll += "," + son.clockInList;
      });
      // 处理一下 变成数组 可能需要做监听？
      var reg = /([\n\r])+/g;
      valueAll = valueAll.trim().replace(reg, "\n");
      let arr = valueAll.split(/[\n+,，；;]/g);
      arr = arr.filter((item) => item != "");
      this.packetData = arr;
    },

    // 减去
    subtractFzItem(index) {
      this.subsetCenterValueArr.splice(index, 1);
      // 重新调整分组名称，确保连续
      this.subsetCenterValueArr.forEach((item, idx) => {
        item.listGroupName = `分组${idx + 1}`;
      });
    },
    // 编辑
    editFzItem(index, item) {
      this.placeholderText1 = "";
      this.commFzInfo = item;
      this.commFzIndex = index;
      this.fzPopItemInfo = JSON.parse(JSON.stringify(item));
      // 处理数据
      this.handleSubShow = true;
      this.modelContentDel = true;
      this.fzTitle = this.fzPopItemInfo.listGroupName;

      this.fzValue = this.fzPopItemInfo.clockInList;
      this.handlerBlurFz();

      this.showModal = true;
      this.copyTextAreaShow = true;
      this.modelContentDel = true;

      setTimeout(() => {
        this.placeholderText1 =
          "请输入姓名名单，每个名单可用中英文逗号,换行隔开，最大输入为1000个名单。可复制粘贴";
      }, 350);
    },
    addFzItem() {
      const length = this.subsetCenterValueArr.length + 1;
      var obj = {
        clockInList: "",
        listGroupName: "分组" + length,
      };
      this.subsetCenterValueArr.push(obj);
    },
    relayList() {
      this.nameAddOptionsShow = true;
    },
    nameAddChange() {
      // this.nameAddType = this.nameOrGroup;
      if (this.nameOrGroup == 0) {
        this.nameAddOptionsShow = false;
        this.clockSwitch = 1;
        this.activityDetail.clockSwitch = 1;
      }

      if (this.nameOrGroup == 1) {
        this.nameAddType = 1;
        this.clockSwitch = 2;
        this.activityDetail.clockSwitch = 2;

        this.openNameListDrawerFun();

        this.nameAddOptionsShow = false;
      }
      if (this.nameOrGroup == 2) {
        this.nameAddType = 2;
        this.clockSwitch = 2;
        this.activityDetail.clockSwitch = 2;
        // 更新中间值
				this.subsetCenterValueArr = JSON.parse(
					JSON.stringify(this.subsetValueArr),
				);
        // 如果没有分组，创建两个分组：第一个有默认姓名，第二个为空
				if (this.subsetCenterValueArr.length === 0) {
					this.subsetCenterValueArr = [
						{
							clockInList: "李某某,王某某",
							listGroupName: "分组1",
							clockInListNum: 2
						},
						{
							clockInList: "",
							listGroupName: "分组2",
							clockInListNum: 0
						}
					];
				} else {
					// 确保至少有两个分组
					if (this.subsetCenterValueArr.length < 2) {
						// 如果只有一个分组，添加第二个空分组
						if (this.subsetCenterValueArr.length === 1) {
							// 如果第一个分组没有姓名，添加默认姓名
							if (!this.subsetCenterValueArr[0].clockInList || this.subsetCenterValueArr[0].clockInList.trim() === "") {
								this.subsetCenterValueArr[0].clockInList = "李某某,王某某";
								this.subsetCenterValueArr[0].clockInListNum = 2;
							}
							// 添加第二个空分组
							this.subsetCenterValueArr.push({
								clockInList: "",
								listGroupName: "分组2",
								clockInListNum: 0
							});
						}
					} else {
						// 如果已有两个或更多分组，确保第一个分组有默认姓名（如果为空）
						if (!this.subsetCenterValueArr[0].clockInList || this.subsetCenterValueArr[0].clockInList.trim() === "") {
							this.subsetCenterValueArr[0].clockInList = "李某某,王某某";
							this.subsetCenterValueArr[0].clockInListNum = 2;
						}
					}
				}

				this.subsetCenterValueArr.forEach((item) => {
					var reg = /([\n\r])+/g;
					var str = item.clockInList.replace(reg, "\n");
					let arr = str.split(/[\n+,，；;]/g);
					arr = arr.filter((item) => item != "");
					item.clockInListNum = arr.length;
					if (item.listGroupName == "") {
						item.listGroupName = "分组" + (this.subsetCenterValueArr.indexOf(item) + 1);
					}
				});

				// 不立即同步到 subsetValueArr，只在保存时才同步

				// 更新分组的下拉列表（根据subsetValueArr，因为这是实际保存的值）
				// 如果subsetValueArr为空，显示默认分组1
				this.pickerName = "全部";
				this.pickerNameSelectArr = [
					{
						label: "全部",
						value: 0,
					},
				];
				var subArr = [];
        if (this.subsetValueArr && this.subsetValueArr.length > 0) {
                    // 只将有数据的分组加入下拉列表
                    this.subsetValueArr.forEach((item, subIndex) => {
                        let clockInList = item.clockInList || "";
                        clockInList = clockInList.trim();
                        // 只添加有数据的分组
                        if (clockInList !== "") {
                            subArr.push({
                                label: item.listGroupName || `分组${subIndex + 1}`,
                                value: subIndex + 1,
                            });
                        }
                    });
                }
                // 如果所有分组都没有数据，显示默认分组1
                if (subArr.length === 0) {
                    subArr.push({
                        label: "分组1",
                        value: 1,
                    });
                }
        const uniqueArr = [...new Set(subArr)];
        this.pickerNameSelectArr.push(...uniqueArr);
        if (!this.packetData || this.packetData.length === 0) {
          // 从subsetCenterValueArr的第一个分组获取数据
          if (this.subsetCenterValueArr.length > 0 && this.subsetCenterValueArr[0].clockInList) {
            var reg = /([\n\r])+/g;
            let nameList = this.subsetCenterValueArr[0].clockInList;
            nameList = nameList.trim().replace(reg, "\n");
            let arr = nameList.split(/[\n+,，；;]/g);
            arr = arr.filter(item => item != "");
            this.packetData = arr;
            this.nameListLength = arr.length;
          } else {
            // 如果没有分组数据，设置默认值
            this.packetData = ["李某某", "王某某"];
            this.nameListLength = 2;
          }
        }

        this.subsetShow = true;
        this.nameAddOptionsShow = false;
      }
    },
    // 提示--上传图片
    uploadPromptImage(event) {
      this.selectedFile = event.target.files[0];
      var pettern = /^image/;
      if (!pettern.test(this.selectedFile.type)) {
        this.$message("文件格式不正确");
        return;
      }
      if (this.selectedFile.size / 1048576 > 5) {
        this.$message("图片大小小于5M");
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularImg",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          var data = response.data;
          if (data.status == 1) {
            this.propertyData.promptImage = data.msg;
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
        });
    },
    //属性设置提交
    propertySet() {
      if (this.propertyData.type == 4) {
        if (this.propertyData.isRequired == 0) {
          this.propertyData.minValue = 0;
        }
        if (this.propertyData.isRequired == 1) {
          if (this.propertyData.minValue == 0) {
            this.propertyData.minValue = 1;
          }
        }
        // 如果是多选，最少不能大于最多
        if (
          this.propertyData.maxValue != 0 &&
          this.propertyData.minValue > this.propertyData.maxValue
        ) {
          this.$message("最少可选不能大于最多可选");
          return false;
        }
      }
      if (
        this.propertyData.type == 5 &&
        this.propertyData.watermarkSwitch == 1 &&
        this.propertyData.watermarkTimeOrPosition.length == 0
      ) {
        this.$message("最少选择一个水印类型");
        return;
      }

      // this.propertyData.isRequiredChecked == true?this.propertyData.isRequired = 1 : this.propertyData.isRequired = 0
      // this.propertyData.isOpenChecked == true?this.propertyData.isOpen = 1 : this.propertyData.isOpen = 0
      this.listList[0].signField[this.commIndex] = { ...this.propertyData };
      console.log(
        this.listList[0].signField[this.commIndex].isRequired,
        "信息-公开必填"
      );
      console.log(this.propertyData.isRequired, "信息-属性设置");
      this.propertySetShow = false;
    },
    imgNumCheckChange(e) {
      this.propertyData.imageUploadLimit = e;
    },
    // 文本格式-
    formatCheckChange(e) {
      this.propertyData.isFormatCheck = e;
    },
    // 属性设置-
    attributeSet(info, index) {
      this.commIndex = index;
      this.commType = info.type;
      info.currentIndex = index;
      this.propertyData = { ...info };
      // 对于type 5的字段，确保annotationPermission有默认值（如果为null或undefined，设置为"2"）
      if (this.propertyData.type == 5) {
        if (this.propertyData.annotationPermission === null || this.propertyData.annotationPermission === undefined || this.propertyData.annotationPermission === "") {
          this.propertyData.annotationPermission = "2";
        } else {
          // 确保是字符串类型，因为开关使用的是字符串 "1" 和 "2"
          this.propertyData.annotationPermission = String(this.propertyData.annotationPermission);
        }
      }
      this.commType = this.propertyData.type;
      this.tipsContent = this.propertyData.promptExplanation;
      this.propertySetShow = true;
    },

    openStudyPopup(type) {
      this.studyContent =
        "开启后，参与人可在地图中搜索定位，若需要显示参与人实时位置，请不要开启";
      this.$refs.studyBox.open();
    },
    closeStudyBox() {
      this.$refs.studyBox.close();
    },
    // 批量
    batchOptions() {
      this.lineCopywriting = "";
      this.placeholderContent = "";
      this.batchOptionShow = true;
    },
    closeBatch() {
      this.placeholderContent = "";
      this.$refs.batchAdd.close();
      this.lineCopywriting = "";
    },
    // 换行添加
    addLineBreak() {
      if (this.lineCopywriting == "") {
        this.$message("请添加选项");
        return false;
      }
      var ary = this.lineCopywriting.split("\n");
      if (ary.length > 15) {
        this.$message("一行一个选项，最大支持添加15个");
        return false;
      }
      for (var i = 0; i < ary.length; i++) {
        if (ary[i] != null && ary[i].trim() != "") {
          var inp = {
            value: ary[i],
          };
          this.propertyData.content.push(inp);
        }
      }
      this.lineCopywriting = "";
      this.placeholderContent = "";
      this.batchOptionShow = false;
    },
    // 添加选项
    addOption() {
      var obj = {
        value: "",
      };
      this.propertyData.content.push(obj);
    },
    //删除轮播图
    trash(index) {
      if (this.propertyData.content.length == 1) {
        this.$message("请至少保留一项");
        return false;
      }
      this.propertyData.content.splice(index, 1);
      if (
        Number(this.propertyData.maxValue) >= this.propertyData.content.length
      ) {
        this.propertyData.maxValue = this.propertyData.content.length;
      }
      if (
        Number(this.propertyData.minValue) >= this.propertyData.content.length
      ) {
        this.propertyData.minValue = this.propertyData.content.length;
      }
    },
    // 上移
    upTr(index) {
      if (index == 0) {
        this.$message("已经是第一项");
        return false;
      }
      //在上一项插入该项
      this.propertyData.content.splice(
        index - 1,
        0,
        this.propertyData.content[index]
      );
      //删除后一项
      this.propertyData.content.splice(index + 1, 1);
    },
    // 下移
    downTr(index) {
      if (index == this.propertyData.content.length - 1) {
        this.$message("已经是最后一项");
        return false;
      }
      //在下一项插入该项
      this.propertyData.content.splice(
        index + 2,
        0,
        this.propertyData.content[index]
      );
      // 删除前一项
      this.propertyData.content.splice(index, 1);
    },
    // 日期
    attributeTimeChange(type, index) {
      this.propertyData.timeSelectType = Number(index);
      this.$forceUpdate();
      console.log(
        this.propertyData.timeSelectType,
        "this.propertyData.timeSelectType"
      );
      console.log(index, "index");
    },
    // 地域
    attributeAreaChange(type, index) {
      this.propertyData.areaSelectType = index;
      this.$forceUpdate();
    },
    attributeDateChange(type, index) {
      this.propertyData.dateSelectType = index;
      this.$forceUpdate();
    },

    checkFun(n) {
      console.log(n);
      if (this.propertyData.type == 4) {
        if (this.propertyData.isRequired == 0) {
          this.propertyData.minValue = 0;
        }
        if (this.propertyData.isRequired == 1) {
          this.propertyData.minValue = 1;
        }
      }
      this.propertyData.isRequired = n;
    },
    openFn(n) {
      this.propertyData.isOpen = n;
    },

    addgljl(idx) {
      this.modulCommonIndex = idx;
      // 获取当前已关联的活动ID数组
      const associatedIds =
        this.modularList[this.modulCommonIndex].info.associationActivityId ||
        [];

      // 遍历relatedList，设置checked状态
      this.relatedList = this.relatedList.map((item) => {
        return {
          ...item,
          checked: associatedIds.some(
            (associatedItem) => associatedItem.id === item.id
          ),
        };
      });

      this.relatedDrawerShow = true;
    },
    relateItemChange(e, info, index) {
      info.checked = e;
    },
    relatedAdd() {
      const newArray = [];
      this.relatedList.forEach((item) => {
        if (item.checked === true) {
          const newItem = {
            id: item.id,
            name: item.name,
            activity_type: item.activity_type,
            activity_big_type: item.activity_big_type,
          };
          newArray.push(newItem);
        }
      });
      this.modularList[this.modulCommonIndex].info.associationActivityId =
        newArray;
      this.relatedDrawerShow = false;
    },
    delRelatedFiles(fileIndex, fatherIndex) {
      this.modularList[fatherIndex].info.associationActivityId.splice(
        fileIndex,
        1
      );
    },
    async getRelatedList() {
      if (this.isLoading) return; // 防止重复加载
      this.isLoading = true;
      const { data, msg, status } = await getCreateList({
        pageNum: this.pageNum,
        pageSize: 15,
        activityBigType: "",
        recordType: 1,
        isDraft: "",
        activityType: "",
        activeState: this.activeState,
        timeRange: "",
        startTime: "",
        endTime: "",
        sortType: 1,
        activityName: "",
      });
      if (this.pageNum == 1) {
        this.relatedList = [];
      }
      this.totalRow = data.total;
      this.pages = data.pages;
      this.pageNum = data.pageNum;
      data.list.forEach((item, index) => {
        item.checked = false;
      });

      // 过滤掉当前活动 ID 的数据
      const filteredList = data.list.filter(
        (item) => item.id.toString() !== this.activityId.toString()
      );
      this.relatedList = this.relatedList.concat(filteredList);
      this.$forceUpdate();
    },

    relatedDrawerClose() {
      this.relatedDrawerShow = false;
    },
    subsetDrawerClose() {
      // 检查是否有有效数据（检查subsetValueArr，因为subsetCenterValueArr是中间值，可能被修改但未保存）
      let hasData = false;
      if (this.subsetValueArr && this.subsetValueArr.length > 0) {
        // 检查是否有分组包含非空的名单
        hasData = this.subsetValueArr.some(item => {
          let clockInList = item.clockInList || "";
          clockInList = clockInList.trim();
          return clockInList !== "";
        });
      }

      // 如果没有数据，设置为默认分组1
      if (!hasData) {
        this.subsetValueArr = [
          {
            clockInList: "李某某,王某某",
            listGroupName: "分组1",
          }
        ];
        // 更新packetData和nameListLength
        var reg = /([\n\r])+/g;
        let nameList = "李某某,王某某";
        nameList = nameList.trim().replace(reg, "\n");
        let arr = nameList.split(/[\n+,，；;]/g);
        arr = arr.filter(item => item != "");
        this.packetData = arr;
        this.nameListLength = arr.length;
      }

      // 更新分组的下拉列表（只将有数据的分组加入下拉列表）
      this.pickerName = "全部";
      this.pickerNameSelectArr = [
        {
          label: "全部",
          value: 0,
        },
      ];
      var subArr = [];
      if (this.subsetValueArr && this.subsetValueArr.length > 0) {
        // 只将有数据的分组加入下拉列表
        this.subsetValueArr.forEach((item, subIndex) => {
          let clockInList = item.clockInList || "";
          clockInList = clockInList.trim();
          // 只添加有数据的分组
          if (clockInList !== "") {
            subArr.push({
              label: item.listGroupName || `分组${subIndex + 1}`,
              value: subIndex + 1,
            });
          }
        });
      }
      // 如果所有分组都没有数据，显示默认分组1
      if (subArr.length === 0) {
        subArr.push({
          label: "分组1",
          value: 1,
        });
      }
      const uniqueArr = [...new Set(subArr)];
      this.pickerNameSelectArr.push(...uniqueArr);

      // 清空中间值
      this.subsetCenterValueArr = [];
      this.subsetShow = false;
    },
    handleSubDrawerClose() {
      this.handleSubShow = false;
    },

    propertyDrawerClose() {
      this.propertySetShow = false;
    },

    openMusic(info) {
      var link = info.fileUrl;
      this.musicLink = this.imageUrl + link;
      this.musicDialog = true;
    },

    async submit() {
      if (this.isrepeatClick) {
        return;
      }
      this.isrepeatClick = true;

      if (
        this.is_draft == 0 &&
        Number(this.activityDetail.enablePush) === 1
      ) {
        const isFollowed = await this.checkWechatFollowStatus({
          showDialog: true,
        });
        if (!isFollowed) {
          this.activityDetail.enablePush = 2;
        }
      }

      //校验是否填写了接龙标题
      if (this.activityDetail.name == "" || this.activityDetail.name == null) {
        this.$message("请填写接龙标题");
        this.isrepeatClick = false;
        return false;
      }
      if (this.selectType == "add") {
        this.activityDetail.templateId = this.activityDetail.id;
        delete this.activityDetail.id;
      }

      // 如果不是草稿
      if (this.is_draft == 0) {
        var isStop = false;
        var isture = true;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.isType == "104"
        ) {
          var formClockObj = this.formClock;
          if (formClockObj.clockRemindStatus == 1) {
            if (formClockObj.remindTime == "") {
              this.$message("打卡提醒时间不能为空！");
              isture = false;
              this.isrepeatClick = false;
            }
          }

          if (formClockObj.clockSupplyStatus == 1) {
            if (formClockObj.supplyTimes === "") {
              this.$message("允许补卡次数不能为空！");
              isture = false;
              this.isrepeatClick = false;
            }
          }

          if (formClockObj.clockLocationStatus == 1) {
            if (formClockObj.address == "") {
              this.$message("地点位置不能为空！");
              isture = false;
              this.isrepeatClick = false;
            } else if (formClockObj.clockRange == "") {
              this.$message("打卡范围不能为空！");
              isture = false;
              this.isrepeatClick = false;
            }
          }

          // 判断是否选中日期
          if (this.selectFrequency == 7) {
            if (this.customDateArr.length == 0) {
              this.$message("请选择日期！");
              isture = false;
              this.isrepeatClick = false;
            }
          }
          // 自定义周几：是否选择周几
          if (this.selectFrequency == 6) {
            if (formClockObj.clockFrequency == "") {
              this.$message("请选择周几打卡！");
              isture = false;
              this.isrepeatClick = false;
            }
          }
        }

        if (this.activityDetail.removeSignStatus == 3) {
          if (this.activityDetail.removeSignEndTime == null) {
            this.$message("自定义开始日期不能为空");
            isture = false;
          } else if (this.activityDetail.removeSignBeginTime == null) {
            this.$message("自定义结束日期不能为空");
            isture = false;
          }
        }
        if (isture == false) {
          this.isrepeatClick = false;
          return;
        }
        // 表单项验证
        if (this.listList[this.indexIdx]) {
          this.listList[this.indexIdx].signField.map((item, index) => {
            if (isStop) {
              this.isrepeatClick = false;
              return;
            }

            if (item.name == "") {
              isStop = true;
              this.$message("请填写第" + (index + 1) + "个报名信息列");
              this.isrepeatClick = false;
            }
            if (item.type == 1) {
              if (item.fieldName == "") {
                isStop = true;
                this.$message("请填写填空标题");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 9) {
              if (item.fieldName == "") {
                isStop = true;
                this.$message("请填写多行输入标题");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 2) {
              for (let i = 0; i < item.content.length; i++) {
                for (let j = i + 1; j < item.content.length; j++) {
                  if (item.content[i].value === item.content[j].value) {
                    isStop = true;
                    this.$message("单选选项内容不能重复");
                    this.isrepeatClick = false;
                    break;
                  }
                }
              }

              item.content.map((itm, idx) => {
                if (itm.value == "") {
                  isStop = true;
                  this.$message("请填写单选选项内容");
                  this.isrepeatClick = false;
                }
              });
              if (item.fieldName == "") {
                isStop = true;
                this.$message("请填写单选标题");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 4) {
              for (let i = 0; i < item.content.length; i++) {
                for (let j = i + 1; j < item.content.length; j++) {
                  if (item.content[i].value === item.content[j].value) {
                    isStop = true;
                    this.$message("多选选项内容不能重复");
                    this.isrepeatClick = false;
                    break;
                  }
                }
              }
              item.content.map((itm, idx) => {
                if (itm.value == "") {
                  isStop = true;
                  this.$message("请填写多选选项内容");
                  this.isrepeatClick = false;
                }
              });
              if (item.fieldName == "") {
                isStop = true;
                this.$message("请填写多选标题");
                this.isrepeatClick = false;
              }
            }
          });
        }
        if (this.activityDetail.removeSignStatus == 3) {
          if (
            this.activityDetail.removeSignBeginTime &&
            this.activityDetail.removeSignEndTime
          ) {
            if (
              new Date(this.activityDetail.removeSignBeginTime).getTime() >
              new Date(this.activityDetail.removeSignEndTime).getTime()
            ) {
              isStop = true;
              this.$message("结束日期不能小于开始日期");
              this.isrepeatClick = false;
            }
          }
        }
        if (this.activityDetail.beginTime && this.activityDetail.endTime) {
          if (
            new Date(this.activityDetail.beginTime).getTime() >
            new Date(this.activityDetail.endTime).getTime()
          ) {
            isStop = true;
            this.$message("结束时间不能小于开始时间");
            this.isrepeatClick = false;
          }
        }

        // 签到码
        if (
          this.activityDetail.signInSwitch == 2 &&
          this.activityDetail.signLocationSwitch == 2
        ) {
          if (!this.activityDetail.signInAddress) {
            isStop = true;
            this.$message("请选择指定参与地点");
            this.isrepeatClick = false;
          }
          if (!this.activityDetail.signLocationDistance) {
            isStop = true;
            this.$message("请选择参与范围");
            this.isrepeatClick = false;
          }
        }

        if (isStop) {
          this.isrepeatClick = false;
          return;
        }
      }

      this.activityDetail.signShowType = this.showName == "列表接龙" ? 1 : 2;

      this.activityDetail.shareTitle = "";
      this.activityDetail.shareCotent = "";
      this.activityDetail.shareBtnWord = "";
      this.activityDetail.shareBack = "";
      this.activityDetail.shareLogo = "";
      this.activityDetail.shareImg = "";

      // 高级设置
      this.activityDetail.shareStatus = this.shareStatus;
      this.activityDetail.commentStatus = this.commentStatus;
      this.activityDetail.updateSignInfo = this.updateSignInfo;
      this.activityDetail.confirmWord = this.confirmWord;
      this.activityDetail.copyStatus = this.copyStatus;

      // 新加的 2024/8/1
      this.activityDetail.isanonymous = this.isanonymous;
      this.activityDetail.publisher =
        this.publisher || localStorage.getItem("jlnickname"); //发布人姓名
      this.activityDetail.is_notice = this.is_notice; //接龙情况通知开关

      this.activityDetail.copywriting = this.copywriting; //自定义文案
      this.activityDetail.copyimage = this.copyimage; //自定义图片

      this.activityDetail.is_destination = this.is_destination; //指定接龙位置
      this.activityDetail.deliveryaddress = this.deliveryaddress; //指定接龙位置坐标

      this.activityDetail.submitcopy =
        this.isType == "109" || this.submitcopy ? this.submitcopy : "提交"; //报名页面提交按钮文案
      this.activityDetail.registrationtime = this.registrationtime; //修改报名信息开始时间
      this.activityDetail.endregistrationtime = this.endregistrationtime; //修改报名信息结束时间
      this.activityDetail.custombutton = 1; //uni.getStorageSync('custombutton')//自定义按钮标题，总开关
      this.activityDetail.checkinrange = this.checkinrange; //打卡范围
      this.activityDetail.anonymousparticipation = this.anonymousparticipation; //匿名参与
      this.activityDetail.specifyaddress = this.specifyaddress;

      this.activityDetail.deleteregistration = this.deleteregistration; //修改报名信息
      this.activityDetail.startdeletingtime = this.startdeletingtime; //删除报名信息开始时间
      this.activityDetail.enddeletingtime = this.enddeletingtime; //修改报名信息结束时间

      this.activityDetail.is_forward = this.is_forward;
      this.activityDetail.thumbs_up = this.thumbs_up;
      this.activityDetail.chatSwitch = this.chatSwitch;
      this.activityDetail.is_comment = this.is_comment;
      this.activityDetail.is_score = this.is_score;
      this.activityDetail.isMessage = this.isMessage;
      this.activityDetail.showRanking = this.showRanking;
      this.activityDetail.musicId = "";
      this.activityDetail.musicName = "";

      // 创建 - 处理封面赋值
      this.activityDetail.activityModeUrl = this.activityModeUrl;
      this.activityDetail.vid = this.vid;
      this.activityDetail.playUrl = this.playUrl;
      this.activityDetail.isVideo = this.isVideo;
      this.activityDetail.isCoverEnabled = this.isCoverEnabled;
      this.activityDetail.subCoverImages = this.subCoverImages
        ? this.subCoverImages.join(",")
        : "";

      // 3.4更新
      this.activityDetail.phoneSwitch = this.phoneSwitch;
      this.activityDetail.userPhone = this.userPhone;

      if (
        this.activityDetail.phoneSwitch == 2 &&
        this.activityDetail.userPhone == ""
      ) {
        this.$message("请填写联系信息");
        isStop = true;
      }

      this.activityDetail.contactType = this.contactType;
      if (this.activityDetail.phoneSwitch == 2) {
        // 根据contactType进行验证
        if (this.contactType == 1) {
          // 手机号验证
          const phoneRegex = /^1[3-9]\d{9}$/;
          if (!phoneRegex.test(this.userPhone)) {
            this.$message("请输入正确的手机号");
            isStop = true;
          }
        } else if (this.contactType == 2) {
          // 微信号验证
          const wechatRegex = /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
          if (!wechatRegex.test(this.userPhone)) {
            this.$message("请输入正确的微信号");
            isStop = true;
          }
        } else if (this.contactType == 3) {
          // 手机号和微信同号验证
          const phoneRegex = /^1[3-9]\d{9}$/;
          if (!phoneRegex.test(this.userPhone)) {
            this.$message("请输入正确的手机号或微信号");
            isStop = true;
          }
        }
      }

      if (isStop) {
        this.isrepeatClick = false;
        return;
      }

      const time = new Date();
      const nowTime = this.timestampToTime(time);
      this.activityDetail.beginTime = this.activityDetail.beginTime
        ? this.activityDetail.beginTime
        : nowTime;

      // 转格式
      this.modular1 = JSON.parse(JSON.stringify(this.modularList));
      this.modular1.map((item, index) => {
        if (this.is_draft == 0) {
          if (isStop) {
            this.isrepeatClick = false;
            return;
          }
          if (item.type == 1 && item.info.value == "") {
            isStop = true;
            this.$message("请填写接龙标题");
          } else if (item.type == 2 && item.info.value == "") {
            isStop = true;
            this.$message("请填写接龙内容");
          } else if (item.type == 3 && item.info.imgarr.length == 0) {
            isStop = true;
            this.$message("请上传图片");
          } else if (item.type == 9 && item.info.imgarr.length == 0) {
            isStop = true;
            this.$message("请上传大图模块图片");
          } else if (
            item.type == 4 &&
            (item.info.latitude == "" || item.info.longitude == "")
          ) {
            isStop = true;
            this.$message("请选择地址");
          } else if (item.type == 5 && item.info.fileUrl == "") {
            isStop = true;
            this.$message("请上传文件");
          } else if (item.type == 6 && item.info.filesArr.length == 0) {
            isStop = true;
            this.$message("请上传音频");
          } else if (item.type == 7 && item.info.fileUrl == "") {
            isStop = true;
            this.$message("请上传视频");
          }
          if (item.type == 8 && item.info.link == "") {
            isStop = true;
            this.$message("请填写公众号链接");
          }
          if (item.type == 8 && item.info.officialAccountTitle == "") {
            isStop = true;
            this.$message("请填写公众号文章标题");
          }
          if (
            item.type == 9 &&
            (item.info.videoId == "" || item.info.videoNumberID == "")
          ) {
            isStop = true;
            this.$message("请填写视频号信息");
          }
          if (
            item.type == 12 &&
            (item.info.appid == "" ||
              item.info.pagePath == "" ||
              item.info.appTitle == "")
          ) {
            isStop = true;
            this.$message("请填写其他小程序信息");
          }
          if (item.type == 11 && item.copy_region_conten == "") {
            isStop = true;
            this.$message("请填写一键复制区信息");
          }
        }
        item.info = JSON.stringify(item.info);
      });

      // 如果不是草稿
      if (this.is_draft == 0) {
        if (this.activityDetail.is_destination == 1) {
          if (this.activityDetail.specifyaddress == "") {
            this.$message("请选择指定参与地点");
            isStop = true;
          } else if (this.activityDetail.checkinrange == "") {
            this.$message("参与范围不能为空");
            isStop = true;
          }
        }
        if (isStop) {
          this.isrepeatClick = false;
          return;
        }
      }

      this.submitFn();
    },
    submitFn() {
      console.log("去创建");
      const appliction = []; //报名填表项
      let fmClockIn = {};
      let clockInList;
      let projectDelIds;

      if (
        this.isType == "109" ||
        this.isType == "110" ||
        this.isType == "104"
      ) {
        fmClockIn = this.formClock;
      }
      clockInList = this.subsetValueArr;
      this.activityDetail.coverImg = this.baseurl;
      this.activityDetail.createSource = 2; //创建来源 1:小程序 2:pc
      let signFieldClone = "";
      signFieldClone = JSON.parse(JSON.stringify(this.listList));
      signFieldClone[this.indexIdx].signField.push(...this.delListInfo);
      signFieldClone.map((item, index) => {
        item.signField.map((itm) => {
          if (itm.content != "" && itm.content != null) {
            //同步maxNum到fmFieldNumList
            this.syncMaxNumToFieldNumListForSave(itm);
            return (itm.content = JSON.stringify(itm.content));
          } else {
            return {};
          }
        });
      });
      this.signFieldClone = signFieldClone;
      this.loadingShow = this.$loading({
        lock: true,
        text: "保存中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.activityDetail.activityType = this.isType;

      // 创建/编辑活动
      updateActivity({
        ...this.activityDetail,
        endTime: this.foreverValidChecked
          ? "2099-12-31 23:59:59"
          : this.activityDetail.endTime,
        // signList: signFieldClone,
        modular: this.modular1,
        modularDelIds: this.modularDelIds,
        //"removeSignStatus":this.removeSignStatus, //新修改
        multipleActivitiesStatus: this.multipleActivitiesStatus,
        projectVos: appliction, ///报名填表项
        fmClockIn: fmClockIn, //打卡
        activityBigType: "1", //接龙大类型 接龙1 通知2
        activityType: this.isType,
        clockInList: clockInList, //预存名单列表
        projectDelIds: projectDelIds,
        groupId: this.groupId ? this.groupId : "",
        interdict_people_num: this.interdict_people_num,
        is_draft: this.is_draft,
        isInFolder: this.folderId ? 2 : (this.isInFolder || 1),
        folderId: this.folderId ? this.folderId : "",
      }).then((res) => {
        if (res.status == 1) {
          // 调用辅助接口updateActivitySignList
          if (this.selectType == "add") {
            try {
              updateActivitySignList({
                id: res.data,
                signList: signFieldClone,
              });
            } catch (error) {
              console.error("调用updateActivitySignList失败:", error);
            }
          }
          if (this.selectType == "update") {
            // 判断填表项的状态，再决定是否保存
            this._isUpdateSignList(signFieldClone, res.data);
          } else {
            this.loadingShow.close();
            this.$message({
              message: "保存成功",
              type: "success",
            });
            // 如果是草稿 跳到index
            if (this.is_draft == 1 && !this.groupId) {
              router.push("/home");
              return false;
            }
            // 如果是群组草稿 跳到群组详情
            if (this.is_draft == 1 && this.groupId) {
              // todo
              return false;
            }

            // todo 去创建成功页 触发commonData.js页中的saveIsOpenShare方法，改变isOpenShare的值为true
            this.saveIsOpenShare(true);
            // 如果在文件夹中创建的，返回文件夹页面
            if (this.folderId) {
              router.replace({
                path: "/folderDetails",
                query: { folderId: this.folderId },
              });
            } else {
              router.replace("/releaseNotes");
            }
          }
        } else {
          this.$message(res.msg);
          this.isrepeatClick = false;
        }
      });
    },
    // 判断填表项状态
    async _isUpdateSignList(signList, id) {
      const result = await isUpdateSignList({
        signList: signList,
        id: this.activityDetail.id,
        userId: this.activityDetail.userId,
      });
      if (result.status == 1) {
        this.loadingShow.close();
        this.isrepeatClick = false;
        this.isDelSignInfoPop = true;
      }
      if (result.status == 2) {
        // 去保存和删除
        this.isDelOrder = "";
        this._updateSignList(signList, id);
      }
    },
    // 编辑填表项
    async _updateSignList(signList, id) {
      const result = await updateSignList({
        signList: signList,
        id: this.activityId,
        userId: this.activityDetail.userId,
      });
      if (result.status == 1) {
        this.loadingShow.close();
        this.$message({
          message: "保存成功",
          type: "success",
        });
        // 如果是草稿 跳到index
        if (this.is_draft == 1) {
          router.push("/home");
          return false;
        }
        // 如果在文件夹中创建的，返回文件夹页面
        if (this.folderId) {
          router.replace({
            path: "/folderDetails",
            query: { folderId: this.folderId },
          });
        } else {
          router.replace("/releaseNotes");
        }
      } else {
        this.loadingShow.close();
        this.$message(result.msg);
        this.isrepeatClick = false;
      }
    },
    // 活动详情
    activityDetailFun() {
      const obj = {};
      if (this.activityKey) {
        obj.activityKey = this.activityKey;
        obj.selectType = this.selectType;
        obj.is_template = this.is_template;
      } else {
        obj.activityId = this.activityId;
        obj.selectType = this.selectType;
        obj.is_template = this.is_template;
      }
      activityDetail({
        ...obj,
      }).then((res) => {
        this.DataScreenUrl = res.data.screenUrl
        this.activityDetail = res.data.activityDetail;
        this.activityId = this.activityDetail.id;
        this.activityDetail.activityId = this.activityId;
        this.activityDetail.id = this.activityId;
        if (res.data.activityDetail.beginTime) {
          this.actStartAndEndTime = [
            res.data.activityDetail.beginTime,
            res.data.activityDetail.endTime,
          ];
        }
        if (this.selectType == "add") {
          var startTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          var endTime = dayjs(startTime)
            .add(1, "month")
            .format("YYYY-MM-DD HH:mm:ss");
          this.activityDetail.beginTime = startTime;
          this.activityDetail.endTime = endTime;
          this.actStartAndEndTime = [startTime, endTime];
        }
        if (this.activityDetail.endTime == "2099-12-31 23:59:59") {
          this.foreverValidChecked = true;
        }

        res.data.modular.map((item) => {
          if (item.type == 4) {
            var obj = {
              lng: 116.403963,
              lat: 39.915119,
            };
            item.location = obj;
          }
          item.info = item.info.replace(/\n/g, "\\n");
          item.info = item.info.replace(/↵/g, " ");
          var info = JSON.parse(item.info);
          if (this.selectType == "add") {
            delete item.id;
            delete item.activityId;
          }
          item.info = info;
        });
        this.modularList = res.data.modular;

        if (res.data.modular.length <= 1) {
          var textarea = document.querySelector(".el-textarea__inner");
          textarea.addEventListener("input", (e) => {
            textarea.style.height = "100px";
            textarea.style.height = e.target.scrollHeight + "px";
          });
        }

        // 填表项
        let signFieldCloneS = "";
        signFieldCloneS = JSON.parse(JSON.stringify(res.data.signList));
        signFieldCloneS.map((itm) => {
          itm.signField.map((item) => {
            item.isUniqueCheckChecked = item.isUniqueCheck == 1 ? true : false;
            item.isRequiredChecked = item.isRequired == 1 ? true : false;
            item.isOpenChecked = item.isOpen == 1 ? true : false;
            if (item.type == 11 || item.type == 10) {
              item.encryption = 1;
            }
            // 对于type 5的字段，确保annotationPermission有默认值（如果为null或undefined，设置为"2"）
            if (item.type == 5) {
              if (item.annotationPermission === null || item.annotationPermission === undefined || item.annotationPermission === "") {
                item.annotationPermission = "2";
              } else {
                // 确保是字符串类型，因为开关使用的是字符串 "1" 和 "2"
                item.annotationPermission = String(item.annotationPermission);
              }
            }
            if (item.content != "" && item.content != null) {
              return (item.content = JSON.parse(item.content));
            } else {
              item["num"] = 3;
              return {};
            }
          });
        });
        this.listList = signFieldCloneS;

        // 接龙名单
        if (res.data.clockNameList && res.data.clockNameList.length) {
          // res.data.clockNameList.forEach(item => {
          //     if (res.data.activityDetail.isTemplate == 1) {
          //         this.packetData.push(item.clockName)
          //     } else {
          //         this.packetData.push(item.clockName)
          //         this.packetData.map((res, index) => {
          //             if (res == "") {
          //                 this.packetData.splice(index, 1)
          //             }
          //         })
          //     }
          // })

          var nameStr = "";
          res.data.clockNameList.forEach((item) => {
            nameStr += item.clockName + ",";
            this.packetData = nameStr.split(",");
            this.packetData.map((res, index) => {
              if (res == "") {
                this.packetData.splice(index, 1);
              }
            });
          });
          this.subsetValueArr = res.data.clockNameList.map((item) => {
            return {
              clockInList: item.clockName,
              listGroupName: item.listGroupName ? item.listGroupName : "",
            };
          });
          // 使用 reduce 按 listGroupName 分组合并
          const mergedArr = Object.entries(
            this.subsetValueArr.reduce((acc, cur) => {
              const key = cur.listGroupName;
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(cur.clockInList);
              return acc;
            }, {})
          ).map(([groupName, clockInLists]) => ({
            listGroupName: groupName,
            clockInList: clockInLists.join(","),
          }));

          console.log(mergedArr, "mergedArrwhat?");
          this.subsetValueArr = mergedArr;

          // 名单人数
          this.nameListLength = this.packetData.length;
          this.pickerName = "全部";
          // 更新分组的下拉
          // 更新分组的下拉
          this.pickerNameSelectArr = [
            {
              label: "全部",
              value: 0,
            },
          ];
          var subArr = [];
          this.subsetValueArr.forEach((item, subIndex) => {
            subArr.push({
              label: item.listGroupName,
              value: subIndex + 1,
            });
          });
          const uniqueArr = [...new Set(subArr)];
          this.pickerNameSelectArr.push(...uniqueArr);

          // 判断是不是分组
          // 检查合并后的数组，如果有多个分组，或者分组名称有实际值（非空字符串），则是分组模式
          // 如果创建时是"仅添加名单"，所有项的listGroupName都是空字符串，合并后只有一个分组
          // 如果创建时是"添加分组+名单"，会有多个分组，或者分组名称有实际值
          const hasMultipleGroups = this.subsetValueArr.length > 1;
          const hasGroupName = this.subsetValueArr.some(item => {
            const groupName = item.listGroupName;
            return groupName && groupName !== "" && groupName.trim() !== "";
          });
          
          if (hasMultipleGroups || hasGroupName) {
            this.nameAddType = 2;
          } else {
            this.nameAddType = 1;
          }
          console.log(this.nameAddType, "是不是分组啊--- 2是1不是");

          this.subsetCenterValueArr = JSON.parse(
            JSON.stringify(this.subsetValueArr)
          );
          this.subsetCenterValueArr.forEach((item) => {
            var reg = /([\n\r])+/g;
            var str = item.clockInList.replace(reg, "\n");
            let arr = str.split(/[\n+,，；;]/g);
            arr = arr.filter((item) => item != "");
            console.log(arr, "啥情况啊，这里怎么就不对呢");
            item.clockInListNum = arr.length;
          });
        }

        // 打卡接龙
        if (res.data.clockInfo) {
          // 这里做了兼容，给两个字段默认值
          this.clockInfoObj = res.data.clockInfo;
          this.formClock = {
            ...res.data.clockInfo,
            checkSwitch: res.data.clockInfo.checkSwitch || 1,
            checkTimes: res.data.clockInfo.checkTimes || 1,
          };
          this.selectData = res.data.clockInfo.clockFrequencyName;
          this.clockFrequencyName = res.data.clockInfo.clockFrequencyName;
          //自定义周几赋值
          res.data.clockInfo.clockFrequency.split(",").forEach((item) => {
            this.candidates.forEach((e) => {
              if (e.value == item) {
                e.checked = "true";
                this.candidateList.push(e.value);
              }
            });
          });
          // 打卡地点
          if (res.data.clockInfo.clockLocationInfo) {
            console.log(
              res.data.clockInfo.clockLocationInfo,
              "res.data.clockInfo.clockLocationInfo"
            );
            this.formClock.address = JSON.parse(
              res.data.clockInfo.clockLocationInfo
            ).address;
            this.formClock.clockRange = res.data.clockInfo.clockRange;
          }
          this.selectFrequency = res.data.clockInfo.clockFrequencyType;
          this.formClock.clockFrequencyType =
            res.data.clockInfo.clockFrequencyType;
          console.log(this.selectFrequency, "this.selectFrequency===");

          // 处理时间段
          if (
            res.data.clockInfo.clockInTimeSlot &&
            res.data.clockInfo.clockInTimeSlot.length
          ) {
            res.data.clockInfo.clockInTimeSlot.forEach((item, index) => {
              item.ifDel = 2;
              // item.startAndEnd = [item.startTime.toString(),item.endTime.toString()]
              const a = [item.startTime.toString(), item.endTime.toString()];
              this.$set(item, "startAndEnd", a);
            });
            this.formClock.clockInTimeSlot = res.data.clockInfo.clockInTimeSlot;

            if (res.data.clockInfo.clockInTimeSlot.length > 1) {
              this.formClock.multiPeriodSwitch = 1;
            }
          }
          this.$forceUpdate();

          // 日期选择
          this.formClock.customDate = res.data.clockInfo.customDate;
          this.customDateArr = res.data.clockInfo.customDate.split(",");
          // 截止日期
          this.formClock.dayOfDate = res.data.clockInfo.dayOfDate;
          this.formClock.timeOfDay = res.data.clockInfo.timeOfDay;
          if (this.selectFrequency == 1) {
            this.monthDay = res.data.clockInfo.dayOfDate;
          }
          if (this.formClock.timeOfDay) {
            var str1 = this.formClock.timeOfDay.substring(0, 2);
            this.endMonthArr2.forEach((item, index) => {
              if (item.value == str1) {
                this.monthHour = index;
              }
            });
          }
          if (this.formClock.timeOfDay) {
            var str2 = this.formClock.timeOfDay.substring(3);
            this.endMonthArr3.forEach((item, index) => {
              if (item.value == str2) {
                this.monthMinute = index;
              }
            });
          }

          this.formClock.clockFrequency = res.data.clockInfo.clockFrequency;
          this.formClock.checkboxValue1 =
            res.data.clockInfo.clockFrequency.split(",");

          this.weekDay = this.formClock.dayOfDate;
          this.monthDay = this.formClock.dayOfDate;

          // 打卡最大次数
          if (
            res.data.clockInfo.clockFrequencyType == 1 ||
            res.data.clockInfo.clockFrequencyType == 2
          ) {
            this.formClock.clockMaxNum = res.data.clockInfo.clockMaxNum;
            if (res.data.clockInfo.clockMaxNum > 1) {
              this.formClock.clockMaxSwitch = 1;
            } else {
              this.formClock.clockMaxSwitch = 2;
            }
            this.$forceUpdate();
          }
          this.interdict_people_num =
            res.data.activityDetail.interdict_people_num;
          this.is_draft = res.data.activityDetail.is_draft;
        } else {
          var clockObj = this.formClock;
          this.clockInfoObj = clockObj;
          if (this.rateType) {
            clockObj.selectFrequency = this.rateType;
            this.selectFrequency = this.rateType;
            clockObj.clockFrequencyType = this.rateType;
            // clockFrequencyName
            if (this.rateType == "1") {
              clockObj.clockFrequencyName = "每月";
            }
            if (this.rateType == "2") {
              clockObj.clockFrequencyName = "每周";
            }
            if (this.rateType == "3") {
              clockObj.clockFrequencyName = "每天";
            }

            if (this.rateType == "4") {
              clockObj.clockFrequencyName = "法定工作日";
            }
            if (this.rateType == "5") {
              clockObj.clockFrequencyName = "法定节假日";
            }
            if (this.rateType == "6") {
              clockObj.clockFrequencyName = "自定义周几打卡";
            }
            if (this.rateType == "7") {
              clockObj.clockFrequencyName = "自定义日期打卡";
            }
            if (this.rateType == "8") {
              clockObj.clockFrequencyName = "一次性打卡";
            }

            this.selectData = clockObj.clockFrequencyName;
            var selectDataArr = {
              value: [clockObj.clockFrequencyName],
            };

            this.clickin(Number(this.rateType));
          }
        }

        // 高级设置
        var detailInfo = res.data.activityDetail;
        this.publisher = detailInfo.publisher
          ? detailInfo.publisher
          : localStorage.getItem("jlnickname");
        this.copyStatus = detailInfo.copyStatus;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.type == "104"
        ) {
          this.confirmWord = "参与打卡";
        } else {
          this.confirmWord = detailInfo.confirmWord;
        }
        this.is_forward = detailInfo.is_forward;
        this.updateSignInfo =
          this.selectType == "update" ? detailInfo.updateSignInfo : 3;
        this.activityDetail.removeSignStatus =
          this.selectType == "update" ? detailInfo.removeSignStatus : 4;
          this.removeSignStatus =  this.selectType == "update" ? detailInfo.removeSignStatus : 4;
        this.copywriting = detailInfo.copywriting;
        this.copyimage = detailInfo.copyimage;
        this.is_destination = detailInfo.is_destination;
        this.deliveryaddress = detailInfo.deliveryaddress;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.isType == "104"
        ) {
          this.submitcopy = "立即打卡";
        } else {
          this.submitcopy = detailInfo.submitcopy;
        }
        this.commentStatus =
          this.selectType == "update" ? detailInfo.commentStatus : 2;
        this.signInfoStatus = detailInfo.signInfoStatus;
        this.custombutton = detailInfo.custombutton;
        this.anonymousparticipation = detailInfo.anonymousparticipation;
        this.deleteregistration = detailInfo.deleteregistration;
        this.checkinrange = detailInfo.checkinrange
          ? detailInfo.checkinrange
          : 2000;
        this.specifyaddress = detailInfo.specifyaddress;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.isType == "104"
        ) {
          this.confirmWord = "参与打卡";
        } else {
          this.confirmWord = detailInfo.confirmWord;
        }
        this.startdeletingtime = detailInfo.startdeletingtime;
        this.enddeletingtime = detailInfo.enddeletingtime;
        // deadline -修改报名信息时间范围
        this.activityDetail.registrationtime = detailInfo.registrationtime;
        this.activityDetail.endregistrationtime =
          detailInfo.endregistrationtime;
        if (detailInfo.registrationtime) {
          this.deadline = [
            detailInfo.registrationtime,
            detailInfo.endregistrationtime,
          ];
        }

        if (detailInfo.removeSignBeginTime) {
          this.deadCancelline = [
            detailInfo.removeSignBeginTime,
            detailInfo.removeSignEndTime,
          ];
        }

        this.thumbs_up = detailInfo.thumbs_up;
        this.chatSwitch = detailInfo.chatSwitch;
        this.is_comment = detailInfo.is_comment;
        this.is_score = detailInfo.is_score;
        this.isMessage = detailInfo.isMessage;
        this.showRanking = detailInfo.showRanking;
        this.activityMode = detailInfo.activityMode;
        this.shareImageStyle = detailInfo.shareImageStyle;
        this.shareZdyImageUrl = detailInfo.shareZdyImageUrl;
        this.clockListNumber = detailInfo.clockListNumber;
        this.checkInStatusSwitch = detailInfo.checkInStatusSwitch;
        this.clockSwitch = detailInfo.clockSwitch.toString();
        this.removeSignStatus = detailInfo.removeSignStatus;
        this.activityDetail.clockSwitch = detailInfo.clockSwitch;

        // 根据clockSwitch和nameAddType设置nameOrGroup
        if (this.clockSwitch == 1 || this.clockSwitch == "1") {
          this.nameOrGroup = 0; // 不启用
        } else if (this.clockSwitch == 2 || this.clockSwitch == "2") {
          if (this.nameAddType == 1) {
            this.nameOrGroup = 1; // 仅添加名单
          } else if (this.nameAddType == 2) {
            this.nameOrGroup = 2; // 添加分组+名单
          }
        }

        this.shareImageUrl = detailInfo.shareImageUrl
          ? detailInfo.shareImageUrl
          : "https://ossfastmake.mustke.com/12jielong/bdJL/sys-defaultShareImg.jpg";
        detailInfo.shareImageUrl = detailInfo.shareImageUrl
          ? detailInfo.shareImageUrl
          : "https://ossfastmake.mustke.com/12jielong/bdJL/sys-defaultShareImg.jpg";
        this.shareZdyImageUrl = detailInfo.shareZdyImageUrl
          ? detailInfo.shareZdyImageUrl
          : "https://ossfastmake.mustke.com/12jielong/bdJL/uploadImgBtn.svg";
        detailInfo.shareZdyImageUrl = detailInfo.shareZdyImageUrl
          ? detailInfo.shareZdyImageUrl
          : "https://ossfastmake.mustke.com/12jielong/bdJL/uploadImgBtn.svg";

        // 编辑 - 处理封面赋值
        this.vid = detailInfo.vid ? detailInfo.vid : "";
        this.playUrl = detailInfo.playUrl ? detailInfo.playUrl : "";
        this.isVideo = detailInfo.isVideo ? detailInfo.isVideo : 2;
        this.isCoverEnabled = detailInfo.isCoverEnabled
          ? detailInfo.isCoverEnabled
          : 1;
        this.subCoverImages = detailInfo.subCoverImages
          ? detailInfo.subCoverImages.split(",")
          : [];
        this.activityModeUrl = detailInfo.activityModeUrl
          ? detailInfo.activityModeUrl
          : "https://ossfastmake.mustke.com/12xtPictures/xt-1.png";

        this.phoneSwitch = detailInfo.phoneSwitch;
        this.userPhone = detailInfo.userPhone;
        this.contactType = detailInfo.contactType ? detailInfo.contactType : 3;

        // 整合activityModeUrl和subCoverImages到turnPictures数组
        this.turnPictures = [];
        // 如果activityModeUrl不为空字符串，则添加到数组开头
        if (this.activityModeUrl && this.activityModeUrl.trim() !== "") {
          this.turnPictures.push(this.activityModeUrl);
        }
        // 如果subCoverImages不为空数组，则添加到turnPictures中
        if (this.subCoverImages && this.subCoverImages.length > 0) {
          this.turnPictures = this.turnPictures.concat(this.subCoverImages);
        }

        if (this.isCoverEnabled == 2 && this.activityModeUrl) {
          // 删除 turnPictures 数组里的第一个
          this.turnPictures.splice(0, 1);
        }

        if (this.activityMode == 1) {
          this.shareImgWord = "系统分享图";
        } else {
          this.shareImgWord = "上传自定义";
        }

        // 核销签到
        var ksTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
        var jsTime = dayjs().add(7, "day").format("YYYY-MM-DD HH:mm:ss");
        // 核销
        this.verificationStartTime =
          this.activityDetail.verificationStartTime || ksTime;
        this.verificationEndTime =
          this.activityDetail.verificationEndTime || jsTime;
        this.signInStartTime = this.activityDetail.signInStartTime || ksTime;
        this.signInEndTime = this.activityDetail.signInEndTime || jsTime;

        // 如果activityDetail中没有对应的时间，则设置默认值
        if (!this.activityDetail.verificationStartTime) {
          this.activityDetail.verificationStartTime = ksTime;
        }
        if (!this.activityDetail.signInStartTime) {
          this.activityDetail.signInStartTime = ksTime;
        }
        if (!this.activityDetail.verificationEndTime) {
          this.activityDetail.verificationEndTime = jsTime;
        }
        if (!this.activityDetail.signInEndTime) {
          this.activityDetail.signInEndTime = jsTime;
        }
        if (this.selectType == "add") {
          this.hxStartAndEndTime = [ksTime, jsTime];
          this.signStartAndEndTime = [ksTime, jsTime];
        }

        if (this.selectType == "update" || this.ifcopy) {
          this.isanonymous = detailInfo.isanonymous;
        }
        this.multipleActivitiesStatus = detailInfo.multipleActivitiesStatus; //是否允许参加多个活动

        this.showName = detailInfo.signShowType == 1 ? "列表接龙" : "网格接龙";

        this.coverimgClone();
        this.clockPresetsList();
        if (this.selectType != "add") {
          this._getSignList();
          this._getProjectManageAdmin();
        }
        if (this.isAi == "1") {
          this.getCreateMessage(this.isAi);
        }
      });
    },
    // 获取封面图片接口
    async coverimgClone() {
      const { data, msg, status } = await getCoverimgTemplate();
      this.imgInfo = data;
      this.baseurl = this.baseurl ? this.baseurl : data[0].coverImg;
      this.imgInfo.map((item, index) => {
        item.imgShowLv = false;
      });
      this.imgInfo[0].imgShowLv = true;
      if (this.activityId != 2) {
        this.baseurl = this.activityDetail.coverImg;
      } else {
        this.baseurl ? this.baseurl : this.imgInfo[0].path;
      }
    },
    // 获取报名人数
    async _getSignList() {
      const { data, msg, status } = await getSignList({
        activityId: this.activityDetail.id,
        signShowType: this.activityDetail.signShowType,
      });

      if (status == 1) {
        if (data.pageInfo.list && data.pageInfo.list.length > 0) {
          this.commonDisabled = true;
        } else {
          console.log(data, "无人报名吗");
        }
      }
    },
    // 判断身份
    async _getProjectManageAdmin() {
      const result = await getProjectManageAdmin({
        activityId: this.activityId,
      });
      if (result.status != 901) {
        this.isOtherPeople = result.data;
        if (this.activityId == 2) {
          this.isOtherPeople = 1;
        }
      }
    },

    // 编辑名单
    nameLists(id) {
      this.nameId = id;
      this.clockPresetsDetail();
    },
    async clockPresetsDetail() {
      const { data, status } = await clockPresetsDetail({
        id: this.nameId,
      });
      if (status == 1) {
        this.clockShowPresetTitle = data.clockPresetTitle;
        this.clockShowPresetContent = data.clockPresetContent;
        this.handlerBlur();
        this.addNameListDrawer = true;
      }
    },
    FocusInterdictPeople() {
      if (this.interdict_people_num == 0) {
        this.interdict_people_num = "";
      }
    },
    BlurInterdictPeople(e) {
      if (this.interdict_people_num == 0 || this.interdict_people_num == "") {
        this.interdict_people_num = 0;
      }
    },
    oninputFun(e) {
      // 正则表达式，匹配正整数和0
      const regex = /^(?:0|[1-9]\d*)$/;
      // 判断输入值是否匹配正则表达式
      if (!regex.test(e)) {
        // 如果不匹配，则将输入值重置为上一个合法的值
        e = e.replace(regex, "");
      }
    },
    cannotEdit() {
      this.$message({
        message: "当前活动已经有人报名，不能修改",
        type: "warning",
      });
    },
    handlerBlur() {
      // var reg = /([\n\r])+/g
      // this.clockShowPresetContent = this.clockShowPresetContent.trim()
      let arr = this.clockShowPresetContent.split(/[\n\s+,，；;]/g);
      arr = arr.filter((item) => item != "");
      // this.people_num = arr.length
      this.people_num2 = arr.length;
    },
    handlerBlurOnlyName() {
      console.log("88888");
      // var reg = /([\n])+/g
      // this.nameShowContent = this.nameShowContent.trim()
      let arr = this.nameShowContent.split(/[\s+,，；;]/g);
      arr = arr.filter((item) => item != "");
      this.people_num = arr.length;
      // this.people_num2 = arr.length
      this.onlyNameArr = arr;
    },
    handlerBlurFz() {
      // var reg = /([\n\r])+/g
      // this.fzValue = this.fzValue.trim()
      let arr = this.fzValue.split(/[\n\s+,，；;]/g);
      arr = arr.filter((item) => item != "");
      this.people_num2 = arr.length;
      this.onlyGroupArr = arr;
    },

    presetsDel(id) {
      this.nameId = id;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirmDelete();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    EchoList(info) {
      if (this.openNameListDrawer == true) {
        this.nameShowContent = info.clockPresetContent;
        this.handlerBlurOnlyName();
      }
      if (this.handleSubShow == true) {
        this.fzValue = info.clockPresetContent;
        this.handlerBlurFz();
      }
      this.nameListDrawer = false;
    },
    // 删除名单
    async confirmDelete() {
      const { msg, status } = await clockPresetsDel({
        id: this.nameId,
      });
      if (status == 1) {
        this.$message({
          type: "success",
          message: msg,
        });
        this.clockPresetsList();
      } else {
        this.$message(msg);
      }
    },
    // 获取名单管理列表
    clockPresetsList() {
      clockPresetsList({
        pageNum: 1,
        pageSize: 10,
      }).then((res) => {
        this.presetsList = res.data.list;
      });
    },

    // -添加模块
    addModule(num) {
      // 自定义内容1
      if (num == 0) {
        const kk = {
          type: 1,
          isCloneTf: 1,
          info: {
            value: "",
            title: "",
          },
        };
        this.modularList.push(kk);
      }
      // 小图
      if (num == 2) {
        var bb = {
          type: 3,
          isCloneTf: 1,
          info: {
            value: "图片",
            imgarr: [],
          },
        };
        this.modularList.push(bb);
      }
      // 位置
      if (num == 3) {
        var cc = {
          type: 4,
          isCloneTf: 1,
          info: {
            value: "地址",
            name: "",
            address: "",
            latitude: "",
            longitude: "",
          },
          location: {
            lng: 116.403963,
            lat: 39.915119,
          },
        };
        this.modularList.push(cc);
      }
      // 文件
      if (num == 4) {
        var dd = {
          type: 5,
          isCloneTf: 1,
          info: {
            value: "文件",
            filesArr: [],
          },
        };
        this.modularList.push(dd);
      }
      // 音频
      if (num == 5) {
        var ee = {
          type: 6,
          isCloneTf: 1,
          info: {
            value: "音频",
            name: "",
            size: "",
            lastName: "",
            fileUrl: "",
            filesArr: [],
          },
        };
        this.modularList.push(ee);
      }
      // 视频
      if (num == 6) {
        var ff = {
          type: 7,
          isCloneTf: 1,
          info: {
            value: "视频",
            name: "",
            size: "",
            lastName: "",
            fileUrl: "",
          },
        };
        this.modularList.push(ff);
      }
      // 大图
      if (num == 7) {
        var gg = {
          type: 9,
          isCloneTf: 1,
          info: {
            value: "大图",
            imgarr: [],
          },
        };
        this.modularList.push(gg);
      }
      // 一键复制
      if (num == 11) {
        var ggg = {
          type: 13,
          isCloneTf: 1,
          info: {
            value: "一键复制区",
            copy_region_conten: "",
          },
        };
        this.modularList.push(ggg);
      }
      // 公众号
      if (num == 8) {
        var gzh = {
          type: 10,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "公众号标题",
            link: "",
            officialAccountTitle: "",
          },
        };
        this.modularList.push(gzh);
      }
      // 视频号
      if (num == 9) {
        var sph = {
          type: 11,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "视频号标题",
            videoId: "",
            videoNumberID: "",
            videoNumberTitle: "",
          },
        };
        this.modularList.push(sph);
      }

      // 其他小程序
      if (num == 10) {
        var qtxcx = {
          type: 12,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "其他小程序标题",
            appid: "",
            pagePath: "",
            appTitle: "",
          },
        };
        this.modularList.push(qtxcx);
      }
      // 关联接龙
      if (num == 12) {
        var gljl = {
          type: 14,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "关联接龙",
            associationActivityId: [],
          },
        };
        this.modularList.push(gljl);
      }

      this.$forceUpdate();
    },
    // 工厂函数
    createField(item, name) {
      const base = {
        isRequired: 1,
        isOpen: 1,
        encryption: 0,
        isUniqueCheck: 0,
        isFormatCheck: 0,
        randomDecimal: Date.now(),
        promptSwitch: 2,
        promptImage: "",
        promptExplanation: "",
        displayStyle: 1, // 默认1列表式 2 下拉式';
        maxValue: 0,
        minValue: 1,
        positionSwitch: 1,
        content: "",
        dateSelectType: 2, // 格式默认2
        areaSelectType: 2,
        timeSelectType: 2, // 默认第3个
        annotationPermission:2,//是否允许用户自行批注
      };
      // 深拷贝字段模板，避免多个实例共享引用导致互相影响
      let config = this.fieldTypeMap[item]
        ? JSON.parse(JSON.stringify(this.fieldTypeMap[item]))
        : null;
      if (!config) return null;
      // AI使用和特殊类型处理
      if (item == -99) config = { ...config, fieldName: name };
      // 多选/单选/性别等特殊content
      if (item == 9 || item == -2 || item == -3) {
        // 已在映射中处理
      }
      // 合并基础配置和字段配置
      const field = { ...base, ...config };

      // 对于包含 content 的类型，确保每个 option 都是独立对象
      if (Array.isArray(field.content)) {
        field.content = field.content.map((opt) => ({ ...opt }));
      }
      if (field.type === 10 || field.type === 11) {
        field.encryption = 1; // 开启加密
      } else {
        field.encryption = 0; // 关闭加密
      }
      // 对于type 5的字段，确保annotationPermission有默认值（如果为null或undefined，设置为"2"）
      if (field.type === 5 && (field.annotationPermission === null || field.annotationPermission === undefined)) {
        field.annotationPermission = "2";
      }

      return field;
    },

    // 优化后的 addForm
    addForm(item, name) {
      console.log("我的添加-------", item, name);

      const field = this.createField(item, name);
      console.log(field, "field");
      if (!field) return;
      if (this.isAi == "0") {
        this.$message({
          showClose: true,
          message: `已经添加了「${field.fieldName || name || "字段"}」`,
          type: "success",
        });
      }
      this.listList[this.indexIdx].signField.push(field);
      this.$forceUpdate();
    },

    // 打开预存名单列表
    openNamelistFun() {
      this.nameListDrawer = true;
    },
    // 添加接龙名单
    sureAddNameList() {
      var reg = /([\n\r])+/g;
      this.nameShowContent = this.nameShowContent.trim().replace(reg, "\n");
      let arr = this.nameShowContent.split(/[\n\s+,，；;]/g);
      arr = arr.filter((item) => item != "");

      if (arr.length > 1000) {
        this.$message("名单人数不能超过1000");
        return;
      }
      this.packetData = arr;
      this.nameListLength = arr.length;
      this.openNameListDrawer = false;
      this.subsetValueArr = [
        {
          clockInList: this.packetData.join(),
          listGroupName: "",
        },
      ];
      this.nameAddType = 1;
      // 清值
      this.subsetCenterValueArr = [];
      this.pickerName = "全部";
    },
    importFiles(event) {
      this.selectedFile = event.target.files[0];
      const lastArr = this.selectedFile.name.split(".");
      if (lastArr[1] != "xls" && lastArr[1] != "xlsx") {
        this.$message("文件格式不正确");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularFile",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFileExcel", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          var data = response.data;
          if (data.status == 1) {
            this.clockShowPresetContent = data.data;
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.log("上传error", error);
        });
    },
    toAddRoster() {
      this.nameId = "";
      this.clockShowPresetTitle = "";
      this.clockShowPresetContent = "";
      this.addNameListDrawer = true;
    },
    // 添加预存名单列表
    async clockPresetsAdd() {
      const arr = this.clockShowPresetContent.split(/[\n\s+,，；;]/g);
      if (arr.length > 1000) {
        this.$message("名单人数不能超过1000");
        return false;
      }
      if (this.clockShowPresetTitle == "") {
        this.$message("名单标题不可以为空");
        return false;
      }
      if (this.clockShowPresetContent == "") {
        this.$message("预存名单不可以为空");
        return false;
      }
      // 添加
      if (this.nameId == "") {
        const { msg, status } = await clockPresetsAdd({
          clockPresetTitle: this.clockShowPresetTitle,
          clockPresetContent: this.clockShowPresetContent,
        });
        if (status == 1) {
          this.$message(msg);
          this.clockPresetsList();
        }
        this.$message(msg);
        this.addNameListDrawer = false;
      }
      // 编辑
      if (this.nameId != "") {
        const { msg, status } = await clockPresetsUpdate({
          clockPresetTitle: this.clockShowPresetTitle,
          clockPresetContent: this.clockShowPresetContent,
          id: this.id,
        });
        if (status == 1) {
          this.clockPresetsList();
        }
        this.$message(msg);
        this.addNameListDrawer = false;
      }
    },
    openCus() {
      this.copyShowWriting = this.copywriting;
      this.copyShowImage = this.copyimage;
      this.customizeDrawer = true;
    },
    // 下载excel模板
    downExam() {
      window.open(serverConfig.baseURL + "/excel/模板.xlsx", "_self");
    },
    sureCoverImgFun() {
      this.copywriting = this.copyShowWriting;
      this.copyimage = this.copyShowImage;
      this.customizeDrawer = false;
    },
    openNameListDrawerFun() {
      // 如果名单为空，添加默认的"李某某"和"王某某"
      if (!this.packetData || this.packetData.length === 0) {
        this.packetData = ["李某某", "王某某"];
        this.nameListLength = 2;
        this.people_num = 2;
      }
      // 弹框赋值
      this.nameShowContent = this.packetData.join();
      this.openNameListDrawer = true;
      this.nameAddType = 1;
    },
    emptyName() {
      this.clockShowPresetContent = "";
    },
    // 导入
    importExcel(event) {
      console.log(event, "eventevent");

      this.selectedFile = event.target.files[0];
      const lastArr = this.selectedFile.name.split(".");

      if (lastArr[1] != "xls" && lastArr[1] != "xlsx") {
        this.$message("文件格式不正确");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularFile",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFileExcel", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          const data = response.data;

          if (this.nameAddType == 1) {
            if (data.status == 1) {
              this.nameShowContent = data.data;
              this.fzValue = data.data;

              let arr = this.nameShowContent.split(/[\s+,，；;]/g);
              arr = arr.filter((item) => item != "");
              this.onlyNameArr = arr;
              this.onlyGroupArr = arr;
            } else {
              this.$message(response.data.msg);
            }
          } else {
            if (data.status == 1) {
              this.fzValue = data.data;
              let arr = this.fzValue.split(/[\s+,，；;]/g);
              arr = arr.filter((item) => item != "");
              this.onlyGroupArr = arr;
              // that.clockShowPresetContent  =  that.clockShowPresetContent+ data.data;
            } else {
              this.$message(response.data.msg);
            }
          }
          this.importVisible = false;
        })
        .catch((error) => {
          loading.close();
          console.log("上传error", error);
        });
    },
    customizeClose() {
      this.customizeDrawer = false;
    },
    // 上传自定义封面
    uploadCopyImage(event) {
      this.selectedFile = event.target.files[0];
      var pettern = /^image/;
      if (!pettern.test(this.selectedFile.type)) {
        this.$message("文件格式不正确");
        return;
      }
      if (this.selectedFile.size / 1048576 > 5) {
        this.$message("图片大小小于5M");
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularImg",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          var data = response.data;
          if (data.status == 1) {
            this.copyShowImage = data.msg;
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.log("上传error", error);
        });
    },
    delCopyImage() {
      this.copyShowImage = "";
    },
    clearName() {
      this.nameShowContent = "";
      this.onlyNameArr = [];
    },
    nameListClose() {
      this.openNameListDrawer = false;
    },
    importClose() {
      this.importVisible = false;
    },
    addNameDrawer() {
      this.addNameListDrawer = false;
    },
    closeAddNameDrawer() {
      this.addNameListDrawer = false;
    },
    nameListDrawerFun() {
      this.nameListDrawer = false;
    },
    // 复制填表项
    copyThisSignField(sonIndex, fatherIndex) {
      var data = JSON.parse(
        JSON.stringify(this.listList[fatherIndex].signField[sonIndex])
      );
      this.listList[fatherIndex].signField.splice(sonIndex + 1, 0, data);
    },
    // 月截止日期处理
    endMonthFunFirst(e) {
      this.monthDay = e;
      this.formClock.dayOfDate = e;
    },
    endMonthFunSecond(e) {
      var str = this.endMonthArr2[e].label;
      this.formClock.timeOfDay =
        str + ":" + this.endMonthArr2[this.monthMinute].label;
    },
    endMonthFunThird(e) {
      var str = this.endMonthArr3[e].label;
      this.formClock.timeOfDay =
        this.endMonthArr2[this.monthHour].label + ":" + str;
    },
    // 周截止日期处理
    endWeekFunFirst(e) {
      this.weekDay = e;
      this.formClock.dayOfDate = e;
    },
    clockMultiPeriodSwitchFn(e) {
      this.formClock.multiPeriodSwitch = e;
      if (e == 2) {
        this.formClock.clockInTimeSlot.forEach((item, index) => {
          if (index >= 1) {
            item.ifDel = 1;
          }
        });
      }
    },
    // 添加时间段
    addTimes() {
      var _json = {
        startTime: "00:00",
        endTime: "23:59",
        startAndEnd: ["00:00", "23:59"],
        ifDel: 2,
        randomDecimal: Date.now(),
      };
      this.formClock.clockInTimeSlot.push(_json);
      this.$forceUpdate();
    },
    timesDel(idx) {
      var l = 0;
      this.formClock.clockInTimeSlot.forEach((item) => {
        if (item.ifDel == 2) {
          l++;
        }
      });
      if (l == 1) {
        this.$message("至少保留一个时间段");
        return false;
      }
      this.formClock.clockInTimeSlot[idx].ifDel = 1;
      this.$forceUpdate();
    },
    // 时间段选择
    clockInTimeSlot(e, idx) {
      this.formClock.clockInTimeSlot[idx].startAndEnd = e;
      this.formClock.clockInTimeSlot[idx].startTime = e[0];
      this.formClock.clockInTimeSlot[idx].endTime = e[1];
    },

    clockLocationFn(e) {
      this.formClock.clockLocationStatus = e;
      this.addMapType = 1;
    },

    clockRangeChange(e) {
      this.formClock.clockRange = e;
    },

    supplyFn(e) {
      console.log(e);
      this.formClock.clockSupplyStatus = e;
    },

    // 日期多选
    multipleDateSure(e) {
      this.customDateArr = e;
      this.formClock.customDate = e.join(",");
    },
    // -打卡频率
    clickin(e) {
      this.CheckInFrequency.forEach((item) => {
        if (item.value == e) {
          this.selectData = item.label;
        }
      });

      this.selectFrequency = e;
      this.formClock.clockFrequencyType = e;
      // 每月
      if (e == 1) {
        this.formClock.timeOfDay = "20:00";
        // 日期处理
        this.lastDayOfMonth = this.lastDayOfMonth.slice(-2);
        // 如果选择了开始时间
        var beginTime = this.activityDetail.beginTime;
        if (beginTime) {
          var year = beginTime.substring(0, 4);
          var month = beginTime.substring(5, 7);
          const lastDay = new Date(year, month, 0).getDate();
          this.lastDayOfMonth = lastDay;
        }
        this.formClock.dayOfDate = this.lastDayOfMonth;
        this.monthDay = Number(this.lastDayOfMonth);
        this.monthHour = 20;
        this.monthMinute = 0;
        this.endMonthValue =
          this.formClock.dayOfDate + "号 " + this.formClock.timeOfDay;
      }
      // 每周
      if (e == 2) {
        this.formClock.timeOfDay = "20:00";
        this.formClock.dayOfDate = "6";
        this.weekDay = 6;
        this.weekHour = 20;
        this.weekMinute = 0;
        this.endWeekValue =
          "周" +
          this.weekChineseNumbers[this.formClock.dayOfDate] +
          " " +
          this.formClock.timeOfDay;
      }
      // 每天
      if (e == 3) {
        this.formClock.clockFrequency = "0,1,2,3,4,5,6";
      }
      // 法定工作日，法定节假日，自定义周几打卡，自定义日期打卡，一次性打卡 设置一样
    },
    candidateChange(e) {
      if (this.selectFrequency == 6) {
        this.formClock.clockFrequency = e.join(",");
      }
      if (this.selectFrequency == 3) {
        this.formClock.clockFrequency = "0,1,2,3,4,5,6";
      }
    },
    clockMaxSwitchFn(e) {
      this.formClock.clockMaxSwitch = e;
      if (e == 2) {
        this.formClock.clockMaxNum = 1;
      }
    },
    checkinRangeChange(e) {
      this.checkinrange = e;
    },
    signRangeChange(e) {
      this.activityDetail.signLocationDistance = e;
    },
    signInfoIsOpenFun(e) {
      this.signInfoStatus = e;
      this.activityDetail.signInfoStatus = e;
    },
    signChange(e) {
      this.updateSignInfo = e;
    },
    deadlineTimeFun(e) {
      this.deadline = e;
      this.activityDetail.registrationtime = e[0];
      this.activityDetail.endregistrationtime = e[1];
    },
    deadCancelTimeFun(e) {
      this.deadCancelline = e;
      this.activityDetail.removeSignBeginTime = e[0];
      this.activityDetail.removeSignEndTime = e[1];
    },
    actStartAndEndTimeFun(e) {
      this.actStartAndEndTime = e;
      this.activityDetail.beginTime = e[0];
      this.activityDetail.endTime = e[1];
    },
    hxStartAndEndTimeFun(e) {
      this.hxStartAndEndTime = e;
      this.activityDetail.verificationStartTime = e[0];
      this.activityDetail.verificationEndTime = e[1];
    },
    qdStartAndEndTimeFun(e) {
      this.signStartAndEndTime = e;
      this.activityDetail.signInStartTime = e[0];
      this.activityDetail.signInEndTime = e[1];
    },
    removeSignChange(e) {
      this.removeSignStatus = e;
      this.activityDetail.removeSignStatus = e;
    },
    // addInp(item, index, fatherIndex) {
    //   var inp = {
    //     value: "",
    //     maxNum: -1,
    //   };
    //   this.listList[fatherIndex].signField[index].content.push(inp);
    //   this.$forceUpdate();
    // },
    // 添加选项
    addInp(item, index) {
      console.log(this.listList, index, "listList");
      var inp = {
        value: "",
        maxNum: -1,
        randomDecimal: Date.now(),
      };
      // 使用 $set 确保响应式更新
      const content = this.listList[this.indexIdx].signField[index].content;
      this.$set(this.listList[this.indexIdx].signField[index], "content", [
        ...content,
        inp,
      ]);

      this.$forceUpdate();
    },
    // 删除添加项
    delInp(item, index, indexIdx, listIndex) {
      this.listList[listIndex].signField[indexIdx].content.splice(index, 1);
      this.$forceUpdate();
    },
    // 是否保密
    encryptionChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].encryption = e;
      this.$forceUpdate();
    },
    // 是否必填
    isRequiredChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].isRequired = e;
      this.$forceUpdate();
    },
    // 是否公开
    isOpenChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].isOpen = e;
      this.$forceUpdate();
    },
    // 是否重复
    isUniqueCheckChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].isUniqueCheck =
        e == true ? 1 : 0;
    },
    // 日期格式
    bindValidateTimePickerChange(e, sonIndex, fatherIndex) {
      this.validateIndex = e;
      this.listList[fatherIndex].signField[sonIndex].timeSelectType =
        this.validateIndex;
    },
    // 省市区
    bindValidateAreaPickerChange(e, sonIndex, fatherIndex) {
      this.validateIndex = e;
      this.listList[fatherIndex].signField[sonIndex].areaSelectType =
        this.validateIndex;
    },
    // 打开抽屉
    openfieldList() {
      this.formDrawerShow = true;
    },

    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    // 上传文件
    handleFileUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;
      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      for (let i = 0; i < this.selectedFile.length; i++) {
        const name = this.selectedFile[i].name;
        const size = this.selectedFile[i].size;
        // 判断后缀名
        const lastArr = this.selectedFile[i].name.split(".");
        if (
          lastArr[1] != "pdf" &&
          lastArr[1] != "ppt" &&
          lastArr[1] != "doc" &&
          lastArr[1] != "docx" &&
          lastArr[1] != "xls" &&
          lastArr[1] != "xlsx" &&
          lastArr[1] != "zip"
        ) {
          loading.close();
          event.target.value = "";
          this.$message("文件格式不正确");
          return;
        } else {
          if (this.selectedFile[i].size / 1048576 > 10) {
            loading.close();
            event.target.value = "";
            this.$message("请上传大小不超过10MB文件");
            break;
          } else {
            var parm = {
              file: this.selectedFile[i],
              type: "modularFile",
            };
            axios
              .post(serverConfig.baseURL + "/file/uploadFile", parm, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Token": localStorage.getItem("token"),
                },
              })
              .then((response) => {
                loading.close();
                if (response.data.status == 1) {
                  var _json = {
                    name: name,
                    size: size,
                    fileUrl: response.data.msg,
                    lastName: lastArr[1],
                  };
                  this.modularList[this.modulCommonIndex].info.filesArr.push(
                    _json
                  );
                }
              })
              .catch((error) => {
                event.target.value = "";
                loading.close();
                console.log("err:", error);
              });
          }
        }
      }
    },
    // 上传音频
    handleMpThreeUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;

      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      for (let i = 0; i < this.selectedFile.length; i++) {
        const name = this.selectedFile[i].name;
        const size = this.selectedFile[i].size;
        // 判断后缀名
        const lastArr = this.selectedFile[i].name.split(".");
        if (lastArr[1] != "mp3") {
          loading.close();
          event.target.value = "";
          this.$message("文件格式不正确");
          return;
        } else {
          if (this.selectedFile[i].size / 1048576 > 10) {
            loading.close();
            event.target.value = "";
            this.$message("请上传大小不超过10MB文件");
            break;
          } else {
            var parm = {
              file: this.selectedFile[i],
              type: "modularMP3",
            };

            axios
              .post(serverConfig.baseURL + "/file/uploadFile", parm, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Token": localStorage.getItem("token"),
                },
              })
              .then((response) => {
                loading.close();
                if (response.data.status == 1) {
                  var _json = {
                    name: name,
                    size: size,
                    fileUrl: response.data.msg,
                    lastName: lastArr[1],
                  };
                  this.modularList[this.modulCommonIndex].info.filesArr.push(
                    _json
                  );
                }
              })
              .catch((error) => {
                loading.close();
                console.log("err:", error);
              });
          }
        }
      }
    },

    // 上传视频
    handleMpFourUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files[0];
      const lastArr = this.selectedFile.name.split(".");
      if (lastArr[1].toLowerCase() != "mp4") {
        this.$message("文件格式不正确");
        event.target.value = "";
        return;
      }
      if (this.selectedFile.size / 1048576 > 10) {
        this.$message("请上传大小不超过10MB文件");
        event.target.value = "";
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularMP4",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          this.modularList[idx].info.fileUrl = response.data.msg;
          this.modularList[idx].info.name = this.selectedFile.name;
          this.modularList[idx].info.size = this.selectedFile.size;
          this.modularList[idx].info.lastName = lastArr[1];
        })
        .catch((error) => {
          loading.close();
          console.log("图片上传失败", error);
        });
    },
    // 上传图片
    handleImgUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;
      var pettern = /^image/;
      for (let i = 0; i < 9; i++) {
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          event.target.value = "";
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("请上传大小不超过5MB文件");
          event.target.value = "";
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.modularList[idx].info.imgarr.push(response.data.msg);
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });
        }
      }
    },
    // 上传小图
    handleSmallImgUpload(event, idx) {
      this.modulCommonIndex = idx;
      // 9个
      const imgCounts = this.modularList[idx].info.imgarr.length;
      const theRest = 9 - imgCounts;
      if (event.target.files.length > theRest) {
        this.$message("只能上传9张小图");
        return;
      }
      this.selectedFile = event.target.files;
      var pettern = /^image/;
      for (let i = 0; i < 9; i++) {
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("图片大小小于5M");
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.modularList[idx].info.imgarr.push(response.data.msg);
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });
        }
      }
    },
    submitUploadBigImage() {
      const formData = new FormData();
      formData.append("image", this.selectedFile);
      var parm = {
        file: this.selectedFile,
        type: "modularImg",
      };

      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          console.log("图片上传成功", response);
        })
        .catch((error) => {
          console.log("图片上传失败", error);
        });
    },
    anonymousFun(e) {
      this.isanonymous = e;
    },
    phoneSwitchChange(e) {
      this.phoneSwitch = e;
    },

    copyStatusFun(e) {
      this.copyStatus = e;
    },
    forwardFun(e) {
      const a = e ? 1 : 2;
      this.shareStatus = a;
      this.is_forward = e ? 1 : 0;
    },
    anonymouspartFun(e) {
      this.anonymousparticipation = e;
    },
    commentFun(e) {
      this.commentStatus = e;
    },
    changeChatSwitch(e) {
      this.chatSwitch = e;
    },
    thumbsUpFun(e) {
      this.thumbs_up = e;
    },
    isCommentFun(e) {
      this.is_comment = e;
    },

    isScoreFun(e) {
      this.is_score = e;
    },
    isMessageFun(e) {
      this.isMessage = e;
    },

    rankingFun(e) {
      this.showRanking = e;
    },

    isDestinationFun(e) {
      this.is_destination = e;
    },
    clockRemindFun(e) {
      this.formClock.clockRemindStatus = e;
    },
    // 打卡提醒时间
    clockTime(e) {
      this.formClock.remindTime = e;
    },
    // 表单项上移下移删除
    topNuoPng(item, index, type, listIdx) {
      var data = [];
      if (type == 1) {
        data = this.listList;
      } else if (type == 2) {
        if (index == 1) {
          return false;
        }
        data = this.listList[listIdx].signField;
      } else if (type == 3) {
        data = this.modular;
      }
      if (index == 0) {
        return false;
      }
      //在上一项插入该项
      data.splice(index - 1, 0, data[index]);
      //删除后一项
      data.splice(index + 1, 1);
    },
    // 下移
    bottomNuoPng(item, index, type, listIdx) {
      var data = [];
      if (type == 1) {
        data = this.listList;
      } else if (type == 2) {
        data = this.listList[listIdx].signField;
      } else if (type == 3) {
        data = this.modular;
      }

      if (index == data.length - 1) {
        return false;
      }
      //在下一项插入该项
      data.splice(index + 2, 0, data[index]);
      // 删除前一项
      data.splice(index, 1);
    },
    // 删除表单项
    delMuKuai(itm, ind, idx) {
      this.indexIdx = idx;
      if (this.selectType == "update") {
        itm["ifDel"] = 1;
        this.delListInfo.push(itm);
      }
      this.listList[this.indexIdx].signField.splice(ind, 1);
    },
    // 大图上移下移
    upBigImg(index, fatherIndex) {
      // 上移

      if (index == 0) {
        this.$message({
          message: "已经是第一项",
          type: "warning",
        });
        return false;
      }
      //在上一项插入该项
      this.modularList[fatherIndex].info.imgarr.splice(
        index - 1,
        0,
        this.modularList[fatherIndex].info.imgarr[index]
      );
      //删除后一项
      this.modularList[fatherIndex].info.imgarr.splice(index + 1, 1);
    },
    downBigImg(index, fatherIndex) {
      // 下移

      if (index == this.modularList[fatherIndex].info.imgarr.length - 1) {
        this.$message({
          message: "已经是最后一项",
          type: "warning",
        });
        return false;
      }
      //在下一项插入该项
      this.modularList[fatherIndex].info.imgarr.splice(
        index + 2,
        0,
        this.modularList[fatherIndex].info.imgarr[index]
      );
      // 删除前一项
      this.modularList[fatherIndex].info.imgarr.splice(index, 1);
    },
    // 大图删除
    delBigImg(index, fatherIndex) {
      this.modularList[fatherIndex].info.imgarr.splice(index, 1);
    },
    // 小图删除
    delSmallPic(index, fatherIndex) {
      this.modularList[fatherIndex].info.imgarr.splice(index, 1);
    },
    // 文件删除
    delFiles(index, fatherIndex) {
      this.modularList[fatherIndex].info.filesArr.splice(index, 1);
    },

    //选择位置
    openAddress(idx) {
      this.addMapType = 1;
      this.addressDialog = true;
      this.addressIdx = idx;
    },
    openMap(idx) {
      this.modulCommonIndex = idx;
      this.addMapType = 2;
      this.addressDialog = true;
      this.addressIdx = idx;
    },
    openJoininAddress() {
      this.addMapType = 3;
      this.addressDialog = true;
    },
    openSignAddress() {
      this.addMapType = 4;
      this.addressDialog = true;
    },

    subAddress() {
      window.addEventListener(
        "message",
        (event) => {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          const loc = event.data;
          // _this.addressData = []
          if (loc && loc.module == "locationPicker") {
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            this.address = loc.poiaddress;
            this.poiname = loc.poiname;
            this.latitude = loc.latlng.lat;
            this.longitude = loc.latlng.lng;
          }
        },
        false
      );
    },
    //地图选点确定
    submitMap() {
      if (
        this.address == null ||
        this.latitude == null ||
        this.longitude == null
      ) {
        this.$message.error("请先选择地址！");
        return;
      }

      this.addressDialog = false;
      // 模块
      if (this.addMapType == 2) {
        this.modularList[this.modulCommonIndex].info.address = this.address;
        this.modularList[this.modulCommonIndex].info.latitude = this.latitude;
        this.modularList[this.modulCommonIndex].info.longitude = this.longitude;
        this.modularList[this.modulCommonIndex].info.name = this.poiname;
        this.modularList[this.modulCommonIndex].location = {
          lng: this.longitude,
          lat: this.latitude,
        };
      }
      // 设置
      if (this.addMapType == 3) {
        this.specifyaddress = this.address;
        this.deliveryaddress = `${this.latitude},${this.longitude}`;
      }
      // 打卡
      if (this.addMapType == 1) {
        var info = {
          name: this.poiname,
          address: this.address,
          latitude: this.latitude,
          longitude: this.longitude,
        };
        this.formClock.clockLocationInfo = JSON.stringify(info);
        this.formClock.address = this.address;
      }
      // 签到
      if (this.addMapType == 4) {
        this.activityDetail.signLocation = `${this.latitude},${this.longitude}`;
        this.activityDetail.signInAddress = this.address;
      }
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    formDrawerClose() {
      this.formDrawerShow = false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },

    handlePreview(file) {
      console.log(file);
    },

    getLastDayOfMonth(date = new Date()) {
      // 使用示例
      // 创建一个新的日期对象，设置为下一个月的第一天
      const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);

      // 减去一天，即得到当前月的最后一天
      const lastDay = new Date(nextMonth - 1);

      // 返回结果，根据需要可以返回不同的格式
      // 这里返回的是日期对象的字符串形式
      return lastDay.toISOString().split("T")[0]; // 如果你想要的是 YYYY-MM-DD 格式

      // 或者直接返回日期对象
      // return lastDay;
    },
    // 对象数组进行去重
    uniqueBy(a, key) {
      const seen = new Set();
      return a.filter((item) => {
        const k = key(item);
        return seen.has(k) ? false : seen.add(k);
      });
    },
    getClickInfo(address) {
      this.markLocation.lat = address.point.lat;
      this.markLocation.lng = address.point.lng;
    },
    searchMap(address) {
      // 创建地址解析器实例，平时用不了，加个window完美胡恶化！
      const myGeo = new window.BMap.Geocoder();

      new myGeo.getPoint(address, (e) => {
        this.markLocation.lat = e.lat;
        this.markLocation.lng = e.lng;
      });
    },
    checkDetail(e) {
      console.log(e, "uuuuuu");
    },
    // 模块上移下移删除
    moveUp(index) {
      if (index == 0) {
        this.$message({
          message: "已经是第一项",
          type: "warning",
        });
        return false;
      }
      //在上一项插入该项
      this.modularList.splice(index - 1, 0, this.modularList[index]);
      //删除后一项
      this.modularList.splice(index + 1, 1);
    },
    moveDown(index) {
      if (index == this.modularList.length - 1) {
        this.$message({
          message: "已经是最后一项",
          type: "warning",
        });
        return false;
      }
      //在下一项插入该项
      this.modularList.splice(index + 2, 0, this.modularList[index]);
      // 删除前一项
      this.modularList.splice(index, 1);
    },
    delmodular(item, index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (
            item.id != null &&
            item.id != undefined &&
            this.selectType == "update"
          ) {
            this.modularDelIds.push(item.id);
          }
          this.modularList.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查看大图
    seeBigImg(src) {
      this.previewImgSrc = src;
      this.previewImgShow = true;
    },
    hidePreview() {
      this.previewImgShow = false;
    },

    timestampToTime(date) {
      if (date == "" || !date) {
        return "";
      }
      var date2 = new Date(date);
      var y = date2.getFullYear();
      var m = date2.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date2.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date2.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date2.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date2.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    // 打卡次数处理让这个次数始终大于0的正整数
    handleInput(value) {
      let num = value.replace(/[^\d]/g, "");
      num = num === "" ? "" : Math.max(0, parseInt(num, 10));
      this.formClock.checkTimes = num;
    },
    handleClockSupplyCenterTextInput(value) {
      let num = value.replace(/[^\d]/g, "");
      num = num === "" ? "" : Math.max(0, parseInt(num, 10));
      this.clockSupplyCenterText = num;
    },
  },
  computed: {
    ...mapState(["isOpenShare"]),
    setMb() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else {
          const infoSize = size / 1048576;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return (
              "音频大小：" +
              (Math.floor(infoSize) == 0
                ? Math.floor(size / 1024) + "KB"
                : Math.floor(infoSize) + "MB")
            );
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return (
              "视频大小：" +
              (Math.floor(infoSize) == 0
                ? Math.floor(size / 1024) + "KB"
                : Math.floor(infoSize) + "MB")
            );
          } else {
            return (
              "文件大小：" +
              (Math.floor(infoSize) == 0
                ? Math.floor(size / 1024) + "KB"
                : Math.floor(infoSize) + "MB")
            );
          }
        }
      };
    },
    setKb() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else if (size == 0) {
          return "文件大小：" + 0 + "KB";
        } else {
          const infoSize = size / 1024;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "KB";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "KB";
          } else {
            return "文件大小：" + Math.floor(infoSize) + "KB";
          }
        }
      };
    },
    setB() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else if (size == 0) {
          return "文件大小：" + 0 + "B";
        } else {
          const infoSize = size;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "B";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "B";
          } else {
            return "文件大小：" + Math.floor(infoSize) + "B";
          }
        }
      };
    },
  },
};
</script>

<template>
  <Layout>
    <div class="kf">
      <img
        class="kf-tx"
        @click="kfShow = true"
        v-show="kfShow == false"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-touxiang.png"
        alt=""
      />
      <img
        class="kf-qr"
        v-show="kfShow == true && appid == 'wx1e899bddb256a5ca'"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-jiajia-qr.png"
        alt=""
      />
      <img
        class="kf-qr"
        v-show="kfShow == true && appid == 'wx7d8daf6d777947a2'"
        style="width: 190px; top: 8px"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-guanjia-qr.png"
        alt=""
      />
      <img
        class="kf-close"
        @click="kfShow = false"
        v-show="kfShow == true"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-chabutton.png"
        alt=""
      />
    </div>

    <div class="row">
      <div class="outBox">
        <div class="bigTitle">
          {{ selectType == "add" ? "创建" : "编辑" }}{{ activeBuildTitle }}
        </div>

        <!--      封面-->
        <div class="blockBox">
          <div class="flex-depart-center fm-block">
            <div class="flex-depart-center-top fm-select">
              <span>版式选择</span>
              <img
                class="yanshiBtn"
                @click="demonstrate(1)"
                src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                alt=""
              />
            </div>
            <div class="fm-b-right ms-block flex-depart-center">
              <div
                class="ms"
                @click="changeMode(2)"
                :class="{ 'ms-active': activityMode == 2 }"
              >
                接龙模式
              </div>
              <div
                class="ms"
                @click="changeMode(1)"
                :class="{ 'ms-active': activityMode == 1 }"
              >
                报名模式
              </div>
            </div>
          </div>
          <div class="fm-flex" v-if="activityMode == 1">
            <!--                        <img :src="activityModeUrl" v-if="isVideo == 2" alt="">-->
            <div class="fm-pics-block" v-if="isVideo == 2">
              <el-carousel indicator-position="outside">
                <el-carousel-item
                  v-for="(item, index) in turnPictures"
                  :key="index"
                >
                  <div
                    class="pic-out-box"
                    :style="{
                      background: 'url(' + item + ') no-repeat center',
                      backgroundSize: 'cover',
                    }"
                  ></div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div
              v-if="isVideo == 1"
              style="background-color: #000; margin-top: 10px"
            >
              <video controls width="420" height="240">
                <source :src="playUrl" type="video/mp4" />
                Sorry, your browser doesn't support embedded videos.
              </video>
            </div>

            <div class="fm-btns flex-depart-center">
              <!-- <el-button @click="selectSysPic">选择系统封面</el-button>
                            <el-dropdown>
                                <el-button type="primary">
                                    上传自定义封面<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <input class="updateFileBtn" type="file" id="uploadImageBtn" accept="image/*"
                                               @change="(event) => handleCoverImgUpload(event)"/>
                                        上传图片
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <input class="updateFileBtn" type="file" id="videoInput5" accept=".mp4"
                                               @change="(event) => handleVideoFmUpload(event)"/>
                                        上传视频
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
              <!-- <div class="zdy-btn" @click="openIV">上传自定义封面</div>
                            <span>推荐上传图片的宽高比例为5:4</span> -->
              <el-button type="primary" @click="openCoverSetting">
                封面设置
              </el-button>
            </div>
          </div>
        </div>

        <div class="blockBox">
          <!--                    <div class="block-title">接龙名称</div>-->
          <div class="centerTitle" style="margin-top: -5px">
            <el-input
              v-model="activityDetail.name"
              placeholder="请输入标题"
              style="text-align: center"
              maxlength="30"
            ></el-input>
          </div>
          <div
            class="b-marT-10"
            :class="{
              zsy: modularList.length <= 1,
              nozsy: modularList.length >= 2,
            }"
          >
            <el-input
              type="textarea"
              class="zsy-inner"
              v-model="activityDetail.content"
              placeholder="请输入内容"
              rows="5"
            ></el-input>
          </div>
          <!-- todo 详情页展示列表 -->

          <div v-for="(item, index) in modularList" :key="index">
            <!-- 内容 -->
            <div class="block-for-box" v-if="item.type == 1">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.title"
                    placeholder="请输入标题"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <el-input
                  type="textarea"
                  v-model="item.info.value"
                  placeholder="请输入内容"
                  rows="5"
                ></el-input>
              </div>
            </div>
            <!-- 大图 -->
            <div class="block-for-box" v-if="item.type == 9">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="大图"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div
                class="b-marT-10"
                v-for="(imgItem, imgIndex) in item.info.imgarr"
                :key="imgIndex"
              >
                <div class="flex-depart-top">
                  <div class="big-img">
                    <!--                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/5c2333976171b.jpg" alt="">-->
                    <img :src="imageUrl + imgItem" alt="" />
                  </div>
                  <div class="flex-depart-column-top-left b-handle">
                    <img
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                      alt=""
                      @click="upBigImg(imgIndex, index)"
                    />
                    <img
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                      alt=""
                      @click="downBigImg(imgIndex, index)"
                    />
                    <img
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                      alt=""
                      @click="delBigImg(imgIndex, index)"
                    />
                  </div>
                </div>
              </div>
              <div
                class="addSmallBtn b-marT-10"
                style="border: 1px dashed #4a73f7"
                v-if="item.info.imgarr.length < 9"
              >
                <input
                  class="updateFileBtn"
                  type="file"
                  id="imageInput"
                  multiple
                  accept="image/*"
                  @change="(event) => handleImgUpload(event, index)"
                />
                <i class="el-icon-circle-plus"></i>&nbsp;点击上传大图
              </div>
            </div>
            <!-- 小图 -->
            <div class="block-for-box" v-if="item.type == 3">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="小图"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10 flex-depart-left-warp">
                <div
                  class="smallImgbox seeBigImgHover"
                  v-for="(imgItem, imgIndex) in item.info.imgarr"
                  :key="imgIndex"
                >
                  <div class="handle2">
                    <img
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-chakandatu.svg"
                      @click="seeBigImg(imgItem)"
                      alt=""
                    />
                    <img
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchuxiaotu.svg"
                      @click="delSmallPic(imgIndex, index)"
                      alt=""
                    />
                  </div>
                  <div
                    class="imgBg"
                    :style="{
                      background: `url(${imageUrl + imgItem}) no-repeat center`,
                      backgroundSize: 'cover',
                    }"
                  ></div>
                </div>
                <div
                  class="upl-smallImg"
                  style="border: 1px solid #dedfe2"
                  v-if="item.info.imgarr.length < 9"
                >
                  <input
                    class="updateFileBtn"
                    type="file"
                    id="imageInput2"
                    multiple
                    accept="image/*"
                    @change="(event) => handleSmallImgUpload(event, index)"
                  />
                  <i class="el-icon-circle-plus"></i>
                  <span>上传小图</span>
                </div>
              </div>
            </div>
            <!-- 地点 -->
            <div class="block-for-box" v-if="item.type == 4">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="地址"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>

              <div class="b-marT-10">
                <div style="font-weight: bold">{{ item.info.name }}</div>
                <div>{{ item.info.address }}</div>
                <el-button
                  v-if="!item.info.address"
                  @click="openMap(index)"
                  class="map-btn"
                  >选择位置</el-button
                >
                <el-button
                  v-if="item.info.address"
                  @click="openMap(index)"
                  class="map-btn"
                  >重新选择</el-button
                >
              </div>
            </div>
            <!-- 文件 -->
            <div class="block-for-box" v-if="item.type == 5">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="文件"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <div
                  class="filesStyle flex-depart-center hoverColor1"
                  v-for="(fileItem, fileIndex) in item.info.filesArr"
                  :key="fileIndex"
                >
                  <div class="flex-depart-left">
                    <img
                      v-if="fileItem.lastName == 'doc'"
                      :src="imageUrl + '/static/announcement/word.png'"
                      class="Img3"
                    />
                    <img
                      v-else-if="fileItem.lastName == 'docx'"
                      :src="imageUrl + '/static/announcement/word.png'"
                      class="Img3"
                    />
                    <img
                      v-else-if="fileItem.lastName == 'pdf'"
                      :src="imageUrl + '/static/announcement/PDF.png'"
                      class="Img3"
                    />
                    <img
                      v-else-if="fileItem.lastName == 'ppt'"
                      :src="imageUrl + '/static/announcement/PPT.png'"
                      class="Img3"
                    />
                    <img
                      v-else-if="fileItem.lastName == 'xls'"
                      :src="imageUrl + '/static/index/excel.png'"
                      class="Img3"
                    />
                    <img
                      v-else-if="fileItem.lastName == 'xlsx'"
                      :src="imageUrl + '/static/index/excel.png'"
                      class="Img3"
                    />
                    <img
                      v-else-if="fileItem.lastName == 'zip'"
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                      class="Img3"
                    />
                    <span>{{ fileItem.name }}</span
                    >/
                    <span v-if="fileItem.size / 1024 <= 1">{{
                      setB(fileItem.size, fileItem.lastName)
                    }}</span>
                    <span
                      v-else-if="
                        fileItem.size / 1024 >= 1 &&
                        fileItem.size / 1048576 <= 1
                      "
                      >{{ setKb(fileItem.size, fileItem.lastName) }}</span
                    >
                    <span v-else-if="fileItem.size / 1048576 >= 1">{{
                      setMb(fileItem.size, fileItem.lastName)
                    }}</span>
                  </div>
                  <i
                    class="el-icon-delete del"
                    @click="delFiles(fileIndex, index)"
                  ></i>
                </div>
              </div>
              <div class="addSmallBtn b-marT-10">
                <input
                  class="updateFileBtn"
                  type="file"
                  id="imageInput3"
                  multiple
                  accept=".xls,.xlsx,.docx,.pdf,.ppt,.zip"
                  @change="(event) => handleFileUpload(event, index)"
                />
                <i class="el-icon-circle-plus"></i>&nbsp;点击上传文件
              </div>
            </div>
            <!-- 音频 -->
            <div class="block-for-box" v-if="item.type == 6">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="音频"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <div
                  class="filesStyle flex-depart-center hoverColor1"
                  v-for="(fileItem, fileIndex) in item.info.filesArr"
                  :key="fileIndex"
                >
                  <div
                    class="flex-depart-left"
                    @click="openMusic(fileItem)"
                    style="cursor: pointer"
                  >
                    <img
                      :src="imageUrl + '/static/announcement/MP3.png'"
                      class="Img3"
                    />
                    <span>{{ fileItem.name }}</span
                    >/
                    <span v-if="fileItem.size / 1024 <= 1">{{
                      setB(fileItem.size, fileItem.lastName)
                    }}</span>
                    <span
                      v-else-if="
                        fileItem.size / 1024 >= 1 &&
                        fileItem.size / 1048576 <= 1
                      "
                      >{{ setKb(fileItem.size, fileItem.lastName) }}</span
                    >
                    <span v-else-if="fileItem.size / 1048576 >= 1">{{
                      setMb(fileItem.size, fileItem.lastName)
                    }}</span>
                  </div>
                  <i
                    class="el-icon-delete del"
                    @click="delFiles(fileIndex, index)"
                  ></i>
                </div>
              </div>
              <div class="addSmallBtn b-marT-10">
                <input
                  class="updateFileBtn"
                  type="file"
                  id="imageInput4"
                  accept=".mp3"
                  multiple
                  @change="(event) => handleMpThreeUpload(event, index)"
                />
                <i class="el-icon-circle-plus"></i>&nbsp;点击上传音频
              </div>
            </div>
            <!-- 视频 -->
            <div class="block-for-box" v-if="item.type == 7">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="视频"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10" v-if="item.info.fileUrl != ''">
                <video controls width="450">
                  <source
                    :src="imageUrl + `${item.info.fileUrl}`"
                    type="video/mp4"
                  />
                  Sorry, your browser doesn't support embedded videos.
                </video>
              </div>
              <div class="addSmallBtn b-marT-10">
                <input
                  class="updateFileBtn"
                  type="file"
                  id="imageInput5"
                  accept=".mp4"
                  @change="(event) => handleMpFourUpload(event, index)"
                />
                <i class="el-icon-circle-plus"></i>&nbsp;{{
                  item.info.fileUrl == "" ? "点击上传视频" : "更改视频"
                }}
              </div>
            </div>

            <!-- 公众号 -->
            <div class="block-for-box" v-if="item.type == 10">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="公众号"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">标题</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.officialAccountTitle"
                  placeholder="请输入公众号文章标题"
                ></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">公众号文章链接</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.link"
                  placeholder="请输入公众号文章链接"
                ></el-input>
              </div>
            </div>

            <!-- 视频号 -->
            <div class="block-for-box" v-if="item.type == 11">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="视频号"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">视频号标题</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.videoNumberTitle"
                  placeholder="请输入视频号标题"
                ></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">视频号ID</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.videoNumberID"
                  placeholder="请输入以sph开头的视频号ID"
                ></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">视频ID</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.videoId"
                  placeholder="请输入视频ID"
                ></el-input>
              </div>
            </div>

            <!-- 其他小程序 -->
            <div class="block-for-box" v-if="item.type == 12">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="其他小程序标题"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">标题</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.appTitle"
                  placeholder="请输入小程序展示标题"
                ></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">小程序APPID</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.appid"
                  placeholder="请输入小程序APPID"
                ></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">小程序页面路径</p>
                <el-input
                  class="f-ipt"
                  v-model="item.info.pagePath"
                  placeholder="请输入小程序页面路径"
                ></el-input>
              </div>
            </div>

            <!-- 关联接龙 -->
            <div class="block-for-box" v-if="item.type == 14">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="其他小程序标题"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div
                class="b-marT-10 gljl-block flex-depart-center"
                @click="addgljl(index)"
                v-for="(fileItem, fileIndex) in item.info.associationActivityId"
                :key="fileIndex"
              >
                <div>{{ fileItem.name }}</div>
                <i
                  class="el-icon-delete del"
                  @click.stop="delRelatedFiles(fileIndex, index)"
                ></i>
              </div>

              <div class="b-marT-10">
                <div class="gl-btnStyle" @click="addgljl(index)">
                  点击添加关联接龙
                </div>
              </div>
            </div>

            <!-- 可复制内容 -->
            <div class="block-for-box" v-if="item.type == 13">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input
                    class="f-ipt"
                    v-model="item.info.value"
                    placeholder="可复制内容"
                  ></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png"
                    alt=""
                    @click="moveUp(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png"
                    alt=""
                    @click="moveDown(index)"
                  />
                  <img
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchu1.png"
                    alt=""
                    @click="delmodular(item, index)"
                  />
                </div>
              </div>
              <div class="b-marT-10">
                <el-input
                  type="textarea"
                  v-model="item.info.value"
                  rows="5"
                  placeholder="请输入可复制内容"
                ></el-input>
              </div>
            </div>
          </div>

          <!-- todo 详情页展示添加按钮 -->
          <div class="handle-box b-marT-10">
            <div class="flex-depart-left h-item" @click="addModule(0)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-zdingyi.svg"
                alt=""
              />
              <span>自定义内容</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(7)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-datu.svg"
                alt=""
              />
              <span>大图</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(2)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-jiugongge.svg"
                alt=""
                style="margin-right: 3px"
              />
              <span>九宫格图片</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(3)">
              <i
                style="font-size: 17px; margin-right: 3px"
                class="el-icon-location-outline"
              ></i>
              <span>位置</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(4)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-wenjian.svg"
                alt=""
              />
              <span>文件</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(5)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-yinpin.svg"
                alt=""
              />
              <span>音频</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(6)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shipin.svg"
                alt=""
              />
              <span>视频</span>
            </div>

            <div class="flex-depart-left h-item" @click="addModule(8)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-gongzhonghao.svg"
                alt=""
              />
              <span>公众号</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(9)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shipinhao.svg"
                alt=""
              />
              <span>视频号</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(10)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-qitaxiaochegnxu.svg"
                alt=""
              />
              <span>其他小程序</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(12)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-guanlian.svg"
                alt=""
              />
              <span>关联接龙</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(11)">
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kefuzi.svg"
                alt=""
              />
              <span>可复制内容</span>
            </div>
          </div>
        </div>
        <div class="blockBox" style="position: relative; padding: 10px 15px">
          <div class="flex-depart-center name-title">
            <div class="name-title-left">
              <span>参与名单</span>
              <span v-if="clockSwitch == 2">（{{ nameListLength }}人）</span>
              <img
                src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                alt=""
                style="position: relative; top: 4px"
                class="yanshiBtn"
                @click="demonstrate(11)"
              />
            </div>
            <div class="flex-depart-center">

              <div @click="relayList" style="display: flex;align-items: center; justify-content: center;">
							<span style="font-size: 28rpx;color: #1877FF;">{{ clockSwitch==1 ? '不启用' : (nameAddType == '2' ? '添加分组+名单' : '仅添加名单') }}</span>
              <i class="el-icon-arrow-right" color="#1877FF"></i>
              </div>
              <!-- <el-switch
                v-model="clockSwitch"
                @change="clockSwitchFn($event)"
                active-color="#1877FF"
                inactive-color="rgb(230, 230, 230)"
                active-value="2"
                inactive-value="1"
              ></el-switch>
              <div class="add-tools" v-if="clockSwitch == 2">
                <div class="add-tools-item" @click="relayList">
                  <i class="el-icon-plus"></i>
                  <span class="add-tools-item-text">添加</span>
                </div>
              </div> -->
            </div>
          </div>

          <div
            class="flex-depart-center-top"
            v-if="nameAddType == '2' && clockSwitch == 2"
          >
            <span>分组：</span>
            <el-select
              v-model="pickerNameSelect"
              placeholder="请选择"
              @change="selectGrouping"
            >
              <el-option
                v-for="(mItem, mIndex) in pickerNameSelectArr"
                :key="mIndex"
                :label="mItem.label"
                :value="mItem.value"
              ></el-option>
            </el-select>
          </div>
          <template v-if="clockSwitch == 2">
            <div class="jlName" v-if="packetData.length">
              <div class="listName">
                <div
                  class="spanDiv"
                  v-for="(item, index) in packetData.slice(
                    0,
                    (activityDetail.clockListNumber || 5) * 4 - 1
                  )"
                  :key="index"
                  :style="{
                    lineHeight:
                      activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                    width:
                      activityDetail.clockListNumber === 2
                        ? 'calc(50% - 8px)'
                        : activityDetail.clockListNumber === 3
                        ? 'calc(33.33% - 8px)'
                        : activityDetail.clockListNumber === 4
                        ? 'calc(25% - 8px)'
                        : 'calc(20% - 8px)',
                  }"
                >
                  <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                    index + 1
                  }}</span>
                  {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                </div>
                <div
                  class="spanDiv"
                  :style="{
                    lineHeight:
                      activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                    width:
                      activityDetail.clockListNumber === 2
                        ? 'calc(50% - 8px)'
                        : activityDetail.clockListNumber === 3
                        ? 'calc(33.33% - 8px)'
                        : activityDetail.clockListNumber === 4
                        ? 'calc(25% - 8px)'
                        : 'calc(20% - 8px)',
                  }"
                  style="
                    width: calc(20% - 8px);
                    background: #ebf3ff;
                    border: 1px dashed #1877ff;
                    cursor: pointer;
                    color: #1877ff;
                  "
                  @click="editFzNameList"
                >
                  编辑名单
                </div>
                <div
                  v-for="n in 8"
                  :key="'empty' + n"
                  class="spanDivEmpty"
                  :style="{
                    width:
                      activityDetail.clockListNumber === 2
                        ? 'calc(50% - 8px)'
                        : activityDetail.clockListNumber === 3
                        ? 'calc(33.33% - 8px)'
                        : activityDetail.clockListNumber === 4
                        ? 'calc(25% - 8px)'
                        : 'calc(20% - 8px)',
                  }"
                ></div>
              </div>
            </div>
          </template>

          <div class="name-flex" v-if="clockSwitch == 2 && packetData.length">
            <div class="flex-left">
              <div class="count">每排数量</div>
              <div class="flex-dropdown" v-if="packetData.length">
                <el-dropdown @command="clockListNumFn">
                  <span class="el-dropdown-link">
                    {{ `一排${clockListNumber}个` }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="item in clockListNumArr"
                      :key="item.value"
                      :command="item.value"
                      >{{ item.label }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="flex-right">
              预览仅展示{{ activityDetail.clockListNumber }}排
            </div>
          </div>
        </div>

        <!-- todo 填表项循环 -->
        <div class="blockBox">
          <div class="block-title">
            填表项设置<img
              class="yanshiBtn"
              @click="demonstrate(2)"
              src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
              alt=""
            />
          </div>
          <div class="cannotEditStyle" v-if="commonDisabled == true">
            *编辑填表项，已报名的人员信息会有所变动。
          </div>
          <div v-for="(listItem, listIndex) in listList" :key="listIndex">
            <div
              v-for="(fieldItem, fieldIndex) in listItem.signField"
              :key="fieldIndex"
            >
              <div v-if="fieldItem.type == 1">
                <!--姓名等-->
                <div
                  class="f-block flex-depart-leftStart"
                  v-if="fieldItem.num == 3"
                >
                  <div class="left-ttype">单行文本</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ fieldIndex + 1 }}、
                        <el-input
                          class="f-ipt"
                          v-model="fieldItem.fieldName"
                          placeholder="姓名"
                        ></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img
                          :src="imgUpMoveSrc"
                          alt=""
                          @click="
                            topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgDownMoveSrc"
                          alt=""
                          @click="
                            bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgCancelSrc"
                          alt=""
                          @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                        />
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span
                          class="sxsz"
                          @click="attributeSet(fieldItem, fieldIndex)"
                          >属性设置</span
                        >
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox
                          v-model="fieldItem.encryption"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              encryptionChange($event, fieldIndex, listIndex)
                          "
                        >
                          保密
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isRequired"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isRequiredChange($event, fieldIndex, listIndex)
                          "
                        >
                          必填
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isOpen"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isOpenChange($event, fieldIndex, listIndex)
                          "
                        >
                          公开
                        </el-checkbox>
                        <div
                          class="flex-depart-left ch-copy"
                          @click="copyThisSignField(fieldIndex, listIndex)"
                        >
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="f-block flex-depart-leftStart"
                  v-else-if="fieldItem.num == 4"
                >
                  <div class="left-ttype">单行文本</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ fieldIndex + 1 }}、
                        <el-input
                          class="f-ipt"
                          v-model="fieldItem.fieldName"
                          placeholder="姓名"
                        ></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img
                          :src="imgUpMoveSrc"
                          alt=""
                          @click="
                            topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgDownMoveSrc"
                          alt=""
                          @click="
                            bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgCancelSrc"
                          alt=""
                          @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                        />
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span
                          class="sxsz"
                          @click="attributeSet(fieldItem, fieldIndex)"
                          >属性设置</span
                        >
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox
                          v-model="fieldItem.encryption"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              encryptionChange($event, fieldIndex, listIndex)
                          "
                        >
                          保密
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isRequired"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isRequiredChange($event, fieldIndex, listIndex)
                          "
                        >
                          必填
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isOpen"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isOpenChange($event, fieldIndex, listIndex)
                          "
                        >
                          公开
                        </el-checkbox>
                        <div
                          class="flex-depart-left ch-copy"
                          @click="copyThisSignField(fieldIndex, listIndex)"
                        >
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="f-block flex-depart-leftStart" v-else>
                  <div class="left-ttype">单行文本</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ fieldIndex + 1 }}、
                        <el-input
                          class="f-ipt"
                          v-model="fieldItem.fieldName"
                          placeholder="姓名"
                        ></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img
                          :src="imgUpMoveSrc"
                          alt=""
                          @click="
                            topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgDownMoveSrc"
                          alt=""
                          @click="
                            bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgCancelSrc"
                          alt=""
                          @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                        />
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span
                          class="sxsz"
                          @click="attributeSet(fieldItem, fieldIndex)"
                          >属性设置</span
                        >
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox
                          v-model="fieldItem.encryption"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              encryptionChange($event, fieldIndex, listIndex)
                          "
                        >
                          保密
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isRequired"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isRequiredChange($event, fieldIndex, listIndex)
                          "
                        >
                          必填
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isOpen"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isOpenChange($event, fieldIndex, listIndex)
                          "
                        >
                          公开
                        </el-checkbox>
                        <div
                          class="flex-depart-left ch-copy"
                          @click="copyThisSignField(fieldIndex, listIndex)"
                        >
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--数量-->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 13"
              >
                <div class="left-ttype">数量</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="数量"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 手机号 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 11"
              >
                <div class="left-ttype">手机号</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="手机号"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 身份证-->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 10"
              >
                <div class="left-ttype">身份证</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="身份证"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 位置 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 12"
              >
                <div class="left-ttype">位置</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="你所在的位置"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 单选/性别/其他 -->
              <template v-if="fieldItem.type == 2">
                <div
                  class="f-block flex-depart-leftStart"
                  v-if="fieldItem.num == 1"
                >
                  <div class="left-ttype">单选</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ fieldIndex + 1 }}、
                        <el-input
                          class="f-ipt"
                          v-model="fieldItem.fieldName"
                          placeholder="请输入自定义内容"
                        ></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img
                          :src="imgUpMoveSrc"
                          alt=""
                          @click="
                            topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgDownMoveSrc"
                          alt=""
                          @click="
                            bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgCancelSrc"
                          alt=""
                          @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-depart-left selectBox-item b-marT-10"
                      v-for="(itexb, idx) in fieldItem.content"
                      :key="idx"
                    >
                      {{ idx + 1 }}、
                      <el-input
                        class="opt-name-input"
                        v-model="itexb.value"
                        placeholder="请输入自定义内容"
                      ></el-input>
                      <el-input
                        class="opt-num-input"
                        maxlength="10"
                        :value="itexb.maxNum === -1 ? '' : itexb.maxNum"
                        placeholder="数量不限"
                        @input="handleNumValueChange($event, itexb)"
                        @focus="handleNumValueFocus(itexb)"
                      >
                        ></el-input
                      >
                      <i
                        class="el-icon-remove-outline"
                        @click="delInp(fieldItem, idx, fieldIndex, listIndex)"
                      ></i>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div
                        class="addOptStyle"
                        @click="addInp(fieldItem, fieldIndex, listIndex)"
                      >
                        + 添加单选选项
                      </div>
                      <div
                        class="addOptStyle"
                        @click="batchSetNum(fieldItem, fieldIndex)"
                      >
                        批量设置数量
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span
                          class="sxsz"
                          @click="attributeSet(fieldItem, fieldIndex)"
                          >属性设置</span
                        >
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox
                          v-model="fieldItem.encryption"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              encryptionChange($event, fieldIndex, listIndex)
                          "
                        >
                          保密
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isRequired"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isRequiredChange($event, fieldIndex, listIndex)
                          "
                        >
                          必填
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isOpen"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isOpenChange($event, fieldIndex, listIndex)
                          "
                        >
                          公开
                        </el-checkbox>
                        <div
                          class="flex-depart-left ch-copy"
                          @click="copyThisSignField(fieldIndex, listIndex)"
                        >
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="f-block flex-depart-leftStart"
                  v-else-if="fieldItem.num == 2"
                >
                  <div class="left-ttype">单选</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ fieldIndex + 1 }}、
                        <el-input
                          class="f-ipt"
                          v-model="fieldItem.fieldName"
                          placeholder="性别"
                        ></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img
                          :src="imgUpMoveSrc"
                          alt=""
                          @click="
                            topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgDownMoveSrc"
                          alt=""
                          @click="
                            bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgCancelSrc"
                          alt=""
                          @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-depart-left selectBox-item b-marT-10"
                      v-for="(itexb, idx) in fieldItem.content"
                      :key="idx"
                    >
                      {{ idx + 1 }}、
                      <el-input
                        v-model="itexb.value"
                        placeholder="男"
                        disabled
                      ></el-input>
                      <i
                        v-if="fieldItem.content.length > 2"
                        class="el-icon-remove-outline"
                      ></i>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span
                          class="sxsz"
                          @click="attributeSet(fieldItem, fieldIndex)"
                          >属性设置</span
                        >
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox
                          v-model="fieldItem.encryption"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              encryptionChange($event, fieldIndex, listIndex)
                          "
                        >
                          保密
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isRequired"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isRequiredChange($event, fieldIndex, listIndex)
                          "
                        >
                          必填
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isOpen"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isOpenChange($event, fieldIndex, listIndex)
                          "
                        >
                          公开
                        </el-checkbox>
                        <div
                          class="flex-depart-left ch-copy"
                          @click="copyThisSignField(fieldIndex, listIndex)"
                        >
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="f-block flex-depart-leftStart" v-else>
                  <div class="left-ttype">单选</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ fieldIndex + 1 }}、
                        <el-input
                          class="f-ipt"
                          v-model="fieldItem.fieldName"
                          placeholder=""
                        ></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img
                          :src="imgUpMoveSrc"
                          alt=""
                          @click="
                            topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgDownMoveSrc"
                          alt=""
                          @click="
                            bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          "
                        />
                        <img
                          :src="imgCancelSrc"
                          alt=""
                          @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-depart-left selectBox-item b-marT-10"
                      v-for="(itexb, idx) in fieldItem.content"
                      :key="idx"
                    >
                      {{ idx + 1 }}、
                      <el-input
                        v-model="itexb.value"
                        maxlength="50"
                        placeholder=""
                        disabled
                      ></el-input>
                      <el-input
                        maxlength="10"
                        :value="itexb.maxNum === -1 ? '' : itexb.maxNum"
                        placeholder="数量不限"
                        @input="handleNumValueChange($event, itexb)"
                        @focus="handleNumValueFocus(itexb)"
                      ></el-input>
                      <i
                        v-if="fieldItem.content.length > 2"
                        class="el-icon-remove-outline"
                      ></i>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div
                        class="addOptStyle"
                        @click="addInp(fieldItem, fieldIndex, listIndex)"
                      >
                        添加选项
                      </div>
                      <div
                        class="addOptStyle"
                        @click="batchSetNum(fieldItem, fieldIndex)"
                      >
                        批量设置数量
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span
                          class="sxsz"
                          @click="attributeSet(fieldItem, fieldIndex)"
                          >属性设置</span
                        >
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox
                          v-model="fieldItem.encryption"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              encryptionChange($event, fieldIndex, listIndex)
                          "
                        >
                          保密
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isRequired"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isRequiredChange($event, fieldIndex, listIndex)
                          "
                        >
                          必填
                        </el-checkbox>
                        <el-checkbox
                          v-model="fieldItem.isOpen"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            ($event) =>
                              isOpenChange($event, fieldIndex, listIndex)
                          "
                        >
                          公开
                        </el-checkbox>
                        <div
                          class="flex-depart-left ch-copy"
                          @click="copyThisSignField(fieldIndex, listIndex)"
                        >
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 音频 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 7"
              >
                <div class="left-ttype">音频</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="音频"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 视频 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 6"
              >
                <div class="left-ttype">视频</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请填写视频标题"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多选 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 4"
              >
                <div class="left-ttype">多选</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请输入自定义内容"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div
                    class="flex-depart-left selectBox-item b-marT-10"
                    v-for="(ite1, idx1) in fieldItem.content"
                    :key="idx1"
                  >
                    {{ idx1 + 1 }}、
                    <el-input
                      class="opt-name-input"
                      v-model="ite1.value"
                      placeholder="请输入自定义内容"
                    ></el-input>
                    <el-input
                      class="opt-num-input"
                      maxlength="10"
                      :value="ite1.maxNum === -1 ? '' : ite1.maxNum"
                      placeholder="数量不限"
                      @input="handleNumValueChange($event, ite1)"
                      @focus="handleNumValueFocus(ite1)"
                    >
                      ></el-input
                    >

                    <i
                      class="el-icon-remove-outline"
                      @click="delInp(fieldItem, idx1, fieldIndex, listIndex)"
                    ></i>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div
                      class="addOptStyle"
                      @click="addInp(fieldItem, fieldIndex, listIndex)"
                    >
                      + 添加多选选项
                    </div>
                    <div
                      class="addOptStyle"
                      @click="batchSetNum(fieldItem, fieldIndex)"
                    >
                      批量设置数量
                    </div>
                  </div>

                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多行文本 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 9"
              >
                <div class="left-ttype">多行文本</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请输入自定义标题"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 学校/院系/公司/职位/部门/单位 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="
                  fieldItem.type == 21 ||
                  fieldItem.type == 22 ||
                  fieldItem.type == 25 ||
                  fieldItem.type == 26 ||
                  fieldItem.type == 27 ||
                  fieldItem.type == 28
                "
              >
                <div class="left-ttype">单行文本</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请输入自定义标题"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 邮箱/工号/学号 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="
                  fieldItem.type == 19 ||
                  fieldItem.type == 23 ||
                  fieldItem.type == 24
                "
              >
                <div class="left-ttype">单行文本</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请输入自定义标题"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 水印拍照 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 20"
              >
                <div class="left-ttype">水印拍照</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="水印拍照"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 日期 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 3"
              >
                <div class="left-ttype">日期</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请输入自定义标题"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多图 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 5"
              >
                <div class="left-ttype">图片</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="图片"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div class="flex-depart-left">
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 省市区 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 8"
              >
                <div class="left-ttype">省市区</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="请选择省市区"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 32"
              >
                <div class="left-ttype">文件</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="文件"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 签名 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 29"
              >
                <div class="left-ttype">签名</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="文件"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 时间区间 -->
              <div
                class="f-block flex-depart-leftStart"
                v-if="fieldItem.type == 31"
              >
                <div class="left-ttype">时间区间</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ fieldIndex + 1 }}、
                      <el-input
                        class="f-ipt"
                        v-model="fieldItem.fieldName"
                        placeholder="时间区间"
                      ></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img
                        :src="imgUpMoveSrc"
                        alt=""
                        @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)"
                      />
                      <img
                        :src="imgDownMoveSrc"
                        alt=""
                        @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        "
                      />
                      <img
                        :src="imgCancelSrc"
                        alt=""
                        @click="delMuKuai(fieldItem, fieldIndex, listIndex)"
                      />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span
                        class="sxsz"
                        @click="attributeSet(fieldItem, fieldIndex)"
                        >属性设置</span
                      >
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox
                        v-model="fieldItem.encryption"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        "
                      >
                        保密
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isRequired"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        "
                      >
                        必填
                      </el-checkbox>
                      <el-checkbox
                        v-model="fieldItem.isOpen"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        "
                      >
                        公开
                      </el-checkbox>
                      <div
                        class="flex-depart-left ch-copy"
                        @click="copyThisSignField(fieldIndex, listIndex)"
                      >
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="b-marT-20 flex-depart-center-center">
            <div class="addBtnStyle" @click="openfieldList">
              <i
                class="el-icon-circle-plus-outline"
                style="position: relative; top: -1px"
              ></i
              >添加填写项
            </div>
          </div>
        </div>
        <!-- todo 设置 -->
        <template>
          <div class="set-out-box">
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">接龙起止时间</span>
              <div class="flex-depart-center mar-bot-check-0">
                <el-checkbox
                  v-model="foreverValidChecked"
                  @change="foreverValidChange"
                  >永久有效
                </el-checkbox>
                <div
                  class="flex-depart-center"
                  v-show="foreverValidChecked == true"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="activityDetail.beginTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </div>
                <div
                  v-show="foreverValidChecked == false"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="actStartAndEndTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="actStartAndEndTimeFun"
                  ></el-date-picker>
                </div>
              </div>
            </div>
            <!-- -------------------打卡部分开始---------------------- -->
            <div v-if="isType == '109' || isType == '110'">
              <div class="settingBox b-marT-10 flex-depart-center">
                <span class="sTitle">打卡提醒</span>
                <div>
                  <el-radio-group
                    v-removeAriaHidden
                    v-model="formClock.clockRemindStatus"
                    @input="clockRemindFun"
                  >
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="2">关闭</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div
                class="settingBox flex-depart-center"
                v-if="formClock.clockRemindStatus == 1"
              >
                <span class="sTitle">打卡提醒时间</span>
                <div>
                  <el-time-picker
                    v-model="formClock.remindTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="任意时间点"
                    @change="clockTime"
                  ></el-time-picker>
                </div>
              </div>
              <div class="settingBox b-marT-10 flex-depart-center">
                <span class="sTitle">打卡频率</span>
                <div>
                  <el-select
                    v-model="selectFrequency"
                    placeholder="请选择"
                    @change="clickin"
                  >
                    <el-option
                      v-for="item in CheckInFrequency"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <template v-if="selectFrequency == 3">
                <div class="settingBox b-marT-10 flex-depart-center">
                  <span class="sTitle">允许一天内多次打卡</span>
                  <div>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="formClock.checkSwitch"
                    >
                      <el-radio :label="2">开启</el-radio>
                      <el-radio :label="1">关闭</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div
                  class="settingBox b-marT-10 flex-depart-center"
                  v-if="formClock.checkSwitch == 2"
                >
                  <span class="sTitle">每天打卡次数</span>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <el-input
                      v-model="formClock.checkTimes"
                      size="small"
                      placeholder="请输入"
                      @input="handleInput"
                      class="w-50"
                    />
                  </div>
                </div>
              </template>

              <div
                class="settingBox flex-depart-center"
                v-if="selectFrequency == 6"
              >
                <el-checkbox-group
                  v-model="candidateList"
                  @change="candidateChange"
                >
                  <el-checkbox
                    v-for="item in candidates"
                    :key="item.value"
                    :label="item.value"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div
                class="settingBox b-marT-10 flex-depart-center"
                v-if="selectFrequency == 7"
              >
                <span class="sTitle"
                  >打卡日期选择<label class="cus-dates"
                    >已选择{{ customDateArr.length }}个日期</label
                  ></span
                >
                <div>
                  <el-date-picker
                    type="dates"
                    v-model="customDateArr"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择一个或多个日期"
                    @change="multipleDateSure"
                  ></el-date-picker>
                </div>
              </div>
              <div
                class="settingBox b-marT-10"
                v-if="selectFrequency == 1 || selectFrequency == 2"
              >
                <div class="flex-depart-center">
                  <span class="sTitle"
                    >允许每{{
                      selectFrequency == 1 ? "月" : "周"
                    }}多次打卡</span
                  >
                  <div>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="formClock.clockMaxSwitch"
                      @input="clockMaxSwitchFn"
                    >
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div
                  class="flex-depart-center"
                  style="padding-top: 10px"
                  v-if="
                    (selectFrequency == 1 || selectFrequency == 2) &&
                    formClock.clockMaxSwitch == 1
                  "
                >
                  <div>每{{ selectFrequency == 1 ? "月" : "周" }}打卡</div>
                  <div>
                    <el-input
                      style="width: 100px"
                      v-model="formClock.clockMaxNum"
                      placeholder="请输入内容"
                    ></el-input
                    >&nbsp;次
                  </div>
                </div>
              </div>
              <div
                class="settingBox b-marT-10 flex-depart-center"
                v-if="selectFrequency == 1 || selectFrequency == 2"
              >
                <span class="sTitle"
                  >每{{ selectFrequency == 1 ? "月" : "周" }}截止打卡时间</span
                >
                <div class="flex-depart-center-end">
                  <div class="deadline" v-if="selectFrequency == 1">
                    <el-select
                      v-model="monthDay"
                      placeholder="请选择"
                      @change="endMonthFunFirst"
                    >
                      <el-option
                        v-for="item in endMonthArr1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="deadline" v-if="selectFrequency == 2">
                    <el-select
                      v-model="weekDay"
                      placeholder="请选择"
                      @change="endWeekFunFirst"
                    >
                      <el-option
                        v-for="item in endWeekArr1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="deadline">
                    <el-select
                      v-model="monthHour"
                      placeholder="请选择"
                      @change="endMonthFunSecond"
                    >
                      <el-option
                        v-for="item in endMonthArr2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="deadline">
                    <el-select
                      v-model="monthMinute"
                      placeholder="请选择"
                      @change="endMonthFunThird"
                    >
                      <el-option
                        v-for="item in endMonthArr3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div
                class="settingBox b-marT-10"
                v-if="
                  selectFrequency == 3 ||
                  selectFrequency == 4 ||
                  selectFrequency == 5 ||
                  selectFrequency == 6 ||
                  selectFrequency == 7
                "
              >
                <div class="flex-depart-center">
                  <span class="sTitle">多时段打卡</span>
                  <div>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="formClock.multiPeriodSwitch"
                      @input="clockMultiPeriodSwitchFn"
                    >
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="mar-top10">打卡时间段:</div>
                <div
                  class="flex-depart-left b-marT-10 rangeTimes"
                  v-for="(item, index) in formClock.clockInTimeSlot"
                  :key="index"
                  v-show="item.ifDel == 2"
                >
                  <el-time-picker
                    is-range
                    v-model="item.startAndEnd"
                    format="HH:mm"
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    @change="(e) => clockInTimeSlot(e, index)"
                  ></el-time-picker>
                  <i class="el-icon-delete-solid" @click="timesDel(index)"></i>
                </div>
                <div
                  class="b-marT-10 add-rangeTimes"
                  @click="addTimes"
                  v-if="formClock.multiPeriodSwitch == 1"
                >
                  添加时间段
                </div>
              </div>
              <div class="settingBox b-marT-10">
                <div class="flex-depart-center">
                  <span class="sTitle">指定打卡地点</span>
                  <div>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="formClock.clockLocationStatus"
                      @input="clockLocationFn"
                    >
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="settingBox b-marT-10">
                <div
                  class="flex-depart-center"
                  v-if="formClock.clockLocationStatus == 1"
                >
                  <span class="new-block-style2">参与地点</span>
                  <div>
                    {{ formClock.address }}
                    <el-button @click="openAddress()" class="map-btn"
                      >选择位置</el-button
                    >
                  </div>
                </div>
              </div>

              <div class="settingBox b-marT-10">
                <div
                  class="flex-depart-center mar-top10"
                  v-if="formClock.clockLocationStatus == 1"
                >
                  <span class="new-block-style2">打卡范围</span>
                  <div>
                    <el-select
                      v-model="formClock.clockRange"
                      placeholder="请选择"
                      @change="clockRangeChange"
                    >
                      <el-option
                        v-for="item in dakaColumnsArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="settingBox b-marT-10">
                <div class="flex-depart-center">
                  <span class="sTitle">允许补卡</span>
                  <div>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="formClock.clockSupplyStatus"
                      @input="supplyFn"
                    >
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div
                  class="flex-depart-center mar-top10"
                  v-if="formClock.clockSupplyStatus == 1"
                >
                  <span>补卡次数</span>
                  <div>
                    <el-select
                      v-model="formClock.clockSupplyType"
                      placeholder="请选择"
                      @change="selectOptionClick"
                    >
                      <el-option
                        v-for="item in clockRangeList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <span
                      v-if="
                        clockSupplyShow == true &&
                        formClock.clockSupplyType != -1
                      "
                      style="margin-left: 10px"
                      >{{ clockSupplyText }} 次</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- -----------------打卡部分结束------------------------- -->
          </div>

          <div
            class="settingBox b-marT-10 flex-depart-center seniorStyle"
            @click="seniorShow = !seniorShow"
          >
            <span class="sTitle"><b></b>高级设置</span>
          </div>
          <div class="set-out-box">
            <div class="settingBox b-marT-10">
              <div class="flex-depart-center">
                <span class="sTitle">
                  显示发布人信息
                  <img
                    class="yanshiBtn"
                    @click="demonstrate(4)"
                    src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                    alt=""
                  />
                </span>
                <div>
                  <template>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="isanonymous"
                      @input="anonymousFun"
                    >
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                  </template>
                </div>
              </div>
              <div class="mar-top10" v-if="isanonymous == 1">
                发布人：
                <el-input
                  style="width: 94%"
                  v-model="publisher"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>

            <div class="settingBox b-marT-10">
              <div class="flex-depart-center">
                <span class="sTitle">
                  显示联系信息
                  <img
                    class="yanshiBtn"
                    @click="demonstrate(4)"
                    src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                    alt=""
                  />
                </span>
                <div>
                  <template>
                    <el-radio-group
                      v-removeAriaHidden
                      v-model="phoneSwitch"
                      @input="phoneSwitchChange"
                    >
                      <el-radio :label="2">开启</el-radio>
                      <el-radio :label="1">关闭</el-radio>
                    </el-radio-group>
                  </template>
                </div>
              </div>
              <div class="mar-top10" v-if="phoneSwitch == 2">
                联系方式：
                <el-select v-model="contactType" placeholder="请选择">
                  <el-option
                    v-for="item in contactTypeArr"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="mar-top10" v-if="phoneSwitch == 2">
                联系号码：
                <el-input
                  style="width: 94%"
                  v-model="userPhone"
                  placeholder="请输入内容"
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle"
                >接龙情况通知
                </span>
                <div class="flex-depart-center-end">
                <el-select
                  v-model="activityDetail.enablePush"
                  placeholder="请选择"
                  @change="handleEnablePushChange"
                >
                  <el-option
                    v-for="item in enablePushArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle"
                >匿名参与
                <img
                  class="yanshiBtn"
                  @click="demonstrate(3)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="anonymousparticipation"
                  @input="anonymouspartFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              class="settingBox b-marT-10"
              v-if="isType != '109' && isType != '110'"
            >
              <div class="flex-depart-center">
                <span class="sTitle"
                  >指定参与地点<img
                    class="yanshiBtn"
                    @click="demonstrate(10)"
                    src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                    alt=""
                /></span>
                <div>
                  <el-radio-group
                    v-removeAriaHidden
                    v-model="is_destination"
                    @input="isDestinationFun"
                  >
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div
              class="settingBox flex-depart-center b-marT-10"
              v-if="is_destination == 1"
            >
              <span class="new-block-style2">参与地点</span>
              <div>
                {{ specifyaddress }}
                <el-button @click="openJoininAddress()" class="map-btn"
                  >选择位置</el-button
                >
              </div>
            </div>

            <div
              class="settingBox flex-depart-center b-marT-10"
              v-if="is_destination == 1"
            >
              <span class="new-block-style2">参与范围</span>
              <div style="width: 440px">
                <el-select
                  v-model="checkinrange"
                  placeholder="请选择"
                  @change="checkinRangeChange"
                >
                  <el-option
                    v-for="item in addresscolumnsArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="isType == 106 || clockInfoObj.clockFrequencyType == 8"
            >
              <span class="sTitle"
                >每人可{{
                  appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
                }}次数</span
              >
              <div class="flex-depart-center-end">
                <el-select
                  v-model="activityDetail.generalCheckTimes"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in generalCheckTimesArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle"
                >禁止他人复制该{{
                  appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
                }}</span
              >
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="copyStatus"
                  @input="copyStatusFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle"
                >禁止他人转发该{{
                  appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
                }}</span
              >
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="is_forward"
                  @input="forwardFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">参与按钮文字</span>
              <div class="flex-depart-center-end">
                <el-input
                  style="width: 200px"
                  v-model="confirmWord"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">提交信息按钮文字</span>
              <div class="flex-depart-center-end">
                <el-input
                  v-model="submitcopy"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>

            <!--                        <div class="settingBox b-marT-10 flex-depart-center">-->
            <!--                            <span class="sTitle">开启留言</span>-->
            <!--                            <div>-->
            <!--                                <el-radio-group v-removeAriaHidden v-model="commentStatus" @input="commentFun">-->
            <!--                                    <el-radio :label="1">开启</el-radio>-->
            <!--                                    <el-radio :label="2">关闭</el-radio>-->
            <!--                                </el-radio-group>-->
            <!--                            </div>-->
            <!--                        </div>-->

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityMode == 2"
            >
              <span class="sTitle">自定义分享图</span>
              <div>
                <el-select
                  v-model="shareImageStyle"
                  placeholder="请选择"
                  @change="shareImgConfirm"
                >
                  <el-option
                    v-for="item in shareImgColumns"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityMode == 2"
            >
              <span class="sTitle" v-if="shareImageStyle == 1"
                >设置系统分享图</span
              >
              <span class="sTitle" v-if="shareImageStyle == 2"
                >设置自定义分享图</span
              >
              <div>
                <div
                  class="edit-share"
                  v-if="shareImageStyle == 1"
                  @click="changeXTShareImg"
                >
                  <img class="sm-1" :src="shareImageUrl" mode="aspectFill" />
                  <span>更换</span>
                </div>
                <div class="edit-share" v-if="shareImageStyle == 2">
                  <img class="sm-1" :src="shareZdyImageUrl" />
                  <span
                    ><input
                      class="updateFileBtn"
                      type="file"
                      id="imageShareInput2"
                      accept="image/*"
                      @change="(event) => handleShareImgUpload(event)"
                    />上传</span
                  >
                </div>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle"
                >{{
                  appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
                }}后自定义展示页面</span
              >
              <div class="setText" @click="openCus">设置</div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">内容字体大小</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.fontSize"
                >
                  <el-radio :label="1">默认</el-radio>
                  <el-radio :label="2">较小</el-radio>
                  <el-radio :label="3">较大</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">内容展开收起设置<img
                  class="yanshiBtn"
                  @click="demonstrate(13)"
                   src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.expandSet"
                >
                  <el-radio :label="1">自动展开</el-radio>
                  <el-radio :label="2">自动收起</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              class="settingBox b-marT-10 flex-depart-center mar-top10"
              v-if="activityMode == 1"
            >
              <span class="sTitle"
                >加密浏览分享数据<img
                  class="yanshiBtn"
                  @click="demonstrate(12)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.encryptBrowsing"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle"
                >群聊<img
                  class="yanshiBtn"
                  @click="demonstrate(5)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="chatSwitch"
                  @input="changeChatSwitch"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">点赞</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="thumbs_up"
                  @input="thumbsUpFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">点评</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="is_comment"
                  @input="isCommentFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">评分</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="is_score"
                  @input="isScoreFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">评论</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="isMessage"
                  @input="isMessageFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="isType == '109' || isType == '104'"
            >
              <span class="sTitle">排行榜</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="showRanking"
                  @input="rankingFun"
                >
                  <el-radio :label="2">开启</el-radio>
                  <el-radio :label="1">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center mar-top10"
              v-if="isType == '106'"
            >
              <span class="sTitle"
                >开启核销<img
                  class="yanshiBtn"
                  @click="demonstrate(6)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.verificationSwitch"
                >
                  <el-radio :label="2">开启</el-radio>
                  <el-radio :label="1">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.verificationSwitch == 2"
            >
              <span class="sTitle new-block-style2">核销起止时间</span>
              <div class="flex-depart-center mar-bot-check-0">
                <el-checkbox
                  v-model="foreverTimeHxChecked"
                  @change="foreverHxValidChange"
                  >永久有效
                </el-checkbox>
                <div
                  class="flex-depart-center"
                  v-show="foreverTimeHxChecked == true"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="verificationStartTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </div>
                <div
                  v-show="foreverTimeHxChecked == false"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="hxStartAndEndTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="hxStartAndEndTimeFun"
                  ></el-date-picker>
                </div>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center mar-top10">
              <span class="sTitle"
                >开启签到码<img
                  class="yanshiBtn"
                  @click="demonstrate(7)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.signInSwitch"
                >
                  <el-radio :label="2">开启</el-radio>
                  <el-radio :label="1">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2"
            >
              <span class="sTitle new-block-style2">签到起止时间</span>
              <div class="flex-depart-center mar-bot-check-0">
                <el-checkbox
                  v-model="foreverTimeQdChecked"
                  @change="foreverQdValidChange"
                  >永久有效
                </el-checkbox>
                <div
                  class="flex-depart-center"
                  v-show="foreverTimeQdChecked == true"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="signInStartTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </div>
                <div
                  v-show="foreverTimeQdChecked == false"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="signStartAndEndTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="qdStartAndEndTimeFun"
                  ></el-date-picker>
                </div>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2"
            >
              <span class="sTitle">显示签到状态</span>
              <div>
                <el-select
                  v-model="checkInStatusSwitch"
                  placeholder="请选择"
                  @change="checkInConfirm"
                >
                  <el-option
                    v-for="item in checkInStatusArr"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="activityDetail.signInSwitch == 2">
              <div >
                <span class="sTitle">签到数据大屏<img
                  class="yanshiBtn"
                  @click="demonstrate(14)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
                <p style="margin-bottom: 0; color: #505d69">
                  实时显示签到数据的数据大屏
                </p>
              </div>

              <div class="flex-depart-center-end setText" @click="getDataScreenUrl()" :style="{color: selectType=='add'?'#F44336 !important':'#1877FF'}">
                {{ selectType =='add'?'请先创建':'获取'}}
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2"
            >
              <span class="sTitle"
                >是否允许撤销签到<img
                  class="yanshiBtn"
                  @click="demonstrate(8)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.revokeSign"
                >
                  <el-radio :label="2">开启</el-radio>
                  <el-radio :label="1">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2"
            >
              <span class="sTitle">指定签到地点</span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="activityDetail.signLocationSwitch"
                >
                  <el-radio :label="2">开启</el-radio>
                  <el-radio :label="1">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div
              class="settingBox flex-depart-center b-marT-10"
              v-if="activityDetail.signLocationSwitch == 2"
            >
              <span class="sTitle new-block-style1">参与地点</span>
              <div>
                {{ activityDetail.signInAddress }}
                <el-button @click="openSignAddress()" class="map-btn"
                  >选择位置</el-button
                >
              </div>
            </div>

            <div
              class="settingBox flex-depart-center b-marT-10"
              v-if="activityDetail.signLocationSwitch == 2"
            >
              <span class="sTitle new-block-style1">参与范围</span>
              <div>
                <el-select
                  v-model="activityDetail.signLocationDistance"
                  placeholder="请选择"
                  @change="signRangeChange"
                >
                  <el-option
                    v-for="item in addresscolumnsArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center mar-top10">
              <span class="sTitle"
                >展示报名信息<img
                  class="yanshiBtn"
                  @click="demonstrate(9)"
                  src="https://ossfastmake.mustke.com/12jielong/bdJL/yanshi4.0.svg"
                  alt=""
              /></span>
              <div>
                <el-radio-group
                  v-removeAriaHidden
                  v-model="signInfoStatus"
                  @input="signInfoIsOpenFun"
                >
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="2">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle new-block-style2">允许修改报名信息</span>
              <div>
                <el-select
                  v-model="updateSignInfo"
                  placeholder="请选择"
                  @change="signChange"
                >
                  <el-option
                    v-for="item in updateSignArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="settingBox flex-depart-center"
              style="padding-top: 0"
              v-show="updateSignInfo == 2"
            >
              <span class="sTitle new-block-style2">时间范围</span>
              <div>
                <el-date-picker
                  v-model="deadline"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="deadlineTimeFun"
                ></el-date-picker>
              </div>
            </div>

            <div
              class="settingBox b-marT-10 flex-depart-center"
            >
              <span class="sTitle new-block-style2">报名后是否允许取消</span>
              <div>
                <el-select
                  v-model="removeSignStatus"
                  placeholder="请选择"
                  @change="removeSignChange"
                >
                  <el-option
                    v-for="item in cancellationArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="settingBox flex-depart-center"
              style="padding-top: 0"
              v-if="removeSignStatus == 3"
            >
              <span class="sTitle new-block-style2">时间范围</span>
              <div>
                <el-date-picker
                  v-model="deadCancelline"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="deadCancelTimeFun"
                ></el-date-picker>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <div class="new-block-style2">
                <span class="sTitle">限制参与人数</span>
                <p style="margin-bottom: 0; color: #505d69">
                  0人即为不限制参与人数
                </p>
              </div>

              <div class="flex-depart-center-end danwei">
                <!--                                <el-input style="width: 200px" v-model="interdict_people_num"-->
                <!--                                          @input="interdict_people_num=interdict_people_num.replace(/^\.+|[^\d]+/g,'')"-->
                <!--                                          @focus="FocusInterdictPeople()" @blur="BlurInterdictPeople" placeholder="请输入内容"></el-input>&nbsp;人-->
                <input
                  type="text"
                  v-model="interdict_people_num"
                  @input="
                    interdict_people_num = interdict_people_num.replace(
                      /^\.+|[^\d]+/g,
                      ''
                    )
                  "
                  @focus="FocusInterdictPeople()"
                  @blur="BlurInterdictPeople"
                  placeholder="请输入参与人数"
                />&nbsp;人
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- todo 去创建 -->
    <div class="posi-bottom-btn-box flex-depart-center-center">
      <div
        class="yl flex-depart-center-center"
        v-if="selectType == 'add' || is_draft == 1"
        @click="saveToDraft"
      >
        存草稿
      </div>
      <div class="saveDatabox flex-depart-center-center" @click="submit">
        立即发布
      </div>
    </div>
    <div style="height: 90px"></div>

    <!--查看大图-->
    <div
      class="previewImgBox"
      @click="hidePreview"
      v-if="previewImgShow == true"
    >
      <i class="closePImg el-icon-circle-close"></i>
      <img class="inner-p-img" :src="imageUrl + previewImgSrc" alt="" />
    </div>

    <systemPictures
      ref="systemPictures"
      @shareSelect="shareSelect"
      @sureSelect="sureSelect"
    ></systemPictures>

    <!--抽屉-表单项弹框 -->
    <el-drawer
      :visible.sync="formDrawerShow"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="formDrawerClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>添加填写项</span>
          <!-- <i class="el-icon-close" @click="formDrawerClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="formDrawerClose"
          />
        </div>
        <div class="underline"></div>
        <div class="af-title">通用填写项</div>
        <div class="ty-block flex-depart-center b-marT-10">
          <div class="ty-b-item" @click="addForm(-1)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>单行文本</div>
            <p>填写文字、数字的单行文本</p>
          </div>
          <div class="ty-b-item" @click="addForm(-4)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>多行文本</div>
            <p>填写多行文本或数字信息</p>
          </div>
        </div>
        <div class="ty-block flex-depart-center b-marT-10">
          <div class="ty-b-item" @click="addForm(-2)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>单选</div>
            <p>可以设置分组、分类、标签</p>
          </div>
          <div class="ty-b-item" @click="addForm(-3)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>多选</div>
            <p>设置多项选择的填表项</p>
          </div>
        </div>
        <div class="af-title b-marT-10">常用填写项</div>
        <div class="b-marT-10 cy-box">
          <div
            class="cy-item"
            v-for="(item, index) in formList"
            :key="item.type"
            @click="addForm(item.type, index)"
          >
            <span>{{ item.label }}</span
            ><i class="el-icon-circle-plus addFBtn2"></i>
          </div>
        </div>
      </div>
    </el-drawer>
    <!--抽屉-名单 -->
    <el-drawer
      :visible.sync="openNameListDrawer"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="nameListClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>添加接龙名单</span>
          <!-- <i class="el-icon-close" @click="nameListClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="nameListClose"
          />
        </div>
        <div class="underline"></div>
        <div class="nl-title">姓名名单</div>
        <div class="b-marT-10">
          <el-input
            type="textarea"
            rows="15"
            v-model="nameShowContent"
            @input="handlerBlurOnlyName($event)"
            placeholder="请输入姓名名单"
            class="textareName"
          ></el-input>
        </div>
        <div style="color: #a5a4a4; line-height: 40px">
          提示：每个名单用逗号或者换行隔开
        </div>
        <div
          class="clockNameNumberSwitchDiv"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="display: flex; align-items: center">
            <el-switch
              v-model="clockNameNumberSwitch"
              @change="clockNameNumberSwitchChange($event)"
              active-color="#1877FF"
              inactive-color="rgb(230, 230, 230)"
              active-value="1"
              inactive-value="2"
            ></el-switch>
            <div style="margin-left: 6px">添加编号/学号</div>
          </div>
          <div>合计:{{ people_num }}人</div>
        </div>
        <div class="flex-depart-center b-marT-10">
          <div class="daoru" @click="importVisible = true">从Excel导入</div>
          <div class="qingkong" @click="clearName">
            <i class="el-icon-delete"></i>清空内容
          </div>
        </div>
        <div class="flex-depart-center b-marT-20 addnameBtns">
          <el-button round @click="openNamelistFun">预存名单</el-button>
          <el-button round type="primary" @click="sureAddNameList"
            >确定</el-button
          >
        </div>

        <div
          class="jl-box"
          :style="{ paddingBottom: '0' }"
          style="
            margin-bottom: 0 !important;
            margin-top: 0;
            background-color: transparent !important;
          "
          v-if="onlyNameArr.length > 0"
        >
          <div class="jlName" style="padding: 0 !important">
            <div class="listName newSpanWidth">
              <div
                class="spanDiv"
                v-for="(item, index) in onlyNameArr"
                :key="index"
                :style="{
                  lineHeight:
                    activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                }"
              >
                <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                  index + 1
                }}</span>
                {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
              </div>
              <div class="spanDivEmpty"></div>
              <div class="spanDivEmpty"></div>
              <div class="spanDivEmpty"></div>
              <div class="spanDivEmpty"></div>
              <div class="spanDivEmpty"></div>
              <div class="spanDivEmpty"></div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 弹出层-名单导入 -->
    <el-dialog
      :visible.sync="importVisible"
      width="30%"
      :show-close="false"
      :before-close="importClose"
    >
      <template slot="title">
        <CustomDialogHeader
          title="Excel表格导入"
          @close="importVisible = false"
        />
      </template>
      <div>
        <el-button @click="downExam">下载excel模板</el-button>
        <el-button type="primary" class="updateFileBtn-out"
          ><input
            class="updateFileBtn"
            type="file"
            id="imageInput7"
            accept=".xls,.xlsx"
            @change.stop="importExcel"
          />导入
        </el-button>
        <div class="b-marT-10" style="color: #f56c6c">
          注：Excel表格内的内容默认只读取第一列非第一行的内容
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="gzhDialogVisible"
      width="360px"
      :show-close="false"
      custom-class="gzh-follow-dialog"
    >
      <div slot="title" class="gzh-dialog-header">
        <span>接龙情况通知</span>
        <i class="el-icon-close" @click="closeGzhDialog"></i>
      </div>
      <div class="gzh-dialog-content">
        <img class="gzh-dialog-qrcode" :src="gzhQrcodeSrc" alt="公众号二维码" />
        <p>扫码关注公众号接受消息通知</p>
        <el-button
          type="primary"
          class="gzh-download-btn"
          round
          @click="downloadGzhQrcode"
        >
          下载二维码
        </el-button>
      </div>
    </el-dialog>

    <!--抽屉-预存名单列表 -->
    <el-drawer
      :visible.sync="nameListDrawer"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="nameListDrawerFun"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>预存名单列表</span>
          <!-- <i class="el-icon-close" @click="nameListDrawerFun"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="nameListDrawerFun"
          />
        </div>
        <div class="underline"></div>
        <div
          class="flex-depart-center b-marT-10 ycn"
          v-for="(item, index) in presetsList"
          :key="index"
          @click="EchoList(item)"
        >
          <div class="n-name">{{ item.clockPresetTitle }}</div>
          <div class="n-handle">
            <span @click.stop="nameLists(item.id)">编辑</span>
            <span @click.stop="presetsDel(item.id)">删除</span>
          </div>
        </div>
        <el-button type="primary" class="b-marT-10" round @click="toAddRoster"
          >添加姓名名单</el-button
        >
      </div>
    </el-drawer>
    <!--抽屉-添加预存名单 -->
    <el-drawer
      :visible.sync="addNameListDrawer"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="addNameDrawer"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>添加预存名单</span>
          <!-- <i class="el-icon-close" @click="addNameDrawer"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="addNameDrawer"
          />
        </div>
        <div class="nl-title">名单标题</div>
        <div class="b-marT-10">
          <el-input
            v-model="clockShowPresetTitle"
            @input="handlerBlur()"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="nl-title b-marT-10">
          预存名单 <span>合计:{{ people_num2 }}人</span>
        </div>
        <div class="b-marT-10">
          <el-input
            type="textarea"
            rows="15"
            v-model="clockShowPresetContent"
            placeholder="请输入姓名名单"
            class="textareName"
          ></el-input>
        </div>
        <div style="color: #a5a4a4; line-height: 50px">
          提示：每个名单用逗号或者换行隔开
        </div>
        <div class="flex-depart-center b-marT-10">
          <div class="daoru updateFileBtn-out">
            从Excel导入
            <input
              class="updateFileBtn"
              type="file"
              id="imageInput8"
              accept=".xls,.xlsx"
              @change.stop="importFiles"
            />
          </div>
          <div class="qingkong" @click="emptyName">
            <i class="el-icon-delete"></i>清空内容
          </div>
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="closeAddNameDrawer">取消</el-button>
          <el-button type="primary" @click="clockPresetsAdd">确定</el-button>
        </div>
      </div>
    </el-drawer>
    <!--抽屉-接龙后自定义展示页面 -->
    <el-drawer
      :visible.sync="customizeDrawer"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="customizeClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>接龙后自定义展示页面</span>
          <!-- <i class="el-icon-close" @click="customizeClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="customizeClose"
          />
        </div>
        <div class="underline"></div>
        <div class="duiHao">
          <img
            src="https://ossfastmake.mustke.com//12jielong/lsyJL/successdh.png"
            alt=""
          />
        </div>
        <div class="b-marT-10 cw">
          <el-input
            v-model="copyShowWriting"
            placeholder="请输入自定义文字"
          ></el-input>
        </div>
        <div class="b-marT-20 flex-depart-center-center" v-if="!copyShowImage">
          <div class="upl-smallImg upl-smallImg2">
            <input
              class="updateFileBtn"
              type="file"
              accept="image/*"
              id="imageInput9"
              @change="uploadCopyImage"
            />
            <i class="el-icon-circle-plus"></i>
            <span>点击上传图片</span>
          </div>
        </div>
        <div
          class="b-marT-20 flex-depart-center-center copy-image-out"
          v-if="copyShowImage"
        >
          <img
            src="https://ossfastmake.mustke.com//static/0307/del.svg"
            @click.stop="delCopyImage"
            alt=""
            class="del-copy-img"
          />
          <img class="copy-image" :src="imageUrl + copyShowImage" alt="" />
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="customizeDrawer = false">取消</el-button>
          <el-button type="primary" @click="sureCoverImgFun">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--关联接龙-->
    <el-drawer
      :visible.sync="relatedDrawerShow"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="relatedDrawerClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>关联接龙</span>
          <!-- <i class="el-icon-close" @click="relatedDrawerClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="relatedDrawerClose"
          />
        </div>
        <div class="underline"></div>
        <div class="call-out" id="scrollable-div">
          <div
            class="b-marT-10 bg-gray pad-10"
            v-for="(item, index) in relatedList"
            :key="item.value"
          >
            <div class="flex-depart-center-top">
              <el-checkbox
                v-model="item.checked"
                @change="($event) => relateItemChange($event, item, index)"
              ></el-checkbox>
              <div class="cell-box">
                <p class="cell-name">{{ item.name }}</p>
                <div class="cell-addTime">{{ item.add_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="relatedDrawerShow = false">取消</el-button>
          <el-button type="primary" @click="relatedAdd">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--属性设置-->
    <el-drawer
      :visible.sync="propertySetShow"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="propertyDrawerClose"
    >
      <div class="drawerOutBox drawerOutBox-nopadding gray-bg">
        <div class="drawer-nav-top" style="padding: 0 20px">
          <div></div>
          <span>属性设置</span>
          <!-- <i class="el-icon-close" @click="propertyDrawerClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="propertyDrawerClose"
          />
        </div>
        <div class="propertySet-box">
          <!--标题-->
          <div class="title-block flex-depart-top2">
            <div class="tb-left font-weight600">
              <label class="x">*</label>标题
            </div>
            <div style="width: 85%">
              <el-input
                v-model="propertyData.fieldName"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>

          <!--文本格式-->
          <div class="wb-setting-block">
            <div
              class="zz"
              v-if="
                commType == -1 ||
                commType == 9 ||
                commType == 1 ||
                commType == 11 ||
                commType == 19 ||
                commType == 23 ||
                commType == 24 ||
                commType == 21 ||
                commType == 22 ||
                commType == 25 ||
                commType == 26 ||
                commType == 27 ||
                commType == 28
              "
            >
              <span class="font-weight600">文本格式：</span>
              <el-select
                v-model="propertyData.isFormatCheck"
                placeholder="请选择"
                @change="formatCheckChange"
              >
                <el-option
                  v-for="(vItem, vIndex) in validateArr"
                  :key="vIndex"
                  :label="vItem"
                  :value="vIndex"
                ></el-option>
              </el-select>
            </div>
            <div
              class="no-repeat"
              v-if="
                commType == -1 ||
                commType == 9 ||
                commType == 1 ||
                commType == 11 ||
                commType == 19 ||
                commType == 23 ||
                commType == 24
              "
            >
              <div>
                <div class="no-title">记录唯一性 不可以重复</div>
                <div class="no-tips">例如学号 工号只能一个接龙者使用。</div>
              </div>
              <el-switch
                v-model="propertyData.isUniqueCheck"
                active-value="1"
                inactive-value="0"
                active-color="#1877FF"
                inactive-color="rgb(230, 230, 230)"
              ></el-switch>
            </div>
          </div>

          <!--文件数量-->
          <div class="files-num" v-if="commType == 5">
            <span class="font-weight600">最多可上传文件数量：</span>
            <div class="set-box">
              <el-select
                v-model="propertyData.imageUploadLimit"
                placeholder="请选择"
                @change="imgNumCheckChange"
              >
                <el-option
                  v-for="(imgItem, imgIndex) in imageUploadNumArr"
                  :key="imgIndex"
                  :label="imgItem"
                  :value="imgIndex"
                ></el-option>
              </el-select>
            </div>
          </div>
          <!--单选展示样式-->
          <div class="files-num" v-if="commType == 2 || commType == 4">
            <span class="font-weight600">展示样式：</span>
            <div class="set-box">
              <el-select
                v-model="propertyData.displayStyle"
                placeholder="请选择"
                @change="imgNumCheckChange"
              >
                <el-option
                  v-for="dItem in displayStyleArr"
                  :key="dItem.value"
                  :label="dItem.label"
                  :value="dItem.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <!--单选多选-->
          <div class="radio-block" v-if="commType == 2 || commType == 4 ">
            <div
              class="rb-item"
              v-for="(contentItem, contentIndex) in propertyData.content"
              :key="contentIndex"
            >
              <div class="rb-left">
                <div>{{ contentIndex + 1 }}</div>
                <div style="width: 265px; margin-left: 10px">
                  <div class="opt-row">
                    <el-input
                      class="opt-name"
                      v-model="contentItem.value"
                      placeholder="请输入选项名称"
                    ></el-input>
                    <el-input
                      class="opt-num"
                      maxlength="10"
                      :value="
                        contentItem.maxNum === -1 ? '' : contentItem.maxNum
                      "
                      placeholder="数量不限111111"
                      @input="handleNumValueChange($event, contentItem)"
                      @focus="handleNumValueFocus(contentItem)"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="rb-right">
                <img
                  :src="commonImgSrc + 'bdJL/move-shang.svg'"
                  @click="upTr(contentIndex)"
                />
                <img
                  :src="commonImgSrc + 'bdJL/move-xia.svg'"
                  @click="downTr(contentIndex)"
                />
                <img
                  :src="commonImgSrc + 'bdJL/move-del.svg'"
                  @click="trash(contentIndex)"
                />
              </div>
            </div>
          </div>
          <div class="radio-add" v-if="commType == 2 || commType == 4">
            <span @click="addOption">添加选项</span>
            <span @click="batchOptions">批量添加选项</span>
            <span @click="batchSetNum(propertyData, commIndex)"
              >批量设置数量</span
            >
          </div>
          <div class="files-num" v-if="commType == 4">
            <span class="font-weight600">最多可选：</span>
            <div class="set-box">
              <el-select v-model="propertyData.maxValue" placeholder="请选择">
                <el-option
                  v-for="(mItem, mIndex) in maxValueArr"
                  :key="mIndex"
                  :label="mItem.label"
                  :value="mItem.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="files-num" v-if="commType == 4">
            <span class="font-weight600">最少可选：</span>
            <el-select v-model="propertyData.minValue" placeholder="请选择">
              <el-option
                v-for="(mItem, mIndex) in minValueArr"
                :key="mIndex"
                :label="mItem.label"
                :value="mItem.value"
              ></el-option>
            </el-select>
          </div>
          <!--地址格式-->
          <div class="area-block" v-if="commType == 8">
            <div class="tt-title">选择格式：</div>
            <div
              class="tt-list"
              v-for="(item, index) in areaSetList"
              :key="item.type"
              @click="attributeAreaChange(item.type, index)"
            >
              <span>{{ item.value }}</span>
              <img
                v-if="index != Number(propertyData.areaSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg"
              />
              <img
                v-if="index == Number(propertyData.areaSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg"
              />
            </div>
          </div>
          <!--日期-->
          <div class="area-block" v-if="commType == 3">
            <div class="tt-title">选择格式：</div>
            <div
              class="tt-list"
              v-for="(item, index) in timeSetList"
              :key="item.type"
              @click="attributeTimeChange(item.type, index)"
            >
              <span>{{ item.value }}</span>
              <img
                v-if="index != Number(propertyData.timeSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg"
              />
              <img
                v-if="index == Number(propertyData.timeSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg"
              />
            </div>
          </div>
          <!--时间区间-->
          <div class="area-block" v-if="commType == 31">
            <div class="tt-title">选择格式：</div>
            <div
              class="tt-list"
              v-for="(item, index) in dateSetList"
              :key="item.type"
              @click="attributeDateChange(item.type, index)"
            >
              <span>{{ item.value }}</span>
              <img
                v-if="index != Number(propertyData.dateSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg"
              />
              <img
                v-if="index == Number(propertyData.dateSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg"
              />
            </div>
          </div>
          <!--必填/公开-->
          <div class="bx-block">
            <div class="bx-item">
              <!--                            <el-checkbox v-model="propertyData.isRequiredChecked" @change="checkFun">必填</el-checkbox>-->
              <el-checkbox
                v-model="propertyData.isRequired"
                :true-label="1"
                :false-label="0"
                @change="checkFun"
                >必填
              </el-checkbox>
            </div>
            <div class="bx-item">
              <!--                            <el-checkbox v-model="propertyData.isOpenChecked">公开</el-checkbox>-->
              <el-checkbox
                v-model="propertyData.isOpen"
                :true-label="1"
                :false-label="0"
                @change="openFn"
                >公开
              </el-checkbox>
            </div>
          </div>

          <!--提示-->
          <div class="tips-block">
            <div class="tip-title">
              <span class="font-weight600">提示</span>
              <el-switch
                v-model="propertyData.promptSwitch"
                active-color="#1877FF"
                inactive-color="rgb(230, 230, 230)"
                active-value="1"
                inactive-value="2"
              ></el-switch>
            </div>
            <div v-show="propertyData.promptSwitch == 1" class="padding-0-20">
              <el-divider></el-divider>
              <div class="tip-t-area">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入提示内容或说明（选填）"
                  maxlength="50"
                  v-model="propertyData.promptExplanation"
                ></el-input>
              </div>
              <template v-if="propertyData.promptImage">
                <div class="up-box1">
                  <input
                    class="updateFileBtn"
                    type="file"
                    id="imageInput11"
                    accept="image/*"
                    @change="uploadPromptImage"
                  />
                  <img
                    class="up-img-fun1"
                    :src="imageUrl + propertyData.promptImage"
                    alt=""
                  />
                </div>
              </template>
              <template v-if="!propertyData.promptImage">
                <div class="up-box1">
                  <input
                    class="updateFileBtn"
                    type="file"
                    id="imageInput10"
                    accept="image/*"
                    @change="uploadPromptImage"
                  />
                  <img
                    class="up-img-fun1"
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/up-img-fun.svg"
                    alt=""
                  />
                </div>
              </template>
            </div>
          </div>
          <!-- 地点选择 -->
          <PosPermissionSelector
            v-model="propertyData.posPermissions"
            v-if="commType == 12"
          >
          </PosPermissionSelector>
          <!-- 水印选择 -->
          <WaterMarkSwitch
            v-if="commType == 5"
            v-model="propertyData.watermarkSwitch"
            :watermarkTimeOrPosition="propertyData.watermarkTimeOrPosition"
            @update:watermarkTimeOrPosition="
              (val) => (propertyData.watermarkTimeOrPosition = val)
            "
          >
          </WaterMarkSwitch>
          <div class="tips-block" v-if="commType == 5">
            <div class="tip-title">
              <span class="font-weight600">是否允许用户自助批注</span>
              <el-switch
                v-model="propertyData.annotationPermission"
                active-color="#1877FF"
                inactive-color="rgb(230, 230, 230)"
                active-value="1"
                inactive-value="2"
              ></el-switch>
            </div>

          </div>
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="propertySetShow = false">取消</el-button>
          <el-button type="primary" @click="propertySet">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 地图 -->
    <el-dialog
      width="600px"
      :visible.sync="addressDialog"
      :destroy-on-close="true"
      top
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader title="请选择地址" @close="addressDialog = false" />
      </template>
      <iframe
        id="mapPage2"
        width="100%"
        height="100%"
        style="width: 550px; height: 500px"
        frameborder="0"
        src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=NBJBZ-IMQLX-TPL4O-7KADZ-F6HMT-V3BPM&referer=myapp"
      ></iframe>
      <span slot="footer">
        <el-button @click="addressDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitMap">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="600px"
      :visible.sync="musicDialog"
      :destroy-on-close="true"
      center
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader title="音乐" @close="musicDialog = false" />
      </template>
      <audio controls :src="musicLink" type="audio/mp3"></audio>
    </el-dialog>

    <!--        批量添加选项-->

    <el-dialog :visible.sync="batchOptionShow" width="30%" :show-close="false">
      <template slot="title">
        <CustomDialogHeader
          title="批量添加选项"
          @close="batchOptionShow = false"
        />
      </template>
      <el-input
        type="textarea"
        :rows="8"
        placeholder="添加选项，一行一个。"
        maxlength="500"
        v-model="lineCopywriting"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchOptionShow = false">取 消</el-button>
        <el-button type="primary" @click="addLineBreak">确 定</el-button>
      </span>
    </el-dialog>

    <!--名单类型-->
    <el-dialog
      :visible.sync="nameAddOptionsShow"
      width="30%"
      class="no-padding-top"
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader
          title="名单类型选择"
          @close="nameAddOptionsShow = false"
        />
      </template>
      <div>
        <el-radio-group v-model="nameOrGroup">
          <el-radio :label="0">不启用</el-radio>
          <el-radio :label="1">仅添加名单</el-radio>
          <el-radio :label="2">添加分组 + 名单</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nameAddOptionsShow = false">取 消</el-button>
        <el-button type="primary" @click="nameAddChange">确 定</el-button>
      </span>
    </el-dialog>

    <!--分组弹框-->
    <el-drawer
      :visible.sync="subsetShow"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="subsetDrawerClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>设置分组</span>
          <!-- <i class="el-icon-close" @click="subsetDrawerClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="subsetDrawerClose"
          />
        </div>
        <div class="underline"></div>
        <div>
          <div
            class="flex-depart-center subset-item"
            v-for="(item, index) in subsetCenterValueArr"
            :key="index"
          >
            <div class="flex-depart-left-center sub-left">
              <img :src="subtractFzImgSrc" @click="subtractFzItem(index)" />
              <div class="flex-depart-left-center">
                <div class="cl-name">
                  {{
                    item.listGroupName
                      ? item.listGroupName
                      : ` 分组${index + 1}`
                  }}
                </div>
              </div>
            </div>
            <!--                        <img class="sub-edit" :src="editImgSrc" @click="editFzItem(index,item)">-->
            <div @click="editFzItem(index, item)" v-if="item.clockInList == ''">
              <span class="szfz">设置名单</span>
              <i class="el-icon-arrow-right" style="color: #1877ff"></i>
            </div>
            <div @click="editFzItem(index, item)" v-else>
              <span class="clockNum">{{ item.clockInListNum }}个</span>,<span
                class="szfz"
                >查看/修改</span
              >
              <i class="el-icon-arrow-right" style="color: #1877ff"></i>
            </div>
          </div>
          <div class="flex-depart-center subset-item add-sub">
            <div class="flex-depart-left-center sub-left" @click="addFzItem">
              <img :src="addFzImgSrc" />
              <div>添加分组</div>
            </div>
          </div>
        </div>

        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="popupSaveFzFn(0)">取消</el-button>
          <el-button type="primary" @click="popupSaveFzFn(1)">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--编辑分组-->
    <el-drawer
      :visible.sync="handleSubShow"
      :direction="direction"
      size="450px"
      :withHeader="false"
      :before-close="handleSubDrawerClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>设置分组名单</span>
          <!-- <i class="el-icon-close" @click="handleSubDrawerClose"></i> -->
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="handleSubDrawerClose"
          />
        </div>
        <div class="underline"></div>

        <div class="setFz-main">
          <div class="ssfz flex-depart-center">
            <!-- <span>所属分组</span> -->
            <div style="width: 100%">
              <el-input
                v-model="fzTitle"
                placeholder="请输入分组名称"
              ></el-input>
            </div>
          </div>

          <div style="position: relative">
            <el-input
              type="textarea"
              :rows="15"
              placeholder="请输入姓名名单"
              maxlength="-1"
              @input="handlerBlurFz($event)"
              v-model="fzValue"
            ></el-input>
            <div style="color: #a5a4a4; line-height: 50px">
              提示：每个名单用逗号或者换行隔开
            </div>
            <div class="clockNameNumberSwitchDiv">
              <div class="flex-depart-center">
                <el-switch
                  v-model="clockNameNumberSwitch"
                  @change="clockNameNumberSwitchChange($event)"
                  active-color="#1877FF"
                  inactive-color="rgb(230, 230, 230)"
                  active-value="1"
                  inactive-value="2"
                ></el-switch>
                <div style="margin-left: 6px">添加编号/学号</div>
              </div>

              <div>
                合计：<span class="total-count">{{ people_num2 }}</span
                >人
              </div>
            </div>
          </div>

          <div class="import-box flex-depart-center">
            <div class="flex-depart-center">
              <div class="blueTxt" @click="importVisible = true">
                从Excel导入
              </div>
              <div class="empty flex-depart-center" @click="emptyFn">
                <i class="el-icon-delete"></i>
                清空内容
              </div>
            </div>
            <div
              class="flex-depart-center"
              @click="openNamelistFun"
              style="cursor: pointer; color: #1877ff"
            >
              <img
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/yucunmingdan.svg"
                style="margin-right: 5px"
              />
              预存名单
            </div>
          </div>
        </div>

        <div>
          <div
            class="jl-box"
            :style="{ paddingBottom: '0' }"
            style="
              margin-bottom: 0 !important;
              margin-top: 0;
              background-color: transparent !important;
            "
            v-if="onlyGroupArr.length > 0"
          >
            <div class="jlName" style="padding: 0 !important">
              <div class="listName newSpanWidth">
                <div
                  class="spanDiv"
                  v-for="(item, index) in onlyGroupArr"
                  :key="index"
                  :style="{
                    lineHeight:
                      activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                  }"
                >
                  <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                    index + 1
                  }}</span>
                  {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                </div>
                <div class="spanDivEmpty"></div>
                <div class="spanDivEmpty"></div>
                <div class="spanDivEmpty"></div>
                <div class="spanDivEmpty"></div>
                <div class="spanDivEmpty"></div>
                <div class="spanDivEmpty"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="addOrEditFz(0)">取消</el-button>
          <el-button type="primary" @click="addOrEditFz(1)">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--弹框-补卡次数-->
    <el-dialog :visible.sync="disbandBox" width="30%" :show-close="false">
      <template slot="title">
        <CustomDialogHeader
          title="请输入补卡次数"
          @close="disbandBox = false"
        />
      </template>
      <el-input
        type="text"
        placeholder="请输入补卡次数"
        maxlength="500"
        v-model="clockSupplyCenterText"
        @input="handleClockSupplyCenterTextInput"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="disbandBox = false">取 消</el-button>
        <el-button type="primary" @click="confirmModal">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="isDelSignInfoPop"
      width="30%"
      :show-close="false"
      :before-close="handleClose"
    >
      <template slot="title">
        <CustomDialogHeader title="提示" @close="isDelSignInfoPop = false" />
      </template>
      <span
        >原有填表项内容已修改，会删除所有已报名人员信息，请提醒接龙人员重新参与报名</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDelSignInfoPop = false">取 消</el-button>
        <el-button type="primary" @click="confirmChangeForm">确 定</el-button>
      </span>
    </el-dialog>

    <!--      图片剪裁-->
    <el-dialog
      :visible.sync="dialogVisibleCro"
      width="600px"
      append-to-body
      @close="closeCropper"
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader title="图片剪裁" @close="closeCropper" />
      </template>
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCropper">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
    <!--  演示  -->
    <el-dialog
      :title="contentList.title"
      :visible.sync="demonVisible"
      width="450px"
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader title="演示" @close="demonVisible = false" />
      </template>
      <div style="max-height: 700px; overflow-y: auto">
        <img class="usePopImg" :src="contentList.imgurl" alt="" />
      </div>
    </el-dialog>

    <!-- 封面设置 Drawer -->
    <el-drawer
      title="封面设置"
      :visible.sync="coverSettingDrawer"
      direction="rtl"
      size="400px"
      :before-close="closeCoverSetting"
      :destroy-on-close="false"
    >
      <div class="cover-setting-container" style="padding: 0 20px">
        <!-- 系统封面区域 -->
        <div class="cover-section" style="margin-bottom: 0">
          <div class="cover-preview" v-if="customCoverDialog.isVideo == 2">
            <div class="section-header">
              <h4>选择系统封面</h4>
              <el-switch
                v-model="customCoverDialog.isCoverEnabled"
                :active-value="1"
                :inactive-value="2"
                @change="toggleCoverEnabled"
              >
              </el-switch>
            </div>
            <div
              v-if="customCoverDialog.isCoverEnabled === 1"
              class="cover-placeholder"
            >
              <img
                v-if="
                  customCoverDialog.isVideo === 2 &&
                  customCoverDialog.activityModeUrl
                "
                :src="customCoverDialog.activityModeUrl"
                alt="封面图"
                style="width: 100%; object-fit: cover"
              />
              <!-- <div class="placeholder-text">封面图</div> -->
            </div>
            <div
              v-if="
                customCoverDialog.isCoverEnabled === 1 &&
                customCoverDialog.isVideo == 2
              "
              class="cover-btn-center"
            >
              <el-button
                type="primary"
                @click="selectSystemCover"
                style="margin-top: 10px"
              >
                更换封面
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="customCoverDialog.isVideo === 1" class="video-container">
          <video controls width="340" height="240">
            <source :src="customCoverDialog.playUrl" type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
          <div class="delete-btn" @click="deleteVideo">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <!-- 自定义封面区域 -->
        <div class="cover-section">
          <div class="cover-tips" v-if="customCoverDialog.isVideo == 2">
            *尺寸比例: 宽5:高4,建议宽度1500px,高度1200px。
          </div>
          <div class="custom-covers" v-if="customCoverDialog.isVideo == 2">
            <!-- {{customCoverDialog.subCoverImages.length}} -->
            <div
              v-for="(image, index) in customCoverDialog.subCoverImages"
              :key="index"
              class="custom-cover-item"
              @click="selectCustomCover(image)"
            >
              <img :src="image" alt="" class="cover-thumbnail" />
              <div class="delete-btn" @click.stop="deleteCoverImage(index)">
                <i class="el-icon-close"></i>
              </div>
              <div
                class="select-overlay"
                v-if="customCoverDialog.activityModeUrl === image"
              >
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
          <div class="upload-tips" v-if="customCoverDialog.isVideo == 2">
            *最多可上传{{ customCoverDialog.maxCoverImages }}张自定义封面图片
          </div>
          <div class="upload-tips" v-if="customCoverDialog.isVideo == 1">
            该封面已包含视频，不可再上传图片轮播。如需修改为图片轮播，请删除视频。
          </div>
          <div class="upload-buttons" v-if="customCoverDialog.isVideo == 2">
            <el-button
              type="primary"
              icon="el-icon-plus"
              :disabled="
                customCoverDialog.subCoverImages.length >=
                customCoverDialog.maxCoverImages
              "
            >
              <input
                type="file"
                accept="image/*"
                multiple
                @change="handleCoverImageUpload"
                :disabled="
                  customCoverDialog.subCoverImages.length >=
                  customCoverDialog.maxCoverImages
                "
                style="
                  position: absolute;
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                "
              />
              上传自定义图片
            </el-button>

            <el-button type="primary" icon="el-icon-video-camera">
              <input
                type="file"
                accept=".mp4"
                @change="handleCoverVideoUpload"
                style="
                  position: absolute;
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                "
              />
              上传自定义视频
            </el-button>
          </div>
        </div>
        <!-- 保存按钮 -->
        <div
          style="height: 90px; position: absolute; bottom: 0; left: 0; right: 0"
        >
          <div class="save-section">
            <el-button
              type="primary"
              @click="saveCoverSetting"
              style="width: 100%"
            >
              保存
            </el-button>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :visible.sync="catchBatchSetNumShowBox"
      width="30%"
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader
          title="批量添加选项"
          @close="catchBatchSetNumShowBox = false"
        />
      </template>
      <el-input
        type="number"
        placeholder="请输入数量"
        maxlength="10"
        v-model="batch_set_num"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="catchBatchSetNumShowBox = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchSetNum">确 定</el-button>
      </span>
    </el-dialog>
        <el-drawer
      :visible.sync="signDataScreenDrawer"
      :direction="direction"
      size="500px"
      :withHeader="false"
      :before-close="nameListClose"
    >
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>签到数据大屏</span>
          <img
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            class="close-btn"
            @click="signDataScreenDrawerClose"
          />
        </div>
        <div class="underline"></div>
        
        <!-- 活动标题 -->
        <div class="act-title">{{ activityDetail.name }}</div>
        
        <!-- 数据大屏地址容器 -->
        <div class="screen-container">
          <div class="container-main" style="line-height: 25px; word-break: break-all;">
            {{ DataScreenUrl }}
          </div>
          <div class="container-main" style="margin-top: 15px;">
            访问密码: <span style="color:#4A73F8; font-weight: bold; font-size:24px;">{{ key }}</span>
          </div>
          <div class="d-flex" style="margin-top: 15px;">
            <div class="tip">请在电脑上打开</div>
            <el-button type="primary" size="small" @click="copyUrl">复制地址</el-button>
          </div>
        </div>

        <!-- 当前使用浏览器信息 -->
        <template v-if="browserList.length">
          <div class="browser-info" v-for="(item, index) in browserList" :key="index">
            <div class="info-title">当前使用</div>
            <div class="info-content">{{ item.browserName }}</div>
            <div class="info-content">IP：{{ item.ip }}</div>
            <el-button type="text" class="offline-btn" @click="offline(index)">下线</el-button>
          </div>
        </template>

        <!-- 效果图 -->
        <div class="effect-title">签到数据大屏效果</div>
        <div class="effect-img">
          <img src="https://ossfastmake.mustke.com/12jielong/lsyJL/largeDataSrcen.png" style="width: 100%; display: block;" />
        </div>

      </div>
    </el-drawer>
  </Layout>
</template>
<style lang="scss" scoped>
/* 自定义对话框头部样式 */
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 10px 0;

  .title-text {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    position: relative;
  }

  .title-underline {
    position: absolute;
    bottom: -5px;
    left: -20px;  
    right: -20px;
    height: 1px;
    background: #e7e7e7;
    border-radius: 1px;
  }
}

.select-count {
  color: var(--el-text-color-primary);
  text-align: center;
  max-height: 200px;
  overflow-y: auto;

  .select-count-item {
    user-select: none;
    padding: 5px;
    padding-left: 0;
    color: #999;

    &:hover {
      color: #409eff;
      opacity: 0.8;
      cursor: pointer;
      background-color: #f5f5f5;
    }
  }

  .active {
    color: #409eff;
    cursor: pointer;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 8px; /* 垂直滚动条宽度 */
    height: 8px; /* 水平滚动条高度 */
  }

  /* 滚动条轨道（背景） */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  /* 鼠标悬停时滑块效果 */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

/* 选项行：名称 + 数量 同行显示 */
.opt-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.opt-row .opt-name {
  flex: 1 1 auto;
}
.opt-row .opt-num {
  flex: 0 0 100px;
}

/* 多选/单选选项：按比例分配宽度 */
.selectBox-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.selectBox-item .opt-name-input {
  width: 70% !important;
}
.selectBox-item .opt-num-input {
  width: 30% !important;
}

.w-50 {
  width: 50px;
  margin-left: auto;
}

.b-marT-10 {
  margin-top: 10px;
}

.b-marT-20 {
  margin-top: 20px;
}

/* flex布局 */
.flex-depart-left {
  display: flex;
  align-items: center;
}

.flex-depart-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-depart-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-depart-center-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-depart-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.flex-depart-left-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.flex-depart-center-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flex-depart-left-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

/*大图排序*/
.flex-depart-column-top-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.add-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #1877ff;
  margin-left: 8px;
  cursor: pointer;
  .add-tools-item {
    display: flex;
    align-items: center;
  }
  .add-tools-item-text {
    margin-left: 5px;
  }
}
.name-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .flex-left {
    display: flex;
    align-items: center;
  }
  .flex-right {
    display: flex;
    align-items: center;
  }
  .flex-dropdown {
    margin-left: 10px;
  }
}

.yanshiBtn {
  width: 60px;
  height: 15px;
}

.clockNameNumberSwitchDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //margin-top: 10px;
}

.name-row-num {
  position: relative;
}

.nr-pos-abs {
  position: absolute;
  right: 20px;
  top: 0;
  width: 200px;
}

.outBox {
  width: 680px;
  margin: 0 auto;
  background-color: #fbfbfb;
}

.bigTitle {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #367ce0;
  /*font-weight: bold;*/
  background-color: #fbfbfb;
}

.block-title {
  font-size: 14px;
  font-weight: Bold;
  text-align: left;
  color: #191919;
}

.blockBox {
  padding: 15px;
  background-color: white;
  margin-bottom: 10px;
  position: relative;
}

.cannot-edit {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  height: 100%;
  width: 100%;
}

.handle-box {
  display: inline-block;
}

.handle-box .h-item {
  margin-right: 30px;
  cursor: pointer;
  display: inline-block;
  float: left;
  margin-top: 8px;
}

.handle-box .h-item img {
  width: 20px;
  height: 20px;
  margin-right: 1px;
}

.handle-box .h-item span {
  font-size: 14px;
  color: #767d98;
  cursor: pointer;

  &:hover {
    color: #1877ff; /* 鼠标悬浮时的字体颜色 */
  }
}

.rangeTimes {
  margin-bottom: 10px;
}

.addBtnStyle {
  width: 200px;
  height: 40px;
  background: #ffffff;
  border: 1px dashed #4a73f7;
  border-radius: 23px;
  font-size: 14px;
  color: #1877ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: bold;

  i {
    margin-right: 10px;
  }
}

.f-block {
  background: #fafafa;
  border-radius: 2px;
  box-sizing: border-box;
  /*padding: 10px;*/
  margin-top: 10px;
  overflow: hidden;
}

.f-block:last-child {
  /*margin-bottom: 0;*/
}

.tl-item .f-ipt {
  width: 508px;
}

.f-handle img {
  width: 20px;
  height: 20px;
  margin-left: 5px;
  cursor: pointer;
}

.checkedState .el-checkbox {
  margin-bottom: 0;
}

.ch-copy {
  margin-left: 50px;
  font-size: 13px;
  color: #409eff;
  align-items: center;
  cursor: pointer;

  i {
    /*width: 17px;*/
    /*height: 17px;*/
    margin-right: 4px;
  }
}

.selectBox-item {
  padding-left: 20px;
}

.selectBox-item .el-input {
  width: 500px;
  margin-right: 10px;
}

.selectBox-item i {
  font-size: 18px;
}

.addOptStyle {
  color: #1877ff;
  cursor: pointer;
  text-align: center;
}

.settingBox {
  padding: 10px 15px;
  background-color: white;
  position: relative;
  border-bottom: 1px solid #f2f2f2;
}

.sTitle {
  font-size: 14px;
  font-weight: Bold;
  text-align: left;
  color: #191919;
  display: inline-flex;
  align-items: center;

  label {
    font-size: 12px;
    color: grey;
    font-weight: normal;
  }

  b {
    width: 4px;
    height: 14px;
    background: #1877ff;
    border-radius: 2px;
    margin-right: 5px;
  }
}

.settingBox .el-date-editor .el-range-separator {
  width: 15%;
}

::v-deep .el-range-separator {
  width: 12%;
}

.setText {
  color: #1877ff;
  cursor: pointer;
  text-decoration: underline;
}

.unLine {
  text-decoration: none !important;
}

.settingBox .el-radio {
  margin-bottom: 0;
}

.set-out-box .b-marT-10 {
  margin-top: 0;
}

.block-for-box {
  -webkit-appearance: none;
  background-color: #fcfcfc;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
}

.big-img img {
  max-width: 600px;
  height: auto;
}

.b-handle img {
  width: 20px;
  height: 20px;
  margin: 5px;
  cursor: pointer;
}

.addSmallBtn {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  color: #1877ff;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}

.updateFileBtn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.el-dropdown-menu__item {
  position: relative;
}

.rangeTimes i {
  margin-left: 5px;
  font-size: 25px;
  cursor: pointer;
  color: #f56c6c;
}

.add-rangeTimes {
  color: #1877ff;
  cursor: pointer;
}

.map {
  width: 100%;
  height: 300px;
}

.deadline {
  width: 80px;
  margin-left: 5px;
}

.smallImgbox {
  width: 150px;
  height: 150px;
  background-color: #f7f7f7;
  margin: 5px;
  position: relative;
}

.handle2 {
  width: 150px;
  height: 150px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;

  img {
    width: 20px;
    height: auto;
    cursor: pointer;
    margin-top: 70px;
    margin-left: 33px;
  }
}

.seeBigImgHover:hover {
  .handle2 {
    display: block;
  }
}

.imgBg {
  width: 150px;
  height: 150px;
  /*background: url("https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg") no-repeat center;*/
  background-size: cover;
  border-radius: 5px;
}

.upl-smallImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  background-color: #f7f7f7;
  color: #1877ff;
  cursor: pointer;
  margin: 5px;
  position: relative;
  border-radius: 5px;

  i {
    font-size: 26px;
  }
}

.upl-smallImg2 {
  width: 100%;
  height: 200px;
  margin: 0;
}

.filesStyle {
  height: 45px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 15px;

  .tubiao {
    margin-right: 2px;
  }

  .del {
    margin-left: 10px;
    position: relative;
    top: 1px;
    cursor: pointer;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}

.previewImgBox {
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner-p-img {
    height: 600px;
    width: auto;
  }

  .closePImg {
    font-size: 40px;
    cursor: pointer;
    position: fixed;
    top: 40px;
    right: 40px;
    color: white;
  }
}

.drawerOutBox {
  padding: 0 20px;
  height: 100%;
  position: relative;
}

.drawBottomBtn {
  width: 100%;
  height: 70px;
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  padding-right: 20px;
}

.af-title {
  font-weight: bold;
  margin-top: 10px;
}

.ty-b-item {
  position: relative;
  width: 195px;
  height: 80px;
  border: 1px solid #b2c4fb;
  background-color: #f4f7fe;
  border-radius: 5px;
  box-sizing: border-box;
  padding-top: 18px;
  padding-left: 10px;
  cursor: pointer;
}

.ty-b-item div {
  font-weight: bold;
  color: #1877ff;
  margin-bottom: 10px;
}

.addFBtn {
  color: #1877ff;
  font-size: 22px;
  position: absolute;
  right: 10px;
  top: 18px;
}

.cy-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}

.cy-item {
  width: 128px;
  height: 45px;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f7fe;
  border-radius: 5px;
  margin-bottom: 5px;
  cursor: pointer;

  .addFBtn2 {
    color: #1877ff;
    font-size: 22px;
  }
}

.seniorStyle {
  background-color: #ecf4ff !important;
  cursor: pointer;
}

.cus-dates {
  margin-bottom: 0 !important;
  margin-left: 5px;
}

.nl-title {
  font-weight: bold;
  margin-top: 10px;

  span {
    font-size: 12px;
    font-weight: normal;
    color: grey;
  }
}

.daoru {
  color: #1877ff;
  cursor: pointer;
  position: relative;
  text-decoration: underline;
}

.qingkong {
  cursor: pointer;
  color: red;
}

.ycn {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: #fbfbfb;
  border: 1px solid #d4d4d4;

  .n-name {
    width: 50%;
    word-break: break-word;
  }

  .n-handle {
    span {
      color: #1877ff;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.duiHao {
  text-align: center;
  margin-top: 10px;

  img {
    height: 80px;
    width: 80px;
  }
}

.updateFileBtn-out {
  position: relative;
}

.copy-image-out {
  position: relative;
}

.del-copy-img {
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.copy-image {
  width: 100%;
  height: auto;
}

.posi-bottom-btn-box {
  position: fixed;
  left: 130px;
  right: 0;
  bottom: 70px;
  height: 74px;
  z-index: 999;
  //background: #fff;
}

.saveDatabox {
  width: 300px;
  height: 45px;
  background: #1877ff;
  border-radius: 25px;
  font-size: 16px;
  font-weight: Bold;
  color: #ffffff;
  cursor: pointer;
  border: 2px solid #1877ff;
}

.yl {
  width: 160px;
  height: 45px;
  background: #fff;
  border-radius: 25px;
  font-size: 16px;
  font-weight: Bold;
  color: #1877ff;
  border: 1px solid #1877ff;
  cursor: pointer;
  margin-right: 10px;
}

.s-name-item {
  width: 105px;
  height: 45px;
  background: #f2f2f2;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  line-height: 45px;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.set-out-box {
  position: relative;
  height: auto;
}

.centerTitle input {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #333333;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  /*transition: border-color .2s cubic-bezier(.645,.045,.355,1);*/
  width: 100%;
}

.centerTitle input:focus {
  border-color: #409eff;
}

.centerTitle input::-webkit-input-placeholder {
  /* placeholder颜色 */
  color: #c4c4cc;
  /* placeholder字体大小 */
  font-size: 14px;
}

.centerTitle {
}

.addnameBtns button {
  width: 45%;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0;
}

.hoverColor1:hover {
  background-color: #ecf4ff;
}

.hoverColor1:hover .del {
  color: red;
}

.drawer-nav-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;

  span {
    font-size: 18px;
    color: black;
    font-weight: bold;
  }

  i {
    cursor: pointer;
    font-size: 18px;
  }
}

.underline {
  width: 100%;
  height: 0.5px;
  background: #e7e7e7;
}

.close-btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.danwei {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;

  /*display: inline-block;*/
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px 0 0;
  width: 440px;
  overflow: hidden;

  input {
    color: #606266;
    width: 420px;
    height: 38px;
    border: 0;
    outline: none;
    box-sizing: border-box;
    padding-left: 10px;
    /*background-color: red;*/
  }
}

.set-out-box .settingBox:hover {
  background-color: #ecf4ff;
}

.blockBox {
}

.settingBox {
}

.danwei:hover {
  border: 1px solid #409eff !important;
}

.el-input {
}

.bf-item {
}

.bf-item {
}

.zsy {
}

.nozsy {
}

.gl-btnStyle {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1877ff;
  background-color: rgba(247, 247, 247, 1);
  cursor: pointer;
}

.gljl-block {
  height: 45px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 15px;
}

.gljl-block:hover {
  background-color: #ecf4ff;
}

.gljl-block .del:hover {
  color: red;
}

.cell-box {
  margin-left: 10px;
}

.cell-name {
  margin-bottom: 5px;
  font-weight: bold;
}

.cell-addTime {
  font-size: 12px;
}

.bg-gray {
  background-color: #f5f5f5;
}

.pad-10 {
  padding: 10px;
}

.call-out {
  height: calc(100% - 190px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 增加 iOS 滚动支持 */
  padding-bottom: 20px; /* 增加底部填充,确保有足够空间触发滚动 */
}

.flex-depart-leftStart {
  display: flex;
  justify-content: flex-start;
}

.inner-main-box {
  width: 97%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 10px 10px;
}

.left-ttype {
  width: 3%;
  background: #c2dbff;
  font-size: 14px;
  color: #466aa9;
  writing-mode: vertical-rl;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.propertySet-box {
  .bx-item {
    width: 49%;
    background-color: white;
    height: 60px;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bx-item .el-checkbox {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row-reverse;
    margin-bottom: 0;
  }

  .flex-depart-top2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .x {
    color: red;
  }

  .title-block {
    background-color: white;
    padding: 10px;
    border-top: 0.5px solid #e5e5e5;
  }

  .tb-left {
    color: #555555;
    font-size: 15px;
    display: flex;
    align-items: center;
  }

  .zz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    border-bottom: 1px solid #eee;
    padding-left: 10px;
    padding-right: 10px;

    text {
      color: #555555;
      font-size: 15px;
    }
  }

  .zz-picker {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    width: 214px;
    height: 44px;
    background: #f4f4f4;
    border-radius: 5px;

    image {
      width: 20px;
      height: 20px;
    }
  }

  .no-repeat {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    height: 80px;
  }

  .wb-setting-block {
    background-color: white;
    margin-top: 10px;
  }

  .no-title {
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    color: #555555;
  }

  .no-tips {
    font-size: 13px;
    text-align: left;
    color: #7c838e;
  }

  .bx-block {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tips-block {
    margin-top: 10px;
    background-color: white;
    padding-bottom: 10px;
  }

  .tip-title {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;

    text {
      color: #555555;
      font-size: 15px;
    }
  }

  .tip-t-area {
    margin-top: 10px;
  }

  .up-img-fun {
    margin-top: 7px;
    width: 100px;
    height: 100px;
    background: #f4f4f4;
    border-radius: 5px;
  }

  .footerBtn {
    height: 63px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: calc(-18.5px + env(safe-area-inset-bottom));

    .btn {
      width: 340px;
      height: 40px;
      background-color: #1877ff;
      border-radius: 25px;
      text-align: center;
      line-height: 40px;
      color: white;
      font-size: 16px;
    }
  }

  .files-num {
    background-color: white;
    padding: 15px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 10px;

    text {
      color: #555555;
      font-size: 15px;
    }
  }

  .radio-block {
    width: 94%;
    margin: 10px auto;
    background-color: white;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .rb-item {
    padding-top: 12.5px;
    padding-bottom: 12.5px;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid #e5e5e5;
  }

  .rb-left {
    width: 75%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    view {
      width: 14px;
      height: 14px;
      background: #e2e2e2;
      border: 0.5px solid #cbcbcb;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #8f8f8f;
      font-size: 12px;
    }

    input {
      width: 88%;
      margin-left: 10px;
    }
  }

  .rb-right {
    width: 25%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }

  // .radio-add {
  //   margin: 0 auto;
  //   padding: 0 10px;
  //   box-sizing: border-box;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;

  //   span {
  //     color: #477aff;
  //     font-size: 14px;
  //     cursor: pointer;
  //   }
  // }
  .radio-add {
    width: calc(100% - 20px);
    margin: 10px auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    background-color: white;
    border: 1px solid #477aff;
    border-radius: 6px;
    overflow: hidden;
    span {
      color: #477aff;
      font-size: 14px;
      padding: 10px;
      background-color: white;
      flex: 1;
      text-align: center;
      position: relative;
      border: none;
      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background-color: #477aff;
      }
    }
  }

  .area-block {
    margin-top: 10px;
    background-color: white;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .tt-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    border-bottom: 1px solid #e7e7e7;
    font-size: 14px;
    width: 96%;
    margin: 0 auto;

    img {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }

  .tt-title {
    font-size: 14px;
    font-weight: bold;
    color: #555555;
    line-height: 45px;
    border-bottom: 1px solid #e7e7e7;
  }

  .position-block {
    margin-top: 5px;
    background-color: white;
    box-sizing: border-box;
    padding: 7.5px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .position-title {
    display: flex;
    color: #555555;
    font-size: 7.5px;
    align-items: center;

    img {
      width: 7.5px;
      height: 7.5px;
      flex-shrink: 0;
      margin-left: 5px;
    }
  }

  .popComm {
    background-color: white;
    border-radius: 5px;
    width: 160px;
    padding-bottom: 7.5px;
  }

  .close-xsxq {
    position: absolute;
    right: 5px;
    top: 7.5px;

    img {
      height: 10px;
      width: 10px;
    }
  }

  .tishi-title {
    line-height: 25px;
    border-bottom: 0.5px solid #eee;
    font-weight: 600;
    font-size: 8px;
    text-align: center;
    color: #333;
  }

  .center-content {
    width: 92%;
    margin: 5px auto;

    textarea {
      width: 100%;
      height: 125px;
      background: #f4f4f4;
      border: 0.5px solid #dcdde0;
      border-radius: 2px;
      box-sizing: border-box;
      padding: 5px;
    }
  }

  .popComm .btn1 {
    width: 105px;
    height: 20px;
    background: #4a73f8;
    border-radius: 11.25px;
    color: white;
    text-align: center;
    line-height: 20px;
    margin: 0 auto;
  }

  .reject-con {
    width: 160px;
    background: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    position: relative;

    .studybtn {
      height: 23.25px;
      border: 0.25px solid #e4e4e4;
      border-radius: 0px 0px 4px 4px;
      line-height: 23.25px;
      text-align: center;
      font-size: 7.5px;
      color: #4a73f8;
    }

    .top-title {
      height: 22.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 0.5px solid #e7e7e7;

      text {
        font-size: 9px;
        font-weight: bold;
        color: #2b2f36;
      }

      .re-close {
        position: absolute;
        right: 5px;
        top: 7.25px;
      }
    }
  }

  .invite-txt1 {
    height: 42.5px;
    display: flex;
    justify-content: center;
    align-items: center;

    view {
      font-size: 7px;
      text-align: center;
      color: #555555;
    }

    input {
      width: 140px;
      height: 22px;
      background: #f4f4f4;
      border: 0.5px solid #dcdde0;
      border-radius: 2px;
      box-sizing: border-box;
      padding-left: 5px;
      line-height: 22px;
    }
  }

  .copyTA-Style {
    padding: 4px;
    color: grey;
    font-size: 7.5px;
  }

  .copyTA-Style-nodata {
    padding: 4px;
    color: #adadad;
    font-size: 7.5px;
  }
}

.sxsz {
  font-size: 13px;
  color: #1877ff;
  cursor: pointer;
}

.drawerOutBox-nopadding {
  padding: 0;
}

.gray-bg {
  background-color: #f5f5f5;
}

.drawerOutBox-nopadding .drawer-nav-top {
  background-color: white;
}

.padding-0-20 {
  padding: 0 10px;
}

.up-img-fun1 {
  width: 50px;
  height: auto;
  margin-top: 3.5px;
}

.up-box1 {
  margin-top: 3.5px;
  width: 50px;
  height: 50px;
  background: #f4f4f4;
  border-radius: 2.5px;
  overflow: hidden;
  position: relative;
}

/*    分组名单*/
.subsetBox {
  box-sizing: border-box;
  padding: 15px 10px;
  padding-bottom: 0;
}

.bd-popTitle {
  color: black;
  text-align: center;
}

.subset-item {
  padding: 15px 0px;
  border-bottom: 1px solid #eee;
  width: 94%;
  margin: 0 auto;
}

.sub-left img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  cursor: pointer;
}

.sub-left .cl-name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 220px;
}

.sub-edit {
  width: 17.5px;
  height: 17.5px;
  cursor: pointer;
}

.add-sub {
  color: #1877ff;
  border-bottom: 0;
  cursor: pointer;
}

.gzh-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1f2233;

  .el-icon-close {
    font-size: 16px;
    cursor: pointer;
    color: #626974;
  }
}

.gzh-dialog-content {
  text-align: center;
  padding: 10px 0 20px;

  p {
    margin: 12px 0 18px;
    color: #626974;
    font-size: 14px;
  }
}

.gzh-dialog-qrcode {
  width: 220px;
  height: 220px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.gzh-download-btn {
  width: 200px;
  margin: 0 auto;
  display: inline-block;
}

.setFz-main {
  margin-top: 15px;
}

.ssfz {
  border-radius: 4px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.import-box {
  font-size: 14px;
  margin-top: 12px;

  img {
    height: 15px;
    width: 15px;
  }
}

.blueTxt {
  color: #1877ff;
  cursor: pointer;
}

.import-box .empty {
  margin-left: 10px;
  cursor: pointer;
}

.yl16 {
  text-align: center;
  font-size: 12px;
  color: grey;
  margin-top: 15px;
  margin-bottom: 10px;
}

.fz-select-box {
  border-radius: 4px;
  border: 1px solid #dadbde !important;
  margin: 0px auto 10px;
  box-sizing: border-box;
  padding: 10px;
  background-color: white;
  width: 96%;
}

.jlName {
  margin: 0 auto 0 auto;
  border-radius: 5px;
  background-color: #fff;

  .listName {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;

    .spanDiv {
      height: 50px;
      width: 10%;
      margin: 4px;
      background-color: #f2f2f2;
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      color: #626974;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .spanDivEmpty {
      height: 0px;
      width: 10%;
      margin: 4px;
    }
  }

  .tips {
    font-size: 14px;
    text-align: center;
    color: #333;
    padding: 0 15px;
  }
}

.newSpanWidth .spanDiv {
  width: 16% !important;
}

.newSpanWidth .spanDivEmpty {
  height: 0px;
  width: 16% !important;
  margin: 4px;
}

.emptySpan {
  height: 0px;
  flex: 0 0 23%;
  margin-bottom: 6px;
  background-color: #f2f2f2;
  border-radius: 4px;
  margin-right: 2.5%;
  text-align: center;
  font-size: 12px;
  color: #626974;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.mar-bot-check-0 .el-checkbox {
  margin-bottom: 0;
}

.cannotEditStyle {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #ff0000;
  font-size: 15px;
}

::v-deep .el-input__inner {
  color: #333;
}

::v-deep .el-textarea__inner {
  color: #333;
  padding: 15px;
}

.jl-box {
  background-color: #ebeef2;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-bottom: 10px;
  margin-top: 16px;

  .jl-title {
    height: 57px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 17px;
    font-weight: bold;
    width: 94%;
    margin: 0 auto;
    color: #323b5a;
  }

  .jlName {
    /*width: 690rpx;*/
    margin: 0 auto 0 auto;
    border-radius: 5px;
    background-color: #fff;
    padding: 12px 8px 12px 8px;

    .listName {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      padding: 10px 0;

      .span {
        height: 47px;
        flex: 0 0 23%;
        margin-bottom: 6px;
        background-color: #f2f2f2;
        border-radius: 4px;
        margin-right: calc(10% / 4);
        text-align: center;
        // line-height: 95rpx;
        font-size: 12px;
        color: #626974;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .span:nth-child(4n) {
        margin-right: 0;
      }
    }

    .tips {
      font-size: 14px;
      text-align: center;
      color: #333;
      padding: 0 15px;
    }
  }
}

.kf {
  height: 250px;
  width: 96px;
  /*background-color: red;*/
  position: fixed;
  right: 0px;
  bottom: 100px;
  z-index: 99;
}

.kf-tx {
  width: 93px;
  height: auto;
  position: absolute;
  right: 0;
  top: 75px;
  cursor: pointer;
}

.kf-qr {
  width: 200px;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
}

.kf-close {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 20px;
  top: 16px;
  cursor: pointer;
}

.szfz {
  color: #1877ff;
  font-size: 14px;
  cursor: pointer;
}

.clockNum {
  font-size: 14px;
  cursor: pointer;
}

.bjmd {
  text-align: center;
  margin-top: 15px;

  span {
    color: #1877ff;
    cursor: pointer;
  }
}

.bjmdBtn {
  padding: 6px 10px;
  color: #1877ff;
  /*border: 1px solid #1877FF;*/
  border-radius: 4px;
  /*position: absolute;*/
  /*right: 10px;*/
  /*top: 15px;*/
  cursor: pointer;
}

// 图片裁剪样式
.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}

.fm-block {
  //margin-bottom: 10px;
}

.fm-select span {
  color: #191919;
  font-weight: bold;
}

.fm-select img {
  width: 60px;
  height: 15px;
}

.fm-b-right {
  width: 160px;
  height: 30px;
  background-color: red;
}

.fm-b-right .ms {
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
  color: #2b2f36;
  cursor: pointer;
  font-size: 13px;
}

.ms-active {
  background-color: #1877ff !important;
  color: white !important;
}

.fm-picture {
  width: 250px;
  height: 160px;
  background: rgba(74, 115, 248, 0.08);
  border: 0.5px solid rgba(74, 115, 248, 0.4);
  border-radius: 2.5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fm-picture span {
  color: #4a73f8;
}

.fm-picture label {
  font-size: 13px;
}

.fm-flex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-left: 104px;
  box-sizing: border-box;
}

.fm-flex img {
  width: 250px;
  height: auto;
}

.fm-btns div {
  display: flex;
  width: 140px;
  height: 35px;
  text-align: center;
  margin-left: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
}

.fm-btns span {
  margin-left: 35px;
}

.fm-btns .el-button {
  margin-left: 20px;
}

.fm-btns .el-dropdown {
  margin-left: 10px;
}

.xt-btn {
  background-color: white;
  color: #1877ff;
  border: 1px dashed #1877ff;
}

.zdy-btn {
  background-color: white;
  color: #1877ff;
  border: 1px dashed #1877ff;
}

.edit-share {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .sm-1 {
    height: 80px;
    width: 100px;
  }

  span {
    margin-left: 10px;
    color: #1877ff !important;
    cursor: pointer;
    position: relative;
  }
}

.usePopImg {
  width: 400px;
  height: auto;
}

.yanshiBtn {
  cursor: pointer;
}

.model-title1 {
  margin-bottom: 5px;
  margin-top: 15px;
}

.new-block-style1 {
  font-size: 14px;
  text-align: left;
  color: #191919;
  padding-left: 29px;
  font-weight: 500;
}

.new-block-style2 {
  text-align: left;
  color: #191919;
  padding-left: 29px;
  font-weight: 500;
}

/* 封面设置样式 */
.cover-setting-container {
  height: 100%;
  .cover-section {
    margin-bottom: 100px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
      }
    }

    .cover-preview {
      border: 2px dashed #d9d9d9;
      padding: 20px;

      .cover-placeholder {
        width: 100%;
        //height: 358px;

        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fafafa;
        margin-top: 15px;
        margin-bottom: 10px;

        .placeholder-text {
          color: #999;
          font-size: 14px;
        }
      }

      .cover-btn-center {
        display: flex;
        justify-content: center;
      }
    }

    .cover-tips {
      font-size: 12px;
      color: #343a40;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .custom-covers {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 15px;

      .custom-cover-item {
        position: relative;
        width: 175px;
        height: calc(175px / 1.5);
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.2s ease;

        &:hover {
          transform: scale(1.05);
        }

        .cover-thumbnail {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .delete-btn {
          position: absolute;
          top: 5px;
          right: 5px;
          width: 20px;
          height: 20px;
          background-color: rgba(255, 0, 0, 0.8);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
          font-size: 12px;
        }

        .select-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(24, 119, 255, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
        }
      }
    }

    .upload-tips {
      font-size: 12px;
      color: #343a40;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .upload-buttons {
      display: flex;
      gap: 10px;

      .el-button {
        position: relative;
        overflow: hidden;
      }
    }
  }

  .save-section {
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    background-color: white;
    padding: 15px 0;
    border-top: 1px solid #e8e8e8;
  }

  .video-container {
    position: relative;
    display: inline-block;

    .delete-btn {
      position: absolute;
      top: 34px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-color: rgba(255, 0, 0, 0.8);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: white;
      font-size: 12px;
    }
  }
}

.fm-flex .fm-pics-block {
  width: 400px;
  height: 300px;
  margin-top: 10px;
}

.pic-out-box {
  width: 400px;
  height: 300px;
  text-align: center;
}

.settingBox .el-select {
  width: 440px;
}

.settingBox .el-input {
  width: 440px !important;
}

.mar-top10 {
  margin-top: 10px !important;
}

body .el-dialog__body {
  border-top: 1px solid #f2f2f2 !important;
}

.name-title-left {
  display: flex;
}
.name-title-left span {
  color: #191919;
  font-weight: bold;
}

.map-btn {
  width: 440px;
  text-align: left;
}
.no-padding-top {
  ::v-deep .el-dialog__header {
    padding: 5px 20px 10px;
  }
}

/* 签到数据大屏样式 */
.act-title {
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #323b5a;
  padding: 20px;
  box-sizing: border-box;
}

.screen-container {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 8px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.container-main {
  font-size: 14px;
  text-align: left;
  color: #323b5a;
  line-height: 1.5;
}

.d-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tip {
    font-size: 14px;
    color: #f73b42;
  }
}

.browser-info {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 8px;
  margin: 20px auto;
  padding: 20px;
  position: relative;
  box-sizing: border-box;

  .info-title {
    font-size: 16px;
    font-weight: bold;
    color: #010100;
    margin-bottom: 10px;
  }

  .info-content {
    font-size: 14px;
    color: #474747;
    line-height: 1.8;
  }

  .offline-btn {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #5255f7;
    font-weight: bold;
  }
}

.effect-title {
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #323b5a;
  padding: 20px 0;
}

.effect-img {
  width: 100%;
  margin: 0 auto;
}
</style>
